const messages = {
  pt: {
    translations: {
      seller_queue: {
        modal: {
          sale_outcome: {
            completed: 'Venda Concluída',
            not_completed: 'Venda Não Concluída',
          },
          reasons: {
            label: 'Motivo da Não Venda:',
            loading: 'Carregando motivos...',
            load_error: 'Não foi possível carregar os motivos. Tente novamente.',
            retry: 'Tentar novamente',
            placeholder: 'Selecione um motivo...',
          },
          buttons: {
            cancel: 'Cancelar',
            next: 'Próximo →',
          },
        },
        "seller_queue":"Fila Vendedor",
        "queue_status":"Status da Fila",
        "queue_position":"Posição na Fila",
        "queue_duration":"Duração",
        "queue_seller_status":"Status do Vendedor",
        "queue_in_service":"Em Atendimento",
        "queue_not_in_service":"Não em Atendimento",
        "queue_no_entry":"Você não está na fila",
        "queue_loading":"Carregando...",
        "queue_error":"Erro: {{error}}",
        "queue_view_details":"Visualizar Detalhes",
      },
      gridHotelFeedback: {
        dashboard: 'Dashboard',
        service_grid: 'Grades',
        service_grid_single: 'Grade de Pesquisa e Satisfação',
        listed_grids:
          'Aqui estão listadas as grades de pesquisa e satisfação juntamente com suas respectivas ações',
        create_service_grid: 'Criar Grade',
        title: 'Título',
        status: 'Status',
        grid_deleted: 'Grade Excluída!',
        grid_deleted_message: 'A Grade de Pesquisa e Satisfação foi excluída com sucesso.',
        error: 'Erro',
        error_delete_message: 'Ocorreu um erro ao excluir a Grade de Pesquisa e Satisfação.',
        service_grid_name: 'Título',
        service_grid_name_placeholder: 'Ex.: Pesquisa de Satisfação',
        fill_information_create:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
        missing_fields: 'Campos obrigatórios',
        missing_fields_message: 'O campo "Título" e a "Lista de Itens" são obrigatórios!',
        grid_created: 'Grade cadastrada',
        grid_created_message: 'Cadastro realizado com sucesso!',
        error_create_message: 'Erro ao cadastrar a grade!',
        service_list: 'Lista de Itens',
        service_placeholder: 'Adicione um item (Ex.: Qualidade do Quarto)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'Editar Grade',
        save_changes_edit:
          'Preencha as informações abaixo e clique no botão salvar para confirmar as alterações',
        grid_updated: 'Grade alterada',
        grid_updated_message: 'Edição realizada com sucesso!',
        error_update_message: 'Erro ao alterar a grade!',

        general: {
          actions: 'Ações',
          edit: 'Editar',
          delete: 'Excluir',
          active: 'Ativo',
          inactive: 'Inativo',
          select: 'Selecione',
          back: 'Voltar',
        },
        buttons: {
          create: 'Criar',
          back: 'Voltar',
          save: 'Salvar',
        },
      },
      // Traduções para a página de gerenciamento de idiomas das lojas
      translate_stores: {
        page_title: 'Gerenciamento de idiomas e relações de Lojas',
        page_subtitle: 'Gerencie os idiomas de tradução e as relações de cada loja do sistema.',
        page_title_relationships: 'Gerenciamento de Relações de Lojas',
        page_subtitle_relationships: 'Gerencie as relações entre as lojas do sistema.',
        tab_translations: 'Gerenciar Idiomas',
        tab_relations: 'Relacionamentos de Lojas',
        breadcrumb: {
          dashboard: 'Dashboard',
          translate_stores: 'Gerenciar Idiomas',
        },
        filters: {
          status: 'Status',
          anonymous: 'Anônimo',
          type: 'Tipo',
          active: 'Ativo',
          inactive: 'Inativo',
          both: 'Ambos',
          all_types: 'Todos',
          status_placeholder: 'Status da Loja',
          type_placeholder: 'Tipo da Loja',
          filter_button: 'Filtrar',
        },
        status_options: {
          active: 'Ativo',
          inactive: 'Inativo',
          both: 'Ambos',
          all_types: 'Todos',
        },
        languages: {
          portuguese: 'Português',
          spanish: 'Espanhol',
          english: 'Inglês',
          french: 'Francês',
          german: 'Alemão',
          italian: 'Italiano',
          japanese: 'Japonês',
          korean: 'Coreano',
          chinese: 'Mandarim',
        },
        table: {
          headers: {
            type: 'Tipo',
            id: 'ID',
            name: 'Nome',
            subdomain: 'Subdomínio',
            status: 'Status',
            created: 'Criado em',
            cnpj: 'CNPJ',
            actions: 'Ações',
          },
          type: 'Tipo',
          id: 'ID',
          name: 'Nome',
          subdomain: 'Subdomínio',
          status: {
            active: 'Ativo',
            inactive: 'Inativo',
          },
          created: 'Criado em',
          cnpj: 'CNPJ',
          actions: 'Ações',
        },
        actions: {
          manage_languages: 'Gerenciar Idiomas',
          edit: 'Editar',
        },
        messages: {
          success: {
            title: 'Sucesso',
            save: 'Idiomas salvos com sucesso!',
          },
          error: {
            title: 'Erro',
            load_data: 'Erro ao carregar dados das lojas!',
            save_languages: 'Erro ao salvar idiomas!',
          },
        },
        modal: {
          title: 'Gerenciar Idiomas',
          description: 'Selecione os idiomas que estarão disponíveis para tradução nesta loja:',
          alert: {
            title: 'Atenção',
            message:
              'Ative ou desative os idiomas que deverão ser usados para tradução nesta loja.',
          },
          buttons: {
            cancel: 'Cancelar',
            save: 'Salvar',
          },
        },
        relations: {
          no_relations: 'Nenhum relacionamento encontrado',
          create_title: 'Criar Relacionamento',
          edit_title: 'Editar Relacionamento',
          parent_label: 'Loja Pai',
          child_label: 'Loja Filha',
          parent_missing: 'Selecione a loja pai',
          child_missing: 'Selecione a loja filha',
          same_store_error: 'A loja pai não pode ser igual à loja filha',
          created_success: 'Relacionamento criado com sucesso',
          updated_success: 'Relacionamento atualizado com sucesso',
          deleted_success: 'Relacionamento excluído com sucesso',
          error_create: 'Erro ao criar relacionamento',
          error_update: 'Erro ao atualizar relacionamento',
          error_delete: 'Erro ao excluir relacionamento',
          store_not_found: 'Loja não encontrada',
          all_option: 'Todas',
          cancel: 'Cancelar',
          save: 'Salvar',
          delete_confirm: 'Sim, excluir',
          create_button: 'Criar Relacionamento',
          save_changes: 'Salvar Alterações',
          create_description:
            'Defina qual loja será a loja pai e qual será a loja filha. Uma loja pai pode ter várias lojas filhas e gerenciar suas configurações.',
          edit_description:
            'Edite o relacionamento entre as lojas selecionadas. As alterações serão aplicadas imediatamente.',
          summary_title: 'Resumo do relacionamento:',
          tips_title: 'Dicas importantes:',
          tip_parent_multiple: 'Uma loja pai pode ter múltiplas lojas filhas',
          tip_child_single: 'Uma loja filha pode ter múltiplos pais',
          tip_all_available: 'Todas as lojas (ativas e inativas) estão disponíveis para seleção',
          click_new: 'Clique em "Novo Relacionamento" para começar',
          message_delete:
            'Você tem certeza que deseja excluir este relacionamento? Esta ação não pode ser desfeita.',
        },
      },
      hospitality_review: {
        page_title: 'Avaliações do Hotel',
        page_subtitle: 'Gerencie e monitore as avaliações e classificações dos hóspedes do hotel.',
        breadcrumb: {
          dashboard: 'Dashboard',
          hospitality: 'Hospitalidade',
          reviews: 'Avaliações',
        },
        statistics: {
          total_reviews: 'Total de Avaliações',
          average_rating: 'Média Geral',
        },
        filters: {
          filter_by_type: 'Filtrar por Tipo',
          filter_by_rating: 'Filtrar por Avaliação',
        },
        type_options: {
          all_types: 'Todos',
          general: 'Geral',
          room: 'Quarto',
          food: 'Comida',
          service: 'Serviço',
          cleanliness: 'Limpeza',
          activities: 'Atividades',
        },
        rating_options: {
          all_ratings: 'Todas as avaliações',
          five_stars: '5 estrelas',
          four_stars: '4 estrelas',
          three_stars: '3 estrelas',
          two_stars: '2 estrelas',
          one_star: '1 estrela',
        },
        table: {
          headers: {
            rating: 'Avaliação',
            type: 'Tipo',
            comment: 'Comentário',
            date: 'Data',
            actions: 'Ações',
          },
          actions: {
            view_full_review: 'Visualizar avaliação completa',
          },
          status: {
            approved: 'Aprovada',
            pending: 'Pendente',
          },
        },
        modal: {
          review_title: 'Avaliação de',
          fields: {
            rating: 'Avaliação',
            type: 'Tipo',
            status: 'Status',
            date: 'Data',
            comment: 'Comentário',
            email: 'Email',
          },
          guest_anonymous: 'Anônimo',
        },
        messages: {
          success: {
            review_deleted: 'Avaliação deletada',
            delete_success: 'Exclusão realizada com sucesso!',
            status_updated: 'Status atualizado',
            approved_success: 'Avaliação aprovada com sucesso!',
            suspended_success: 'Avaliação suspensa com sucesso!',
          },
          error: {
            title: 'Erro',
            load_reviews: 'Erro ao carregar avaliações do hotel!',
            invalid_id: 'ID inválido para exclusão!',
            delete_error: 'Erro ao deletar a avaliação!',
            status_error: 'Erro ao alterar status da avaliação!',
          },
          confirm: {
            delete_title: 'Confirmar exclusão',
            delete_text: 'Tem certeza que deseja excluir esta avaliação?',
            delete_confirm: 'Sim, excluir',
            delete_cancel: 'Cancelar',
          },
        },
      },
      hospitality_info: {
        page_title: 'Informações do Hotel',
        page_subtitle: 'Gerencie contato, horários e serviços do hotel.',
        tabs: {
          contact: 'Contato',
          hours: 'Horários e Informações',
          services: 'Serviços',
          ramal: 'Ramal',
          about: 'Sobre',
        },
        contact: {
          phone_label: 'Telefone',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'E-mail',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: 'Horários e Informações do Hotel',
          add_button: 'Adicionar Horário/Informação',
          remove_button: 'Remover',
          hour_number: 'Item',
          title_label: 'Título',
          title_placeholder: 'Ex.: Recepção, Piscina, Restaurante',
          description_label: 'Horário e Informações',
          description_placeholder:
            'Descreva o horário de funcionamento e informações adicionais (Ex.: 08:00 - 22:00, não funciona aos finais de semana)',
        },
        services: {
          title: 'Serviços do Hotel',
          add_button: 'Adicionar Serviço',
          remove_button: 'Remover',
          service_number: 'Serviço',
          service_title_label: 'Título do Serviço',
          service_title_placeholder: 'Ex.: Room Service',
          service_description_label: 'Descrição',
          service_description_placeholder: 'Descreva o serviço',
        },
        ramal: {
          title: 'Ramal do Hotel',
          add_button: 'Adicionar Ramal',
          remove_button: 'Remover',
          ramal_number: 'Ramal',
          ramal_title_label: 'Título do Ramal',
          ramal_title_placeholder: 'Ex.: 504',
          ramal_description_label: 'Descrição',
          ramal_description_placeholder: 'Descrição do ramal',
        },
        about: {
          description_label: 'Sobre o Hotel',
          description_placeholder:
            'Descreva informações gerais sobre o hotel, história, diferenciais e características especiais',
        },
        actions: {
          save_button: 'Salvar',
        },
        messages: {
          error_title: 'Erro',
          error_text: 'Não foi possível salvar as informações do hotel.',
          success_title: 'Salvo!',
          success_text: 'Informações do hotel salvas com sucesso.',
          required_phone: 'Telefone é obrigatório.',
          required_email: 'E-mail é obrigatório.',
          required_hours: 'Todos os itens devem ter título e descrição.',
          required_service: 'Todos os serviços devem ter título e descrição.',
          required_ramal: 'Todos os ramais devem ter título e descrição.',
        },
      },
      hospitality_schedules: {
        page_title: 'Programação do Hotel',
        page_subtitle: 'Gerencie eventos e programações do hotel.',
        new_button: 'Nova Programação',
        edit_button: 'Editar Programação',
        delete_button: 'Excluir Programação',
        delete_confirm:
          'Tem certeza que deseja excluir esta programação? Esta ação não pode ser desfeita.',
        table: {
          title: 'Título',
          type: 'Tipo',
          location: 'Local',
          time: 'Horário',
          recurrence: 'Recorrência',
          period: 'Período',
          status: 'Status',
          actions: 'Ações',
          active: 'Ativo',
          inactive: 'Inativo',
          single_event: 'Evento único',
          all_types: 'Todos',
          all_status: 'Todos os status',
          age_group: 'Grupo de Idade',
        },
        filters: {
          type: 'Tipo',
          type_placeholder: 'Selecione o tipo',
          status: 'Status',
          status_placeholder: 'Selecione o status',
          date_init: 'Data Inicial',
          date_init_placeholder: 'Data inicial',
          date_end: 'Data Final',
          date_end_placeholder: 'Data final',
          search: 'Pesquisar',
          clear: 'Limpar Filtros',
        },
        messages: {
          load_error: 'Erro ao carregar as programações!',
          delete_success: 'Programação excluída com sucesso!',
          delete_error: 'Erro ao excluir a programação!',
        },
        types: {
          activity: 'Entretenimento',
          food: 'Gastronomia',
          event: 'Evento',
          tour: 'Passeio',
        },
        age_groups: {
          all: 'Todos',
          children: 'Crianças',
          teens: 'Adolescentes',
          adults: 'Adultos',
          seniors: 'Idosos',
          family: 'Família',
        },
        singleEvent: 'Evento Único',
      },
      hospitality_schedule_edit: {
        page_title: 'Editar Programação',
        page_subtitle: 'Editando: {{title}}',
        not_found: {
          title: 'Programação não encontrada',
          description: 'A programação que você está tentando editar não foi encontrada.',
          back_button: 'Voltar para Lista',
        },
        form: {
          type_label: 'Tipo',
          type_placeholder: 'Selecione o tipo',
          type_sports: 'Esportes',
          type_wellness: 'Bem-estar',
          type_other: 'Outro',
          title_label: 'Título',
          title_placeholder: 'Digite o título da programação',
          description_label: 'Descrição',
          description_placeholder: 'Descreva a programação',
          location_label: 'Local',
          location_placeholder: 'Local da programação',
          time_label: 'Horário',
          time_placeholder: 'Ex: 14:00 - 16:00 ou 14:00',
          time_smalltext: 'Formato: "HH:MM - HH:MM" ou "HH:MM"',
          recurrence_config: 'Configuração de Recorrência',
          single_event_radio: 'Evento Único - Evento que acontece em datas específicas',
          recurring_event_radio:
            'Evento Recorrente - Evento que se repete em dias específicos da semana',
          day_within_date_range_radio:
            'Evento Dentro de um Intervalo de Datas - Evento que ocorre dentro de um intervalo de datas específico',
          days_of_week_label: 'Dias da Semana',
          selected_days: 'Selecionados: {{days}}',
          date_init_label: 'Data Inicial',
          date_init_placeholder: 'Data de início',
          date_end_label: 'Data Final',
          date_end_placeholder: 'Data de término (opcional)',
          status_label: 'Status',
          back_button: 'Voltar',
          save_button: 'Salvar Alterações',
        },
      },
      hospitality_schedule_create: {
        page_title: 'Nova Programação',
        page_subtitle: 'Criar uma nova programação para o hotel',
        success: {
          title: 'Sucesso!',
          text: 'Programação criada com sucesso!',
        },
        error: {
          title: 'Erro',
          text: 'Erro ao criar programação!',
        },
        form: {
          title_label: 'Título *',
          title_placeholder: 'Digite o título da programação',
          title_required: 'Título é obrigatório',
          type_label: 'Tipo *',
          type_placeholder: 'Selecione o tipo',
          type_sports: 'Esportes',
          type_wellness: 'Bem-estar',
          type_other: 'Outros',
          description_label: 'Descrição *',
          description_placeholder: 'Descreva a programação',
          description_required: 'Descrição é obrigatória',
          location_label: 'Local *',
          location_placeholder: 'Local da programação',
          location_required: 'Local é obrigatório',
          time_label: 'Horário *',
          time_placeholder: 'Ex: 14:00 - 16:00 ou 14:00',
          time_smalltext: 'Formato: "HH:MM - HH:MM" ou "HH:MM"',
          time_required: 'Horário é obrigatório',
          recurrence_config: 'Configuração de Recorrência',
          single_event_radio: 'Evento Único - Evento que acontece em datas específicas',
          recurring_event_radio:
            'Evento Recorrente - Evento que se repete em dias específicos da semana',
          day_within_date_range_radio:
            'Evento Dentro de um Intervalo de Datas - Evento que ocorre dentro de um intervalo de datas específico',
          days_of_week_label: 'Dias da Semana',
          selected_days: 'Selecionados: {{days}}',
          date_init_label: 'Data Inicial',
          date_init_placeholder: 'Data de início',
          date_end_label: 'Data Final',
          date_end_placeholder: 'Data de término (opcional)',
          status_label: 'Status',
          back_button: 'Voltar',
          save_button: 'Salvar',
        },
      },
      hospitality_banner: {
        page_title: 'Banners do Hotel',
        page_subtitle:
          'Gerencie os banners do seu hotel. Controle período de exibição, ordem e status.',
        breadcrumb: {
          hospitality: 'Hospitalidade',
          publicity: 'Publicidade',
        },
        new_button: 'Nova Publicidade',
        table: {
          title: 'Título',
          image: 'Imagem',
          order: 'Ordem',
          period: 'Período',
          created_date: 'Data de Criação',
          status: 'Status',
          actions: 'Ações',
        },
        actions: {
          edit: 'Editar publicidade',
          view: 'Visualizar detalhes',
          delete: 'Excluir publicidade',
        },
        modal: {
          title: 'Publicidade #{{id}}',
          order: 'Ordem',
          status: 'Status',
          active: 'Ativa',
          inactive: 'Inativa',
          period: 'Período',
          created: 'Criado em',
          updated: 'Última atualização',
          image: 'Imagem',
          no_image: 'Sem imagem',
        },
        delete: {
          confirm_title: 'Confirmar exclusão',
          confirm_text: 'Tem certeza que deseja excluir esta publicidade?',
          confirm_button: 'Sim, excluir',
          cancel_button: 'Cancelar',
          success_title: 'Publicidade deletada',
          success_text: 'Exclusão realizada com sucesso!',
        },
        status: {
          success_title: 'Status atualizado',
          success_text: 'Publicidade {{action}} com sucesso!',
          activated: 'ativada',
          deactivated: 'desativada',
        },
        error: {
          title: 'Erro',
          load_data: 'Erro ao carregar dados de publicidade!',
          invalid_id: 'ID inválido para exclusão!',
          delete: 'Erro ao deletar a publicidade!',
          status_change: 'Erro ao alterar status da publicidade!',
        },
      },
      hospitality_banner_create: {
        page_title: 'Criar novo Banner do Hotel',
        page_subtitle: 'Preencha as informações abaixo para criar um novo banner.',
        breadcrumb: {
          hospitality: 'Hospitalidade',
          publicity: 'Publicidade',
          create: 'Criar Publicidade',
        },
        form: {
          title_label: 'Título do Banner *',
          title_placeholder: 'Ex: Caminhadas...',
          order_label: 'Ordem de Exibição *',
          order_placeholder: 'Ex: 1, 2, 3...',
          order_smalltext: 'Ordem de prioridade da publicidade (números menores aparecem primeiro)',
          status_label: 'Publicidade Ativa',
          status_smalltext: 'Marque para ativar a publicidade',
          start_date_label: 'Data de Início *',
          start_time_label: 'Horário de Início *',
          end_date_label: 'Data de Fim *',
          end_time_label: 'Horário de Fim *',
          image_label: 'Imagem da Publicidade',
          image_select: 'Selecione uma imagem',
          image_formats: 'Formatos aceitos: JPG, PNG, GIF',
          image_optional: 'Opcional - Uma imagem padrão será usada se não for fornecida',
          image_preview: 'Preview da Imagem',
          image_remove: 'Remover Imagem',
        },
        preview: {
          period_title: 'Período da Publicidade:',
          start: 'Início',
          end: 'Fim',
        },
        validation: {
          title: 'Erro de validação',
          order_positive: 'Ordem deve ser um número maior que zero!',
          start_date_required: 'Data de início é obrigatória!',
          end_date_required: 'Data de fim é obrigatória!',
          dates_required: 'Datas e horários são obrigatórios!',
          start_before_end: 'Data de início deve ser anterior à data de fim!',
        },
        success: {
          title: 'Publicidade criada',
          text: 'Publicidade criada com sucesso!',
        },
        error: {
          title: 'Erro',
          text: 'Erro ao criar a publicidade!',
        },
      },
      hospitality_banner_update: {
        page_title: 'Editar Publicidade do Hotel',
        page_subtitle: 'Editando publicidade #{{id}}',
        breadcrumb: {
          edit: 'Editar Publicidade',
        },
        current_image: 'Imagem Atual',
        save_button: 'Salvar Alterações',
        not_found: {
          title: 'Publicidade não encontrada',
          text: 'A publicidade que você está tentando editar não foi encontrada.',
          back_button: 'Voltar para Lista',
        },
        no_changes: {
          title: 'Nenhuma alteração',
          text: 'Nenhum campo foi modificado!',
        },
        success: {
          title: 'Publicidade atualizada',
          text: 'Publicidade atualizada com sucesso!',
        },
        error: {
          title: 'Erro',
          text: 'Erro ao atualizar publicidade',
          load_data: 'Erro ao carregar dados da publicidade!',
          update: 'Erro ao atualizar a publicidade!',
        },
      },
      hospitality_publicity: {
        page_title: 'Banners de Destaque do Hotel',
        page_subtitle:
          'Gerencie os banners de destaque do seu hotel. Controle período de exibição, ordem e status.',
        breadcrumb: {
          hospitality: 'Hospitalidade',
          publicity: 'Publicidade',
        },
        new_button: 'Novo Banner',
        table: {
          image: 'Imagem',
          order: 'Ordem',
          period: 'Período',
          created_date: 'Data de Criação',
          status: 'Status',
          actions: 'Ações',
        },
        actions: {
          edit: 'Editar publicidade',
          view: 'Visualizar detalhes',
          delete: 'Excluir publicidade',
        },
        modal: {
          title: 'Publicidade #{{id}}',
          order: 'Ordem',
          status: 'Status',
          active: 'Ativa',
          inactive: 'Inativa',
          period: 'Período',
          created: 'Criado em',
          updated: 'Última atualização',
          image: 'Imagem',
          no_image: 'Sem imagem',
        },
        delete: {
          confirm_title: 'Confirmar exclusão',
          confirm_text: 'Tem certeza que deseja excluir esta publicidade?',
          confirm_button: 'Sim, excluir',
          cancel_button: 'Cancelar',
          success_title: 'Publicidade deletada',
          success_text: 'Exclusão realizada com sucesso!',
        },
        status: {
          success_title: 'Status atualizado',
          success_text: 'Publicidade {{action}} com sucesso!',
          activated: 'ativada',
          deactivated: 'desativada',
        },
        error: {
          title: 'Erro',
          load_data: 'Erro ao carregar dados de publicidade!',
          invalid_id: 'ID inválido para exclusão!',
          delete: 'Erro ao deletar a publicidade!',
          status_change: 'Erro ao alterar status da publicidade!',
        },
      },
      hospitality_publicity_create: {
        page_title: 'Criar Publicidade do Hotel',
        page_title_edit: 'Editar Publicidade do Hotel',
        page_subtitle: 'Preencha as informações abaixo para criar uma nova publicidade.',
        breadcrumb: {
          hospitality: 'Hospitalidade',
          publicity: 'Publicidade',
          create: 'Criar Publicidade',
        },
        form: {
          order_label: 'Ordem de Exibição *',
          order_placeholder: 'Ex: 1, 2, 3...',
          order_smalltext: 'Ordem de prioridade da publicidade (números menores aparecem primeiro)',
          status_label: 'Publicidade Ativa',
          status_smalltext: 'Marque para ativar a publicidade',
          start_date_label: 'Data de Início *',
          start_time_label: 'Horário de Início *',
          end_date_label: 'Data de Fim *',
          end_time_label: 'Horário de Fim *',
          image_label: 'Imagem da Publicidade',
          image_select: 'Selecione uma imagem',
          image_formats:
            'Formatos aceitos: JPG, PNG, GIF | Dimensões: ~200x112px | Tamanho máx: 2MB',
          image_optional: 'Opcional - Uma imagem padrão será usada se não for fornecida',
          image_preview: 'Preview da Imagem',
          image_remove: 'Remover Imagem',
          external_link_checkbox: 'Incluir Link Externo',
          external_link_label: 'Link Externo',
          external_link_placeholder: 'https://example.com',
          description_label: 'Descrição do Banner',
          description_smalltext: '* Máximo {qtd} caracteres',
          title_label: 'Título do Banner',
          title_placeholder: 'Exemplo: Trilhas...',
          title_smalltext: '* Máximo {qtd} caracteres',
        },
        preview: {
          period_title: 'Período da Publicidade:',
          start: 'Início',
          end: 'Fim',
        },
        validation: {
          title: 'Erro de validação',
          order_positive: 'Ordem deve ser um número maior que zero!',
          start_date_required: 'Data de início é obrigatória!',
          end_date_required: 'Data de fim é obrigatória!',
          dates_required: 'Datas e horários são obrigatórios!',
          start_before_end: 'Data de início deve ser anterior à data de fim!',
          external_link_required: 'Link externo é obrigatório quando a opção é selecionada!',
          image_size_error: 'A imagem deve ter no máximo 2MB!',
          image_dimensions_error:
            'As dimensões da imagem devem ser aproximadamente 200x112 pixels! Atual: {{current}}',
          image_invalid: 'Arquivo de imagem inválido! Por favor, selecione uma imagem válida.',
        },
        success: {
          title: 'Publicidade criada',
          text: 'Publicidade criada com sucesso!',
        },
        error: {
          title: 'Erro',
          text: 'Erro ao criar a publicidade!',
          update: 'Erro ao atualizar a publicidade!',
        },
        not_found: {
          title: 'Publicidade não encontrada',
          text: 'A publicidade que você está tentando editar não foi encontrada.',
          back_button: 'Voltar para a lista',
        },
        no_changes: {
          title: 'Sem alterações',
          text: 'Nenhum campo foi modificado!',
        },
        current_image: 'Imagem Atual',
      },
      // Adicionar ao arquivo
      service_list: {
        filters: {
          categories: 'Categories',
          category_placeholder: 'Category',
          filter_button: 'Filter',
          all_categories: 'ALL',
        },
        table: {
          schedule: 'Schedule',
          extension: 'Extension',
        },
        actions: {
          delete_service: 'Delete Service',
        },
      },
      // Adicionar ao arquivo
      service_create: {
        page_title: 'Cadastrar Serviço',
        breadcrumb: {
          services: 'Serviços',
          create: 'Criar',
        },
        form: {
          classification_placeholder: 'Selecione uma classificação',
          name_label: 'Nome',
          name_placeholder: 'Nome do serviço',
          description_label: 'Descrição',
          description_placeholder: 'Descrição do serviço',
          schedule_label: 'Horário de Funcionamento',
          schedule_placeholder: 'Ex: 24h, 08:00-18:00, Sob demanda',
          schedule_smalltext: 'Máximo 50 caracteres',
          extension_label: 'Ramal',
          extension_placeholder: 'Ex: 1001, 2050',
          extension_smalltext: 'Máximo 10 caracteres',
          code_label: 'Código',
          code_placeholder: 'Código do serviço',
          order_label: 'Ordem',
          order_placeholder: 'Ordem de exibição',
          status_label: 'Status',
          status_active: 'Ativo',
          status_inactive: 'Inativo',
          external_link_label: 'Link Externo',
          external_link_placeholder: 'https://example.com',
          priority_label: 'Prioridade',
          priority_low: 'Baixa',
          priority_normal: 'Normal',
          priority_high: 'Alta',
          priority_critical: 'Crítica',
        },
        icons: {
          title: 'Ícones',
          category_label: 'Categoria do Ícone',
          all_categories: 'Todos',
          selected_icon: 'Ícone selecionado',
        },
        validation: {
          missing_fields_title: 'Campos faltantes',
          missing_fields_text:
            'Verifique se preencheu todos os campos obrigatórios: Nome, Classificação e Ícone!',
        },
        success: {
          title: 'Serviço cadastrado',
          text: 'Cadastro realizado com sucesso!',
        },
        error: {
          title: 'Erro',
          text: 'Erro ao cadastrar o serviço!',
          icons_load: 'Erro ao encontrar os tipos',
        },
      }, // Adicionar ao arquivo
      service_update: {
        page_title: 'Editar Serviço',
        page_title_full: 'Atualizar Serviço',
        breadcrumb: {
          edit: 'Editar',
        },
        error: {
          title: 'Erro',
          load_data: 'Erro ao carregar dados do serviço!',
          text: 'Erro ao atualizar o serviço!',
        },
        success: {
          title: 'Serviço atualizado',
          text: 'Edição realizada com sucesso!',
        },
      },
      // Adicionar ao arquivo
      service_category_create: {
        validation: {
          missing_fields_title: 'Campos faltantes',
          missing_fields_text: 'Verifique se preencheu todos os campos!',
        },
        success: {
          title: 'Classificação cadastrada',
          text: 'Cadastro realizado com sucesso!',
        },
        error: {
          title: 'Erro',
          text: 'Erro ao cadastrar a classificação!',
          create: 'Erro ao cadastrar classificação!',
        },
      },

      // Adicionar ao arquivo
      service_category_list: {
        page_title: 'Categorias de Conteúdo',
        page_subtitle:
          'Aqui estão listadas as categorias de conteúdo juntamente com suas respectivas ações.',
        breadcrumb: {
          categories: 'Categorias',
        },
        add_button: 'Adicionar',
        table: {
          name: 'Nome',
          status: 'Status',
          actions: 'Ações',
        },
        actions: {
          edit_category: 'Editar categoria',
          delete_category: 'Excluir categoria',
        },
        delete: {
          error_title: 'Erro',
          error_text: 'Erro ao deletar a categoria!',
          success_title: 'Categoria deletada',
          success_text: 'Deleção realizada com sucesso!',
          confirm_title: 'Você tem certeza?',
          confirm_text: 'A categoria será deletada e não será possível restaurar!',
          cancel_button: 'fechar!',
          confirm_button: 'Deletar!',
        },
      },
      service_category_update: {
        error: {
          title: 'Erro',
          load_data: 'Erro ao carregar dados da classificação!',
          text: 'Erro ao atualizar a classificação!',
          update: 'Erro ao atualizar a classificação!',
        },
        success: {
          title: 'Classificação atualizada',
          text: 'Edição realizada com sucesso!',
        },
      },
      hotelRoom: {
        status: {
          available: 'Disponível',
          reserved: 'Reservado',
          maintenance: 'Em Manutenção',
          occupied: 'Ocupado',
          being_cleaning: 'Sendo Limpo',
        },
        type: {
          single: 'Solteiro',
          double: 'Casal',
          twin: 'Duas Camas',
          queen: 'Queen',
          king: 'King',
          suite: 'Suíte',
          junior_suite: 'Suíte Júnior',
          master_suite: 'Suíte Master',
          presidential: 'Suíte Presidencial',
          family: 'Quarto Família',
          accessible: 'Quarto Acessível',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: 'Cliente',
          wizard_step_reservation: 'Reserva',
          wizard_step_confirmation: 'Confirmação',
          wizard_step1: 'Passo 1',
          wizard_step2: 'Passo 2',
          wizard_step3: 'Passo 3',
          wizard_customer_title: 'Selecionar ou Cadastrar Cliente',
          wizard_customer_search_placeholder: 'Buscar por nome, email ou telefone...',
          wizard_customer_search_button: 'Buscar Cliente Existente',
          wizard_customer_new_button: 'Cadastrar Novo Cliente',
          wizard_customer_none_found: 'Nenhum cliente encontrado',
          wizard_customer_showing_first:
            'Mostrando os primeiros 20 resultados. Refine sua busca para encontrar outros clientes.',
          wizard_reservation_title: 'Dados da Reserva',
          wizard_reservation_room_label: 'Quarto *',
          wizard_reservation_room_subtitle:
            'Clique nos quartos para selecioná-los. Você pode selecionar múltiplos quartos.',
          wizard_reservation_room_placeholder: 'Selecione um quarto',
          wizard_reservation_status_label: 'Status da Reserva',
          wizard_reservation_status_placeholder: 'Selecione o status',
          wizard_reservation_checkin_label: 'Data e Hora de Check-in *',
          wizard_reservation_checkout_label: 'Data e Hora de Check-out *',
          wizard_reservation_password_label: 'Senha do Cliente',
          wizard_reservation_password_placeholder: 'Digite a senha do cliente',
          wizard_reservation_generate_password: 'Gerar senha',
          wizard_confirmation_title: 'Confirmar Reserva',
          wizard_confirmation_customer_data: 'Dados do Cliente',
          wizard_confirmation_reservation_data: 'Dados da Reserva',
          wizard_confirmation_room: 'Quarto',
          wizard_confirmation_capacity: 'Capacidade',
          wizard_confirmation_price: 'Preço',
          wizard_confirmation_checkin: 'Check-in',
          wizard_confirmation_checkout: 'Check-out',
          wizard_confirmation_status: 'Status',
          wizard_confirmation_password: 'Senha',
          wizard_confirmation_address: 'Endereço',
          wizard_confirmation_zipcode: 'CEP',
          wizard_confirmation_gender_male: 'Masculino',
          wizard_confirmation_gender_female: 'Feminino',
          wizard_confirmation_gender_other: 'Outro',
          wizard_confirmation_gender_not_informed: 'Prefiro não informar',
          wizard_buttons_back: 'Voltar',
          wizard_buttons_cancel: 'Cancelar',
          wizard_buttons_next: 'Próximo',
          wizard_buttons_create: 'Criar',
          wizard_page_title: 'Nova Reserva de Quarto',
          wizard_page_subtitle: 'Criar nova reserva para o hotel',
          legend: {
            title: 'Legenda de Status dos Quartos',
            available: 'Disponível',
            selected: 'Selecionado',
            unavailable: 'Não Disponível',
            occupied: 'Ocupado',
            reserved: 'Reservado',
            being_cleaning: 'Em Limpeza',
            maintenance: 'Em Manutenção',
            no_info: 'Sem Informação',
          },
        },
        customer_form: {
          title: 'Dados do Cliente',
          personal_info_title: 'Informações Pessoais',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: 'Nome Completo *',
          name_placeholder: 'Digite o nome completo',
          email_label: 'E-mail *',
          email_placeholder: 'Digite o e-mail',
          birthdate_label: 'Data de Nascimento *',
          gender_label: 'Gênero',
          gender_placeholder: 'Selecione o gênero',
          gender_male: 'Masculino',
          gender_female: 'Feminino',
          gender_other: 'Outro',
          contact_info_title: 'Informações de Contato',
          phone_label: 'Telefone *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: 'Tipo de Telefone',
          phone_type_cell: 'Celular',
          phone_type_landline: 'Fixo',
          whatsapp_optin: 'Aceita receber mensagens no WhatsApp',
          address_title: 'Endereço Residencial',
          cep_label: 'CEP *',
          cep_placeholder: '00000-000',
          street_label: 'Logradouro *',
          street_placeholder: 'Rua, Avenida, etc.',
          number_label: 'Número *',
          number_placeholder: '123',
          extra_label: 'Complemento',
          extra_placeholder: 'Apto, Bloco, etc.',
          district_label: 'Bairro *',
          district_placeholder: 'Nome do bairro',
          city_label: 'Cidade *',
          city_placeholder: 'Nome da cidade',
          state_label: 'Estado *',
          state_placeholder: 'SP',
          reference_label: 'Ponto de Referência',
          reference_placeholder: 'Próximo ao shopping, em frente à praça, etc.',
          terms_title: 'Termos e Condições',
          accept_terms: 'Aceito os termos e condições de uso *',
          lgpd_consent: 'Autorizo o tratamento dos meus dados pessoais (LGPD) *',
        },
        title: 'Reservas de Quartos',
        subtitle: 'Gerenciamento de reservas do hotel',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_reservation: 'Reservas',
        btn_new_reservation: 'Nova Reserva',
        btn_confirm: 'Confirmar Reserva',
        btn_checkin: 'Fazer Check-in',
        btn_checkout: 'Fazer Check-out',
        btn_cancel: 'Cancelar Reserva',
        btn_no_show: 'Marcar como Não Compareceu',
        btn_delete: 'Deletar Reserva',
        btn_details: 'Detalhes Reserva',
        filter_status_label: 'Status da Reserva',
        filter_status_placeholder: 'Selecione um status',
        filter_status_all: 'Todos os Status',
        table_reservation: 'Reserva',
        table_room: 'Quarto',
        table_customer: 'Cliente',
        table_checkin: 'Check-in',
        table_checkout: 'Check-out',
        table_status: 'Status',
        table_price: 'Valor',
        table_actions: 'Ações',
        status_confirmed: 'Confirmada',
        status_in_progress: 'Em andamento',
        status_completed: 'Concluída',
        status_cancelled: 'Cancelada',
        status_no_show: 'Não Compareceu',
        status_pending: 'Pendente',
        msg_success_delete: 'Deleção realizada com sucesso!',
        msg_success_update: 'Status da reserva atualizado com sucesso!',
        msg_error_delete: 'Erro ao deletar a reserva!',
        msg_error_update: 'Erro ao atualizar o status da reserva!',
        msg_confirm_status_change: 'Deseja alterar o status da reserva para "{status}"?',
        msg_confirm_checkin: 'Deseja fazer o check-in para esta reserva?',
        msg_confirm_checkout: 'Deseja finalizar o check-out? Esta ação não pode ser desfeita.',
        msg_checkout_attention: '⚠️ ATENÇÃO - LEIA ATENTAMENTE:',
        msg_checkout_list: [
          'O cliente já efetuou o pagamento',
          'Não há pendências financeiras',
          'Todos os serviços foram devidamente quitados',
        ],
        msg_checkout_confirm_read: 'Li e confirmo que todas as validações foram verificadas',
        msg_checkout_validation:
          'Você deve confirmar que leu e verificou todas as validações antes de prosseguir.',
        msg_confirm_delete: 'Deletar Reserva',
        tab_basic: 'Informações Básicas',
        tab_summary: 'Resumo',
        tab_activities: 'Atividades',
        tab_tours: 'Passeios',
        tab_experiences: 'Experiências',
        tab_services: 'Serviços',
        tab_services_list: 'Listagem de Serviços',
        tab_orders: 'Pedidos de Hotel',
        label_loading: 'Carregando...',
        label_loading_orders: 'Carregando pedidos...',
        label_order_details: 'Detalhes do Pedido',
        label_no_data: 'Nenhum pedido encontrado',
        label_pending: 'Nenhum pedido está reservado no momento.',
        tab_title: 'Pedidos de Hotel',
        label_order: 'Pedido',
        label_orders: 'Pedidos',
        label_total_spent: 'Total Gasto: {value}',
        label_total_orders: 'Total de Pedidos',
        label_total_spent_label: 'Total Gasto',
        label_total_paid_label: 'Total Pago',
        label_products: 'Produtos',
        label_quantity: 'Quantidade',
        label_sku: 'SKU',
        label_delivery: 'Entrega',
        label_delivery_address: 'Endereço de Entrega',
        label_withdraw_address: 'Endereço de Retirada',
        label_financial_summary: 'Resumo Financeiro',
        label_products_label: 'Produtos',
        label_delivery_fee: 'Taxa de Entrega',
        label_discount: 'Desconto',
        label_total: 'Total',
        label_payment_na: 'Pagamento N/A',
        label_payment_offline: 'Pagamento Offline',
        label_payment_card: 'Pagamento com Cartão',
        label_payment_credit: 'Crédito',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: 'Informações Básicas',
          label_customer: 'Cliente',
          label_room: 'Quarto',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Status',
          label_price: 'Valor',
          label_notes: 'Observações',
          placeholder_notes: 'Adicione observações da reserva',
          status_edit_warning:
            'O status da reserva não pode ser editado após confirmação ou cancelamento.',
          selected_room_details:
            'Quarto {roomNumber} - {type} (Capacidade: {capacity}) - R$ {price}',
          selected_customer_details: 'Cliente: {name} | Email: {email} | Telefone: {phone}',
          optional_checkout: 'O check-out é opcional e pode ser preenchido posteriormente.',
          status_pending: 'Pendente',
          status_confirmed: 'Confirmada',
          status_in_progress: 'Em andamento',
          status_completed: 'Concluída',
          status_cancelled: 'Cancelada',
          summary_capacity: 'Capacidade',
          summary_people: 'pessoas',
          btn_change_password: 'Alterar Senha',
        },
        summary: {
          tab_title: 'Resumo',
          room_details: 'Detalhes do Quarto',
          label_total: 'Total',
          label_paid: 'Pago',
          label_pending: 'Pendente',
          label_services: 'Serviços',
          label_products: 'Produtos',
          label_activities: 'Atividades',
          label_experiences: 'Experiências',
          label_tours: 'Passeios',
          label_room: 'Quarto',
          label_customer: 'Cliente',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Status',
          label_price: 'Valor',
          label_notes: 'Observações',
          label_capacity: 'Capacidade',
          label_people: 'Pessoas',
          label_orders: 'Pedidos de Hotel',
          label_payment_method: 'Método de Pagamento',
          label_discount: 'Desconto',
          label_tax: 'Taxa',
          label_total_with_tax: 'Total com Taxa',
          label_total_with_discount: 'Total com Desconto',
          label_total_paid: 'Total Pago',
          label_total_pending: 'Total Pendente',
          label_summary: 'Resumo da Reserva',
          label_details: 'Detalhes',
          label_edit: 'Editar',
          label_delete: 'Deletar',
          label_confirm: 'Confirmar',
          label_cancel: 'Cancelar',
          label_no_data: 'Sem dados disponíveis',
          label_success: 'Operação realizada com sucesso!',
          label_error: 'Erro na operação!',
          label_warning: 'Atenção',
          label_info: 'Informação',
          label_actions: 'Ações',
          label_service: 'Serviço',
          label_product: 'Produto',
          label_activity: 'Atividade',
          label_experience: 'Experiência',
          label_tour: 'Passeio',
          label_order: 'Pedido',
          label_date: 'Data',
          label_time: 'Horário',
          label_type: 'Tipo',
          label_edit_reservation: 'Editar Reserva',
          label_delete_reservation: 'Deletar Reserva',
          label_confirm_reservation: 'Confirmar Reserva',
          label_cancel_reservation: 'Cancelar Reserva',
          label_status_confirmed: 'Confirmada',
          label_status_in_progress: 'Em andamento',
          label_status_completed: 'Concluída',
          label_status_cancelled: 'Cancelada',
          label_status_no_show: 'Não Compareceu',
          label_status_pending: 'Pendente',
        },
        activities: {
          tab_title: 'Atividades',
          label_activity: 'Atividade',
          label_activities: 'Atividades',
          label_no_data: 'Nenhuma atividade encontrada',
          label_pending: 'Nenhuma atividade está reservada no momento.',
          label_people: 'Participantes',
          label_category: 'Categoria',
          label_location: 'Localização',
          label_session_time: 'Horário da Sessão',
          label_skill_level: 'Nível de Habilidade',
          label_special_requests: 'Solicitações Especiais',
          label_price: 'Valor',
          label_date: 'Data',
          label_time: 'Horário',
          label_status: 'Status',
          label_actions: 'Ações',
          label_description: 'Descrição',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendente',
          status_cancelled: 'Cancelado',
          status_completed: 'Concluído',
          btn_add_activity: 'Adicionar Atividade',
        },
        experiences: {
          tab_title: 'Experiências',
          label_experience: 'Experiência',
          label_experiences: 'Experiências',
          label_no_data: 'Nenhuma experiência encontrada',
          label_pending: 'Nenhuma experiência está reservada no momento.',
          label_people: 'Participantes',
          label_category: 'Categoria',
          label_location: 'Localização',
          label_session_time: 'Horário da Sessão',
          label_skill_level: 'Nível de Habilidade',
          label_special_requests: 'Solicitações Especiais',
          label_price: 'Valor',
          label_date: 'Data',
          label_time: 'Horário',
          label_status: 'Status',
          label_actions: 'Ações',
          label_description: 'Descrição',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendente',
          status_cancelled: 'Cancelado',
          status_completed: 'Concluído',
          btn_add_experience: 'Adicionar Experiência',
          label_duration: 'Duração',
          label_rating: 'Avaliação',
          label_special_occasion: 'Ocasião Especial',
          label_includes: 'Inclui',
        },
        hotel_orders: {
          tab_title: 'Pedidos de Hotel',
          label_order: 'Pedido',
          label_orders: 'Pedidos',
          label_no_data: 'Nenhum pedido encontrado',
          label_pending: 'Nenhum pedido está reservado no momento.',
          label_delivery: 'Entrega',
          label_quantity: 'Quantidade',
          label_sku: 'SKU',
          label_delivery_address: 'Endereço de Entrega',
          label_withdraw_address: 'Endereço de Retirada',
          label_financial_summary: 'Resumo Financeiro',
          label_products: 'Produtos',
          label_products_label: 'Produtos',
          label_total_spent: 'Total Gasto: {value}',
          label_total_orders: 'Total de Pedidos',
          label_total_spent_label: 'Total Gasto',
          label_total_paid_label: 'Total Pago',
          label_discount: 'Desconto',
          label_total: 'Total',
          label_payment_na: 'Pagamento N/A',
          label_payment_offline: 'Pagamento Offline',
          label_payment_card: 'Pagamento com Cartão',
          label_payment_credit: 'Crédito',
          label_delivery_fee: 'Taxa de Entrega',
          no_order_title: 'Nenhum Pedido Encontrado',
        },
        tours: {
          tab_title: 'Passeios',
          label_tour: 'Passeio',
          label_tours: 'Passeios',
          label_no_data: 'Nenhum passeio encontrado',
          label_pending: 'Nenhum passeio está reservado no momento.',
          label_people: 'Participantes',
          label_duration: 'Duração',
          label_difficulty: 'Dificuldade',
          label_rating: 'Avaliação',
          label_transfer_included: 'Transferência Incluída',
          label_transfer_yes: 'Transferência Incluída',
          label_transfer_no: 'Sem Transferência',
          label_schedule: 'Horário',
          label_weather_concerns: 'Preocupações com o Clima',
          label_physical_requirements: 'Requisitos Físicos',
          label_special_requests: 'Solicitações Especiais',
          label_price: 'Valor',
          label_date: 'Data',
          label_time: 'Horário',
          label_status: 'Status',
          label_actions: 'Ações',
          label_description: 'Descrição',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendente',
          status_cancelled: 'Cancelado',
          status_completed: 'Concluído',
          btn_add_tour: 'Adicionar Passeio',
        },
        services: {
          tab_title: 'Serviços',
          no_services: 'Nenhum serviço reservado',
          no_services_description: 'Não há serviços reservados para esta hospedagem no momento.',
          total_services: 'Total de Serviços',
          total_amount: 'Valor Total',
          total_people: 'Total de Pessoas',
          service_info: 'Informações do Serviço',
          service_name: 'Nome do Serviço',
          booking_id: 'ID da Reserva',
          reservation_date: 'Data da Reserva',
          reservation_time: 'Horário',
          people_qty: 'Quantidade de Pessoas',
          submitted_at: 'Enviado em',
          room_info: 'Informações do Quarto',
          room_number: 'Número do Quarto',
          room_type: 'Tipo do Quarto',
          room_price: 'Valor do Quarto',
          total_price: 'Valor Total',
          description: 'Descrição',
          booking_details: 'Detalhes da Reserva',
          booking_title: 'Título',
          capacity: 'Capacidade',
          multiple: 'Múltiplo',
          yes: 'Sim',
          no: 'Não',
          notes: 'Observações',
          created_at: 'Criado em',
          updated_at: 'Atualizado em',
          service_id: 'Serviço',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendente',
          status_cancelled: 'Cancelado',
          status_completed: 'Concluído',
        },
        services_list: {
          tab_title: 'Listagem de Serviços',
          no_services: 'Nenhum serviço reservado',
          no_services_description: 'Não há serviços reservados para esta hospedagem no momento.',
          total_filtered: 'Serviços Filtrados',
          of_total: 'de {total}',
          total_amount: 'Valor Total',
          total_people: 'Total de Pessoas',
          average_price: 'Valor Médio',
          filter_search: 'Buscar',
          filter_search_placeholder: 'Buscar por nome, quarto, descrição...',
          filter_status: 'Status',
          filter_status_all: 'Todos os Status',
          active_filters: 'Filtros Ativos',
          clear_filters: 'Limpar Filtros',
          table_title: 'Lista de Serviços Reservados',
          services: 'serviços',
          column_id: 'ID',
          column_service: 'Serviço',
          column_room: 'Quarto',
          column_date: 'Data',
          column_people: 'Pessoas',
          column_price: 'Valor',
          column_status: 'Status',
          column_actions: 'Ações',
          btn_view_details: 'Ver Detalhes',
          no_results: 'Nenhum resultado encontrado',
          no_results_description: 'Tente ajustar os filtros para encontrar mais resultados.',
          status_confirmed: 'Confirmado',
          status_pending: 'Pendente',
          status_cancelled: 'Cancelado',
          status_completed: 'Concluído',
          showing: 'Mostrando',
          to: 'até',
          of: 'de',
        },
      },
      hospitality_hotel_room: {
        label_room_number: 'Número do Quarto *',
        image: 'Imagem do Quarto',
        placeholder_room_number: 'Ex: 101, A201, Suíte Presidencial',
        max_20_chars: 'Máximo 20 caracteres',
        label_status: 'Status',
        label_capacity: 'Capacidade (pessoas)',
        placeholder_capacity: 'Ex: 2',
        label_price: 'Preço (R$)',
        placeholder_price: 'Ex: 150.00',
        label_type: 'Tipo do Quarto',
        title: 'Quartos de Hotel',
        subtitle: 'Gerenciamento de quartos do hotel',
        create_multiples: 'Criar Múltiplos Quartos',
        add_room: 'Adicionar Quarto',
        header_number: 'Número',
        header_status: 'Status',
        header_type: 'Tipo',
        header_capacity: 'Capacidade',
        header_price: 'Preço',
        header_actions: 'Ações',
        action_edit: 'Editar Quarto',
        action_delete: 'Deletar Quarto',
        modal_bulk_title: 'Criar Múltiplos Quartos',
        modal_bulk_prefix: 'Prefixo (opcional)',
        modal_bulk_prefix_placeholder: 'Ex: A, B, 1º',
        modal_bulk_start: 'Número Inicial *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: 'Número Final *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: 'Capacidade',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: 'Preço',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'Tipo',
        type_single: 'Solteiro',
        type_double: 'Duplo',
        type_twin: 'Twin',
        type_queen: 'Queen',
        type_king: 'King',
        type_suite: 'Suíte',
        type_junior_suite: 'Suíte Júnior',
        type_master_suite: 'Suíte Master',
        type_presidential: 'Presidencial',
        type_family: 'Familiar',
        type_accessible: 'Acessível',
        modal_bulk_cancel: 'Cancelar',
        modal_bulk_create: 'Criar Quartos',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hotel_room: 'Quartos de Hotel',
        create_title: 'Criar Quarto de Hotel',
        create_subtitle: 'Adicionar novo quarto ao hotel',
        edit_title: 'Editar Quarto de Hotel',
        edit_subtitle: 'Editar informações do quarto #{room}',
        breadcrumb_create: 'Criar Quarto',
        breadcrumb_edit: 'Editar Quarto',
      },
      hospitality_experiences: {
        tab_basic: 'Informações Básicas',
        edit: 'Editar Experiência',
        edit_subtitle: 'Atualiza a informação da experiência',
        create: 'Criar Experiência',
        create_subtitle: 'Preencha os detalhes para criar uma nova experiência',
        tab_details: 'Itens detalhados',
        tab_image: 'Imagem',
        tab_schedules: 'Horários',
        list_title: 'Experiências do Hotel',
        list_subtitle: 'Gerencie todas as experiências do hotel',
        field_title: 'Título',
        field_title_placeholder: 'Ex: Jantar Romântico Exclusivo',
        field_description: 'Descrição',
        field_description_placeholder: 'Descreva detalhadamente a experiência oferecida...',
        field_image: 'Nova Imagem',
        field_price: 'Preço (R$)',
        field_price_placeholder: '0.00',
        field_duration: 'Duração',
        field_duration_placeholder: 'Ex: 2 horas',
        field_type: 'Tipo de Experiência',
        field_rating: 'Avaliação (0-5)',
        field_rating_placeholder: '0',
        field_status: 'Status Ativo',
        field_includes: 'Itens Incluídos',
        field_includes_placeholder: 'Ex: Champagne, decoração especial...',
        field_show_additional_services: 'Mostrar opções de serviços pré-definidas',
        field_actions: 'Ações',
        status_active: 'Ativo',
        status_inactive: 'Inativo',
        no_rating: 'Sem avaliação',
        no_includes: 'Nenhum item incluído',
        currency: 'R$',
        btn_add: 'Adicionar Experiência',
        btn_edit: 'Editar',
        btn_delete: 'Remover',
        btn_update: 'Atualizar Experiência',
        btn_create: 'Criar Experiência',
        btn_remove: 'Remover',
        btn_add_item: 'Adicionar Item',
        edit_title: 'Editar Experiência',
        create_title: 'Criar Experiência',
        msg_success_create: 'Experiência criada com sucesso!',
        msg_success_update: 'Experiência atualizada com sucesso!',
        msg_success_delete: 'Experiência removida',
        msg_success_delete_text: 'Experiência removida com sucesso!',
        msg_error_create: 'Erro ao criar experiência',
        msg_error_update: 'Erro ao atualizar experiência',
        msg_error_delete: 'Erro ao remover experiência',
        msg_error_delete_text: 'Não foi possível remover a experiência!',
        msg_error_load: 'Erro ao carregar experiência',
        msg_error_load_text: 'Não foi possível carregar os dados da experiência!',
        msg_error_required_title: 'Título é obrigatório!',
        msg_error_title_length: 'Título deve ter no máximo 255 caracteres!',
        msg_error_required_description: 'Descrição é obrigatória!',
        msg_error_required_price: 'Preço é obrigatório!',
        msg_error_price_negative: 'Preço deve ser maior ou igual a zero!',
        msg_error_required_duration: 'Duração é obrigatória!',
        msg_error_duration_length: 'Duração deve ter no máximo 100 caracteres!',
        msg_error_required_includes: 'Pelo menos um item deve estar incluído!',
        msg_error_rating_range: 'Avaliação deve estar entre 0 e 5!',
        field_order: 'Ordem',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        header_order: 'Ordem',
        msg_error_order_negative: 'A ordem deve ser maior ou igual a zero!',
      },
      entertainment_services: {
        list_title: 'Entretenimento',
        list_subtitle: 'Gerencie os serviços de entretenimento disponíveis',
        create: 'Criar Serviço de Entretenimento',
        create_subtitle: 'Preencha os detalhes para criar um novo serviço',
        create_title: 'Criar Serviço de Entretenimento',
        edit: 'Editar Serviço de Entretenimento',
        edit_subtitle: 'Atualiza a informação do serviço',
        edit_title: 'Editar Serviço de Entretenimento',
        field_title: 'Título',
        field_title_placeholder: 'Ex: Spa e Massagem',
        field_type: 'Tipo de Serviço',
        field_status: 'Status Ativo',
        field_actions: 'Ações',
        type_experience: 'Experiência',
        type_activity: 'Atividade',
        type_tour: 'Tour',
        status_active: 'Ativo',
        status_inactive: 'Inativo',
        btn_add: 'Adicionar Serviço',
        btn_edit: 'Editar',
        btn_delete: 'Remover',
        btn_update: 'Atualizar Serviço',
        btn_create: 'Criar Serviço',
        btn_search: 'Buscar',
        btn_clear: 'Limpar',
        search_placeholder: 'Buscar por título...',
        msg_success_create: 'Serviço criado com sucesso!',
        msg_success_update: 'Serviço atualizado com sucesso!',
        msg_success_delete: 'Serviço removido',
        msg_success_delete_text: 'Serviço removido com sucesso!',
        msg_error_create: 'Erro ao criar serviço',
        msg_error_update: 'Erro ao atualizar serviço',
        msg_error_delete: 'Erro ao remover serviço',
        msg_error_delete_text: 'Não foi possível remover o serviço!',
        msg_error_load: 'Erro ao carregar serviço',
        msg_error_load_text: 'Não foi possível carregar os dados do serviço!',
        msg_error_required_title: 'Título é obrigatório!',
        msg_error_title_length: 'Título deve ter no máximo 255 caracteres!',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: 'Reservas de Serviços',
          details_title: 'Detalhes da Reserva',
          cancel_title: 'Cancelar Reserva',
          cancel_reason_label: 'Motivo do Cancelamento *',
          cancel_reason_placeholder: 'Selecione o motivo do cancelamento',
          cancel_reason_select: 'Selecione um motivo',
          type_tour: 'Passeio',
          type_experience: 'Experiência',
          type_activity: 'Atividade',
          type_room_service: 'Serviço de Quarto',
          status_pending: 'Pendente',
          status_confirmed: 'Confirmado',
          status_cancelled: 'Cancelado',
          status_completed: 'Concluído',
          error_title: 'Erro',
          error_load: 'Erro ao carregar as reservas!',
          error_details: 'Erro ao carregar detalhes da reserva!',
          error_cancel: 'Erro ao cancelar a reserva!',
          success_title: 'Sucesso',
          success_cancel: 'Reserva cancelada com sucesso!',
          warning_title: 'Atenção',
          warning_cancel_reason: 'Por favor, selecione um motivo para o cancelamento.',
          no_details: 'Detalhes específicos não disponíveis para este tipo de reserva.',
          reasons_tour: [
            'Mudança de planos',
            'Problemas climáticos',
            'Conflito de horário',
            'Motivos de saúde',
            'Cancelamento do hotel',
          ],
          reasons_experience: [
            'Mudança de data da estadia',
            'Ocasião especial cancelada',
            'Conflito de agenda',
            'Motivos pessoais',
            'Preferência por outro serviço',
          ],
          reasons_activity: [
            'Não me sinto preparado(a)',
            'Conflito de horário',
            'Problemas de saúde',
            'Mudança de planos',
            'Atividade não atende expectativa',
          ],
          reasons_room_service: [
            'Mudança de planos',
            'Serviço não necessário',
            'Conflito de horário',
            'Motivos pessoais',
            'Preferência por outro serviço',
          ],
        },
        create_title: 'Criar Atividade do Hotel',
        create_subtitle: 'Adicionar nova atividade ao hotel',
        edit_title: 'Editar Atividade do Hotel',
        edit_subtitle: 'Atualizar informações da atividade',
        list_title: 'Atividades do Hotel',
        list_subtitle: 'Gerenciamento de atividades e entretenimento',
        field_title: 'Título da Atividade *',
        field_title_placeholder: 'Ex: Aula de Yoga, Show Musical, Recreação Infantil',
        field_title_hint: 'Máximo 255 caracteres',
        field_time: 'Horário *',
        field_time_placeholder: 'Ex: 08:00 - 09:00, Diariamente às 15h',
        field_time_hint: 'Máximo 100 caracteres',
        field_description: 'Descrição *',
        field_description_placeholder:
          'Descreva detalhadamente a atividade, seus benefícios e o que os hóspedes podem esperar...',
        field_image: 'Imagem da Atividade',
        field_location: 'Localização *',
        field_location_placeholder: 'Ex: Piscina principal, Salão de eventos, Praia',
        field_location_hint: 'Máximo 255 caracteres',
        field_capacity: 'Capacidade *',
        field_capacity_placeholder: 'Ex: 20, se 0 é ilimitado',
        field_capacity_hint: 'Máximo 50 caracteres',
        field_period: 'Período *',
        field_period_placeholder: 'Ex: 00:15 ou 01:00 ou 00:30',
        field_category: 'Categoria *',
        field_age_group: 'Faixa Etária',
        field_price: 'Preço (R$)',
        field_price_placeholder: '0.00 (deixe vazio se gratuito)',
        field_price_hint: 'Deixe vazio para atividade gratuita',
        field_requires_reservation: 'Requer Reserva',
        field_requires_reservation_hint: 'Marque se a atividade necessita de reserva prévia',
        field_is_active: 'Atividade Ativa',
        field_is_active_hint: 'Desmarque para desativar temporariamente a atividade',
        btn_edit: 'Editar Atividade',
        btn_delete: 'Deletar Atividade',
        btn_create: 'Criar Atividade',
        btn_cancel: 'Cancelar',
        msg_success_create: 'Atividade criada com sucesso!',
        msg_success_update: 'Atividade atualizada com sucesso!',
        msg_success_delete: 'Atividade deletada com sucesso!',
        msg_error_create: 'Erro ao criar atividade!',
        msg_error_update: 'Erro ao atualizar atividade!',
        msg_error_delete: 'Erro ao deletar atividade!',
        msg_error_load: 'Erro ao carregar atividade!',
        msg_error_required_title: 'Título é obrigatório!',
        msg_error_title_length: 'Título deve ter no máximo 255 caracteres!',
        msg_error_required_description: 'Descrição é obrigatória!',
        msg_error_required_time: 'Horário é obrigatório!',
        msg_error_time_length: 'Horário deve ter no máximo 100 caracteres!',
        msg_error_required_location: 'Localização é obrigatória!',
        msg_error_location_length: 'Localização deve ter no máximo 255 caracteres!',
        msg_error_required_capacity: 'Capacidade é obrigatória!',
        msg_error_capacity_length: 'Capacidade deve ter no máximo 50 caracteres!',
        msg_error_price_negative: 'Preço deve ser maior ou igual a zero!',
        remove_schedule: 'Eliminar Horário',
        confirm_remove_schedule: 'Tem certeza que deseja eliminar este horário?',
        schedule_seasonal_start: 'Início de Temporada',
        schedule_seasonal_end: 'Fim de Temporada',
        schedule_start_time: 'Hora de Início',
        schedule_end_time: 'Hora de Fim',
        add_schedule: 'Adicionar Horário',
        schedule_time: 'Hora *',
        schedule_time_placeholder: 'Ex.: 08:00 - 09:00, Diário às 15h',
        schedule_description: 'Descrição *',
        schedule_days_of_week: 'Dias da Semana',
        schedule_status: 'Horário Ativo',
        schedule_seasonal_hint: 'Defina um período estacional se aplicável',
        field_duration_hint: 'Duração em horas e minutos (ex: 2h30min)',
        field_duration_placeholder: 'Duração em horas e minutos (ex: 2h30min)',
        field_order: 'Ordem',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        msg_error_order_negative: 'A ordem deve ser maior ou igual a zero!',
      },
      hotel_tour: {
        create_title: 'Criar Passeios',
        create_subtitle: 'Adicionar novo passeio ao hotel',
        edit_title: 'Editar Passeios',
        edit_subtitle: 'Atualizar informações do passeio',
        list_title: 'Passeios',
        list_subtitle: 'Gerenciar passeios e excursões',
        field_title: 'Título do Passeio *',
        field_difficulty: 'Dificuldade',
        field_duration: 'Duração',
        field_rating: 'Avaliação',
        field_participants: 'Participantes',
        field_schedules: 'Horários',
        field_includes: 'Inclui',
        field_transfer: 'Transfer',
        field_currency: 'Moeda',
        field_currency_hint: 'Código da moeda (ex: BRL, USD)',
        currency_brl: 'Real (BRL)',
        currency_usd: 'Dólar (USD)',
        currency_eur: 'Euro (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: 'Avaliação de 0 a 5 estrelas',
        field_participants_min: 'Participantes Mínimos *',
        field_participants_min_hint: 'Número mínimo de participantes',
        field_participants_max: 'Participantes Máximos',
        field_participants_max_placeholder: 'Deixe vazio se ilimitado',
        field_participants_max_hint: 'Número máximo de participantes (opcional)',
        field_age_restriction: 'Restrição de Idade',
        field_age_restriction_placeholder:
          'Ex: Acima de 12 anos, Não recomendado para menores de 18',
        field_age_restriction_hint: 'Restrições de idade (opcional)',
        field_physical_requirements: 'Requisitos Físicos',
        field_physical_requirements_placeholder:
          'Ex: Boa condição física, Capacidade de caminhar longas distâncias',
        field_physical_requirements_hint: 'Requisitos físicos necessários (opcional)',
        field_cancellation_hours: 'Cancelamento (horas) *',
        field_cancellation_hours_hint: 'Horas antes para cancelamento',
        field_discount_children: 'Desconto Crianças (%)',
        field_discount_children_hint: 'Desconto em porcentagem',
        field_weather_dependent: 'Depende do Clima',
        field_weather_dependent_hint: 'Marque se depende das condições climáticas',
        field_is_active: 'Tour Ativo',
        field_is_active_hint: 'Desmarque para desativar temporariamente',
        tab_basic: 'Informações Básicas',
        tab_details: 'Detalhes e Configurações',
        tab_schedules: 'Horários',
        tab_includes: 'Itens Inclusos',
        tab_image: 'Imagem',
        no_schedule_added: 'Nenhum horário adicionado',
        click_add_schedule: 'Clique em "Adicionar Horário" para começar.',
        includes_title: 'Itens Inclusos no Tour',
        selected: 'Selecionados',
        field_image_hint: 'Selecione uma imagem representativa do tour',
        update_info: 'Atualizar informações do tour',
        field_title_placeholder: 'Ex: City Tour, Excursão à Praia, Caminhada Histórica',
        field_title_hint: 'Máximo 255 caracteres',
        field_time: 'Horário *',
        field_time_placeholder: 'Ex: 08:00 - 09:00, Diariamente às 15h',
        field_time_hint: 'Máximo 100 caracteres',
        field_description: 'Descrição *',
        field_description_placeholder:
          'Descreva o passeio, destaques e o que os hóspedes podem esperar...',
        field_image: 'Imagem do Passeio',
        field_location: 'Localização *',
        field_location_placeholder: 'Ex: Centro, Praia, Museu',
        field_location_hint: 'Máximo 255 caracteres',
        field_capacity: 'Capacidade *',
        field_capacity_placeholder: 'Ex: 20 pessoas, Ilimitado, 10-15 participantes',
        field_capacity_hint: 'Máximo 50 caracteres',
        field_category: 'Categoria *',
        field_price: 'Preço (R$)',
        field_price_placeholder: '0.00 (deixe vazio se gratuito)',
        field_price_hint: 'Deixe vazio para passeio gratuito',
        field_requires_reservation: 'Requer Reserva',
        field_requires_reservation_hint: 'Marque se o passeio necessita de reserva prévia',
        btn_edit: 'Editar Passeio',
        btn_delete: 'Deletar Passeio',
        btn_create: 'Criar Passeio',
        btn_cancel: 'Cancelar',
        table_title: 'Título',
        table_time: 'Horário',
        table_location: 'Localização',
        table_category: 'Categoria',
        table_price: 'Preço',
        table_capacity: 'Capacidade',
        table_actions: 'Ações',
        msg_success_create: 'Passeio criado com sucesso!',
        msg_success_update: 'Passeio atualizado com sucesso!',
        msg_success_delete: 'Passeio deletado com sucesso!',
        msg_error_create: 'Erro ao criar passeio!',
        msg_error_update: 'Erro ao atualizar passeio!',
        msg_error_delete: 'Erro ao deletar passeio!',
        msg_error_load: 'Erro ao carregar passeio!',
        msg_error_required_title: 'Título é obrigatório!',
        msg_error_title_length: 'Título deve ter no máximo 255 caracteres!',
        msg_error_required_description: 'Descrição é obrigatória!',
        msg_error_required_time: 'Horário é obrigatório!',
        msg_error_time_length: 'Horário deve ter no máximo 100 caracteres!',
        msg_error_required_location: 'Localização é obrigatória!',
        msg_error_location_length: 'Localização deve ter no máximo 255 caracteres!',
        msg_error_required_capacity: 'Capacidade é obrigatória!',
        msg_error_capacity_length: 'Capacidade deve ter no máximo 50 caracteres!',
        msg_error_price_negative: 'Preço deve ser maior ou igual a zero!',
        schedule_start_time: 'Hora de Início',
        schedule_end_time: 'Hora de Fim',
        add_schedule: 'Adicionar Horário',
        schedule_time: 'Hora *',
        schedule_time_placeholder: 'Ex.: 08:00 - 09:00, Diário às 15h',
        schedule_description: 'Descrição *',
        schedule_days_of_week: 'Dias da Semana',
        schedule_status: 'Horário Ativo',
        schedule_seasonal_hint: 'Defina um período estacional se aplicável',
        field_duration_hint: 'Duração em horas e minutos (ex: 2h30min)',
        field_duration_placeholder: 'Duração em horas e minutos (ex: 2h30min)',
        schedule_seasonal_start: 'Início de Temporada',
        schedule_seasonal_end: 'Fim de Temporada',
        difficult: {
          easy: 'Fácil',
          medium: 'Moderado',
          hard: 'Difícil',
          extreme: 'Extremo',
        },
        field_order: 'Ordem',
        field_order_placeholder: 'Ex: 1, 2, 3...',
        header_order: 'Ordem',
        msg_error_order_negative: 'A ordem deve ser maior ou igual a zero!',
      },
      months: {
        jan: 'Jan',
        feb: 'Fev',
        mar: 'Mar',
        apr: 'Abr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Sep',
        oct: 'Out',
        nov: 'Nov',
        dec: 'Dez',
      },
      permissions: {
        color_variations: 'Variações de Cor',
        food: 'Smart Order',
        smartorder: 'Gestão de Produtos',
        category: 'Categorias',
        subcategory: 'Subcategorias',
        product: 'Produtos',
        mark: 'Marcas',
        grid: 'Grades',
        variation: 'Variações',
        catalog: 'Catálogos',
        integration: 'Integrações',
        int_pos: 'PDV',
        int_gateway: 'Meio de Pagamento',
        messaging: 'Mensageria',
        sms: 'Status e SMS',
        multichannel: 'Multicanal',
        report: 'Relatórios',
        saleorder: 'Pedidos',
        indicators: 'Indicadores',
        orderReport: 'Pedidos',
        imports: 'Importação de Imagens',
        importProductImage: 'Produtos',
        importProductImageSKU: 'Variações',
        importCategoryImage: 'Categorias',
        customers: 'Clientes',
        customer_report: 'Lista de Clientes',
        measurement_unit: 'Unidades de Medida',
        logs: 'Logs',
        settings: 'Configurações',
        charge_integration: 'Cargas',
        summaryAccess: 'Acessos',
        sellerAccess: 'Dash Vendedor',
        managerAccess: 'Dash Gerente',
        managerGroupAccess: 'Dash Gestor do Grupo',
        orders: 'Pedidos',
        support: 'Suporte',
        translate: 'Idiomas e Relações',
        application: 'Webapp',
        messenger: 'Mensageria',
        others: 'Outros',
        settings_store: 'Configurações da Loja',
        settings_hotel: 'Configurações ',
        modalities: 'Modalidades',
        delivery_tax: 'Taxa de entrega',
        shifts: 'Turnos',
        whatsappweb: 'WhatsApp Web',
        filemanager: 'Gerenciador de Arquivos',
        payment_plans: 'Planos de Pagamento',
        settings_account: 'Configurações da Conta',
        account: 'Conta',
        groups: 'Grupos',
        users: 'Usuários',
        terms: 'Termos',
        highlights: 'Destaques',
        menu: 'Cardápio',
        productReport: 'Produtos',
        optional: 'Lista de Adicionais',
        locations: 'Setores',
        stores_location: 'Estabelecimentos',
        message_hotel: 'Status e Notificação',
        service: 'Serviços',
        service_items: 'Serviços',
        service_category: 'Categorias',
        feed: 'Feed',
        content: 'Interface do Webapp',
        sessions: 'Seções',
        buttons: 'Vincular Botão',
        structured_content: 'Serviços Essenciais',
        orders_room_service: 'Quarto',
        orders_activities: 'Atividades',
        orders_service_reservation: 'Reservas de Serviços',
        queue: 'Fila de espera',
        queue_config: 'Configurações',
        queue_manager: 'Gerenciamento',
        checkout: 'Dados do Cliente',
        booking: 'Reserva',
        booking_management: 'Gerenciamento',
        booking_config: 'Configurações',
        booking_environment: 'Ambientes',
        booking_day: 'Reservas do dia',
        booking_report: 'Relatórios',
        booking_managerday: 'Gerenciamento Diário',
        booking_management_dashboard: 'Dashboard de Reservas',
        table_management: 'Gestão de Mesas',
        table_allocation_report: 'Relatório de Alocação de Mesas',
        table_management_dashboard: 'Dashboard de Mesas',
        liveShop: 'Live Commerce',
        icon_library: 'Biblioteca de Ícones',
        stores: 'Lojas/Clientes',
        segments: 'Segmentos',
        payment: 'Pagamentos',
        serviceCategory: 'Categoria do Serviço',
        SDS: 'KDS',
        sds_manage: 'Meus KDS',
        sds_layout: 'Personalização',
        sds_link: 'Configurações',
        sds_display: 'Displays',
        /* Agregador */
        config: 'Configurações',
        config_account: 'Dados da conta',
        config_sector: 'Setor de atuação',
        config_user: 'Usuários',
        config_term: 'Termos',
        subCategory: 'Subcategoria',
        footer: 'Recursos do rodapé',
        footerFeature: 'Habilitar recursos',
        footerContent: 'Feed de recursos',
        footerContentAddEdit: 'Recursos',
        webapp: 'Personalizar',
        webapp_qrcode: 'Gerar QR Code',
        ia_menu: 'Inteligência Artificial',
        ia_config: 'Configurações',
        ia_fit: 'Treinamento',
        ia_file_manager: 'Gerenciador de Arquivos',
        ia_folders: 'Pastas',
        ia_files: 'Arquivos',
        ia_settings: 'Configurações',
        ia_folders_blank: 'Nenhuma pasta encontrada',
        ia_filter: 'Filtrar',
        ia_recharge: 'Recarregar',
        ia_final_date: 'Data Final',
        ia_initial_date: 'Data Inicial',
        summarize: 'Dashboard',
        consumption: 'Consumo IA',
        ct_account: 'Consumo e Valor',
        ct_s3_account: 'Conta S3',
        ct_data_cost_account: 'Dados e Custos',
        publication_highlight_banner: 'Banner Destaque',
        publication: 'Publicidade',
        cost: 'Custos',
        security_settings: 'Configurações de segurança',
        coupon: 'Cupom',
        clean_safe: 'Clean & Safe',
        service_requests: 'Formulários de Serviço',
        grid_hotel: 'Grades de Serviços',
        /*Hotelaria */
        hotel_maintenance: 'Gerenciamento',
        hotel_room: 'Quarto',
        hotel_reservation: 'Reservas de Quarto',
        hotel_activities_experiences: 'Entretenimentos',
        hotel_activities: 'Atividades',
        hotel_tour: 'Passeios',
        hotel_tour_schedules: 'Passeios Horários',
        hotel_tour_reservation: 'Reservas Gerais',
        hotel_experiences: 'Experiências',
        hotel_info: 'Informações',
        hotel_reservations: 'Reservas',
        hotel_schedules: 'Programação do Hotel',
        publication_banner: 'Banner',
        feed_back: 'Feed Back',
        feedback_satisfaction: 'Pesquisa e Satisfação',
        grid_hotel_feedback: 'Grades',
        feedback_list: 'Formulários',
        feedback: 'Resultados',
        post: 'Publicação e Botões',
        posts: 'Publicação',
        post_category: 'Categoria de Publicações',
        page_publications: 'Página de Publicações',
        post_content: 'Conteúdo da Publicação',
        booking_hotel: 'Central de Reservas',
        grid_hotel_booking: 'Grades de Serviços',
        booking_config_hotel: 'Reservas de Serviços',
        communication: 'Comunicação',
        communicationCenter: 'Central de Comunicação',
        hotel_management: 'Gestão do Hotel',
        hotel_management_entertainment: 'Entretenimento',
        product_color_variations: 'Variações de Cores',
        swagger_permission: 'Permissões Swagger',
        feedback_analytics: 'Análise de Feedback',
      },
      // Traduções para Color Variations Workbench
      workbench: {
        page_title: 'Variações de Cores',
        page_subtitle: 'Gerenciamento de variações de cores dos produtos',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_workbench: 'Workbench de Cores',

        // Mode Selection
        selectMode: 'Selecione o Modo',
        chooseProdutOrVariation: 'Escolha trabalhar com um Produto ou uma Variação',
        product: 'Produto',
        productDescription: 'Escolha entre os produtos cadastrados da sua loja',
        variation: 'Variação',
        variationDescription: 'Escolha entre as variações cadastradas',

        // Product/Variation Selection
        selectProduct: 'Selecione um Produto',
        selectVariation: 'Selecione uma Variação',
        searchProduct: 'Pesquisar produto por nome ou código...',
        searchVariation: 'Pesquisar variação por SKU ou nome do produto...',
        noProductsFound: 'Nenhum produto encontrado',
        noProductsMatchSearch: 'Nenhum produto encontrado com os critérios de busca',
        noVariationsFound: 'Nenhuma variação encontrada',
        noVariationsMatchSearch: 'Nenhuma variação encontrada com os critérios de busca',
        showingResults: 'Mostrando',
        noImagesFound: 'Nenhuma imagem encontrada para este produto/variação',
        description:
          'Selecione um produto ou variação para começar a criar variações de cores personalizadas.',
        of: 'de',
        backButton: 'Voltar',

        // Image and Color Selection
        selectImage: 'Selecione a Imagem',
        selectColor: 'Selecione a Cor',
        colorDescription: 'Descrição (Opcional)',
        descriptionPlaceholder: 'Descreva a mudança que deseja fazer...',
        selectImageFirst: 'Por favor, selecione uma imagem primeiro',
        processingError: 'Erro ao processar a variação',

        // Buttons
        generateVariation: 'Gerar Variação',
        processing: 'Processando...',
        processingTimeSeconds: '{time}s',

        // Preview
        selectedImagePreview: 'Prévia da Imagem Selecionada',
        resultPreview: 'Prévia do Resultado',
        originalImage: 'Imagem Original',
        processedImage: 'Imagem Processada',
        targetColor: 'Cor Alvo',
        processingTime: 'Tempo de Processamento',

        // Actions
        approveAndApply: 'Aprovar e Aplicar',
        reject: 'Rejeitar',
        applyVariation: 'Aplicar Variação',
        applyTarget: 'Onde deseja aplicar esta variação?',

        // Apply Dialog
        createNewVariation: 'Criar Nova Variação',
        newVariationInfo: 'Uma nova variação será criada com esta imagem',
        replaceExistingVariation: 'Substituir Variação Existente',
        selectVariationToReplace: 'Selecione a variação que deseja substituir',
        replaceProductImage: 'Substituir Imagem do Produto',
        selectProductToReplaceImage: 'Selecione qual imagem do produto será substituída',

        // Messages
        variationSavedSuccess: 'Variação salva com sucesso!',
        errorSavingVariation: 'Erro ao salvar a variação',
        successTitle: 'Sucesso',
        errorTitle: 'Erro',
        warningTitle: 'Atenção',

        // Dialog Buttons
        cancel: 'Cancelar',
        save: 'Salvar',
        confirm: 'Confirmar',
        close: 'Fechar',
      },
      // Traduções para Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: 'Reservas de Serviços',
        page_subtitle: 'Gerencie as reservas de serviços',
        breadcrumb_services: 'Serviços - Booking',
        breadcrumb_booking: 'Serviços de Booking',
        create_button: 'Criar Reserva de Serviço',

        // Table headers
        table_image: 'Imagem',
        table_title: 'Título',
        table_order: 'Ordem',
        table_status: 'Status',
        table_actions: 'Ações',

        // Table actions
        action_edit: 'Editar',
        action_delete: 'Deletar',

        // Status
        status_active: 'Ativo',
        status_inactive: 'Inativo',

        // Messages
        delete_success: 'Reserva deletada',
        delete_error: 'Falha ao deletar reserva',
        delete_confirm: 'Confirma exclusão?',

        // Create page
        create_title: 'Criar Reserva de Serviço',
        create_subtitle: 'Preencha as informações para criar uma nova reserva de serviço',

        // Edit page
        edit_title: 'Editar Reserva de Hotel',
        edit_subtitle: 'Edite as informações da reserva',

        // Form fields
        field_title_label: 'Título',
        field_title_placeholder: 'Ex.: Reserva de Spa',
        field_status_label: 'Status',
        field_description_label: 'Descrição',
        field_image_label: 'Imagem',
        field_icon_label: 'Ícone',

        // Icon picker
        icon_choose: 'Escolher Ícone',
        icon_choose_modal: 'Escolher Ícone',

        // Day configuration
        day_config_title: 'Configuração de Dias',
        day_config_info_line1:
          'Se o dia não tiver horários definidos, esse limite vale para o dia inteiro.',
        day_config_info_line2:
          'Se o dia tiver horários com intervalos, esse limite vale para cada horário/intervalo.',
        day_configure: 'Configurar',
        day_periods_title: 'Períodos de Tempo',
        day_period_add: 'Adicionar Período',
        day_period_max: 'Máximo 3 períodos',
        day_period_none: 'Nenhum período configurado. Adicione pelo menos um período.',
        day_period_overlap: 'Os períodos não podem se sobrepor.',
        day_period_label: 'Período',
        day_period_remove: 'Remover',
        day_interval_label: 'Intervalo (min)',
        day_start_time_label: 'Hora Início',
        day_end_time_label: 'Hora Fim',

        // Day names
        day_sunday: 'Domingo',
        day_monday: 'Segunda',
        day_tuesday: 'Terça',
        day_wednesday: 'Quarta',
        day_thursday: 'Quinta',
        day_friday: 'Sexta',
        day_saturday: 'Sábado',

        // Grid selection
        grid_title: 'Grades Vinculadas',
        grid_select: 'Selecionar Grades',
        grid_selected: 'grade(s) selecionada(s)',
        grid_capacity: 'Capacidade',
        grid_multiple: 'Múltipla',
        grid_multiple_yes: 'Sim',
        grid_multiple_no: 'Não',
        grid_status_active: 'Ativa',
        grid_status_inactive: 'Inativa',
        grid_item_name_placeholder: 'Nome (Ex.: Massagem Relaxante)',
        grid_item_value_placeholder: 'Valor (Ex.: 50,00)',

        // Action buttons
        button_back: 'Voltar',
        button_save: 'Salvar',
        button_update: 'Atualizar',
        button_create: 'Criar',
        button_cancel: 'Cancelar',
        button_confirm: 'Confirmar',

        // Validation messages
        validation_title_required: 'Campo obrigatório',
        validation_title_text: 'O título é obrigatório.',
        validation_icon_required: 'Campo obrigatório',
        validation_icon_text: 'Selecione um ícone.',
        validation_day_required: 'Configuração necessária',
        validation_day_text: 'Configure pelo menos um dia da semana.',

        // Success messages
        success_created: 'Reserva criada',
        success_created_text: 'A reserva foi criada com sucesso!',
        success_updated: 'Reserva atualizada',
        success_updated_text: 'A reserva foi atualizada com sucesso!',

        // Error messages
        error_create: 'Erro ao criar',
        error_create_text: 'Ocorreu um erro ao criar a reserva.',
        error_update: 'Erro ao atualizar',
        error_update_text: 'Ocorreu um erro ao atualizar a reserva.',
        error_save: 'Erro',
        error_save_text: 'Ocorreu um erro ao salvar a reserva.',
        error_load: 'Erro',
        error_load_text: 'Erro ao carregar os dados da reserva.',

        // Breadcrumbs
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hospitality: 'Hospitalidade',
        breadcrumb_hotel_reservations: 'Reservas de Hotel',
        breadcrumb_create: 'Criar',
        breadcrumb_edit: 'Editar',
      },
      customer: {
        select_group: 'Selecione um grupo',
        select: 'Selecionar',
        create: 'Criar cliente',
        create_group: 'Criar grupo',
        edit: 'Visualizar cliente',
        search_custom: 'Buscar...',
        customer: 'Clientes',
      },

      buttons: {
        create: 'Criar',
        back: 'Voltar',
        previous: 'Anterior',
        register_pluginspace: 'Cadastrar Pluginspace',
        access: 'Acessar',
        add_modality: 'Adicionar modalidade',
        add_km: 'Adicionar Km',
        zip_code_list: 'Lista de CEPs',
        add_zip_code: 'Adicionar CEP',
        area: 'Áreas de Frete',
        list_of_negative_renge_zip_code: 'Lista de CEPs negativos',
        add_negative_zip_code: 'Adicionar CEP negativo',
        add_user: 'Adicionar usuário',
        generate_password: 'Gerar senha',
        generate_sku: 'Gerar SKU',
        add_group: 'Adicionar grupo',
        save: 'Salvar',
        add_term: 'Adicionar termo',
        add_integration: 'Adicionar integração',
        filter: 'Filtrar',
        search: 'Procurar',
        register_product: 'Cadastrar Produto',
        choose_files: 'Escolher arquivos',
        add_categories: 'Adicionar categorias',
        add_subcategories: 'Adicionar subcategorias',
        add_brand: 'Adicionar marca',
        close: 'Fechar',
        add_grade: 'Adicionar grade',
        add: 'Adicionar',
        add_variation: 'Adicionar variação',
        confirm_grades: 'Confirmar grades',
        add_catalog: 'Adicionar catálogo',
        generete_qr_code: 'Gerar QR Code',
        personalize: 'Personalizar',
        settings: 'Configurações',
        add_interval: 'Adicionar intervalo',
        add_gateway: 'Adicionar gateway',
        overview: 'Visão geral',
        view: 'Visualizar',
        load_csv: 'Carregar arquivo',
        download_csv: 'Download XLSX Padrão',
        att_page: 'Atualizar página',
        export: 'Exportar',
        add_service: 'Cadastrar Serviço',
        add_environment: 'Adicionar ambiente',
        generate_ia: 'Propor',
        clear_table_card: 'Limpar mesa ou comanda',
        propose_image: 'Propor imagem',
        cancel: 'Cancelar',
        next: 'Próximo',
      },

      global: {
        success: 'Sucesso',
        error: 'Erro',
        warning: 'Atenção',
        active: 'Ativo',
        inactive: 'Inativo',
      },

      modals: {
        warning_confirm: 'Tem certeza?',
        warning_save: 'Salvar',
        warning_close: 'Fechar',
        text_close: 'Fechar',
      },

      general: {
        delete_item: 'Deseja deletar este item?',
        delete_product_observation:
          'As variações desse produto também serão excluidas, deseja continuar mesmo assim?',
        delete_classification_observation:
          'Excluindo essa categoria, todos os produtos relacionados a ela vão para a Geral, deseja continuar?',
        delete: 'Deletar',
        edit: 'Editar',
        duplicate: 'Duplicar',
        attention: 'Atenção',
        actions: 'Ações',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Aqui estão listados os itens juntamente com suas respectivas ações',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
        save_changes_edit:
          'Preencha as informações abaixo e clique no botão salvar para confirmar as alterações',
        save_changes_duplicate:
          'Valide ou altere as informações abaixo e clique no botão salvar para confirmar as alterações',
        active: 'Ativo',
        inactive: 'Inativo',
        showing: 'Mostrando',
        of: 'de',
        to: 'até',
        records: 'registros',
        type: 'Tipo',
        today: 'Hoje',
        copy: 'Copiar',
        linkS3: 'Link',
        linkedS3: 'Linked',
        downloadS3: 'Download',
        downloadedS3: 'Download Iniciada',
        copied: 'Copiado',
        copy_link: 'Copiar link do vendedor',
        test: 'Testar',
        success: 'Sucesso',
        error: 'Erro',
        email: 'E-mail',
        paymentFree: 'Grátis',
      },

      pluginspaces: {
        hospitality: 'Hotéis',
        food: 'Food',
        healthcare: 'Hospitalidade',
        varejo: 'Varejo',
        fashion: 'Moda',
      },

      dashboard: {
        totals_by_products: 'Totais por produto',
        totals_by_category: 'Totais por categoria',
        last_orders: 'Útimos pedidos',
        products: 'Produtos',
        quantity: 'Quantidade',
        total: 'Total',
        category: 'Categoria',
        welcome: 'Bem-vindo ao Ninegrid',
        describe_dashboard:
          'Aqui você tem todas as ferramentas para gerir sua loja de forma simples e eficiente. Explore os menus laterais para navegar em nossas funcionalidades. Bom trabalho!',
      },

      modalities: {
        modalities: 'Modalidades',
        modalitie: 'Modalidade',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Aqui estão listadas as modalidades juntamente com suas respectivas ações',
        delivery: 'Entrega',
        withdraw: 'Retirada',
        active: 'Ativo',
        inactive: 'Inativo',
        name: 'Nome',
        code: 'Código',
        actions: 'Ações',
        search: 'Procurar',
        type: 'Tipo',
        sector_name: 'Nome do setor',
        table: 'Mesa',
        room: 'Quarto',
        counter: 'Balcão',
        internal: 'Entrega Interna',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: 'Taxa de entrega',
        create_delivery_fee: 'Criar taxa de entrega',
        edit_delivery_fee: 'Editar taxa de entrega',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
        save_changes_edit:
          'Preencha as informações abaixo e clique no botão salvar para confirmar as alterações',
        km_min: 'Km Mínimo',
        km_max: 'Km Máximo',
        value: 'Valor',
        actions: 'Ações',
        patterns: 'Padrões de Importação',
        import_file:
          'Para importar os arquivos a primeira célula do arquivo tem que seguir um dos seguintes padrões:',
        import_delivery: 'Para importar por range: kmmin, kmmax, Value',
        import_cep: 'Para importar CEP: cep_inicio, cep_fim, valor',
        import_cep_negative: 'Para importar CEP negativo: cep_inicio, cep_fim',
        model: 'Modelo',
        continue_import:
          'Todos seus registros serão substituídos, você tem certeza que deseja continuar?',
        cep_delivery: 'CEPs de Entrega',
        cep_info: 'Aqui estão listados os CEP`s de entregas juntamente com suas respectivas ações.',
        cep_start: 'CEP Início',
        cep_end: 'CEP Fim',
        create_cep: 'Criar CEPs de Entrega',
        edit_cep: 'Editar CEPs de Entrega',
        cep_delivery_negative: 'CEPs Negativos de Entrega',
        cep_info_negative:
          'Aqui estão listados os CEP`s negativos de entregas juntamente com suas respectivas ações.',
        create_cep_negative: 'Criar CEP Negativo',
        edit_cep_negative: 'Editar CEP Negativo',
        delete_cep_negative: 'Deletar CEP Negativo',
      },

      user: {
        user: 'Usuários',
        here_are_listed_the_users_along_with_their_respective_actions:
          'Aqui estão listados os usuários juntamente com suas respectivas ações',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
        save_changes_edit:
          'Preencha as informações abaixo e clique no botão salvar para confirmar as alterações',
        picture: 'Foto',
        name: 'Nome',
        type: 'Tipo',
        registration: 'Cadastro',
        create_user: 'Criar usuário',
        edit_user: 'Editar usuário',
        profile_picture: 'Imagem do perfil',
        password: 'Senha',
        generate_pass: 'Gerar Senha',
        access_level: 'Grupo de acesso',
        select_a_access_level: 'Selecione um grupo de acesso',
        select_type: 'Selecione um tipo',
        active: 'Ativo',
        actions: 'Ações',
        discount_permission: 'Permissão para desconto na venda',
        discount_value: 'Valor do desconto máximo (%)',
        phone: 'Número do telefone',
      },

      groups: {
        groups: 'Grupos',
        group: 'Grupo',
        here_are_listed_the_groups_along_with_their_respective_actions:
          'Aqui estão listados os grupos juntamente com suas respectivas ações',
        name: 'Nome',
        Integrations: 'Integrações',
        means_of_payment: 'Meio de pagamento',
        products: 'Produtos',
        category: 'Categorias',
        subcategory: 'Subcategoria',
        indicators: 'Indicadores',
        requests: 'Pedidos',
        reports: 'Relatórios',
        messenger: 'Mensageria',
      },

      shifts: {
        shifts: 'Turnos',
        here_are_listed_the_shifts_for_each_day_of_the_week:
          'Aqui estão listados os turnos para cada dia da semana',
        monday: 'Segunda',
        tuesday: 'Terça',
        wednesday: 'Quarta',
        thursday: 'Quinta',
        friday: 'Sexta',
        saturday: 'Sábado',
        sunday: 'Domingo',
        start: 'Início',
        end: 'Fim',
      },

      account: {
        account: 'Conta',
        edit_account: 'Editar conta',
        registration_number: 'CNPJ',
        corporate_name: 'Razão social',
        customer_name: 'Nome',
        name_of_the_establishment: 'Nome do estabelecimento',
        subdomain: 'Subdomínio',
        code: 'Código',
        default_language: 'Idioma padão',
        default_currency: 'Moeda padrão',
        login_of_person_in_charge: 'Login do responsável da conta',
        name_of_person_in_charge: 'Nome do responsável',
        address: 'Endereço',
        zip_code: 'CEP',
        number: 'Número',
        neighbourhood: 'Bairro',
        city: 'Cidade',
        state: 'Estado',
        public_place: 'Logradouro',
        address_complement: 'Complemento',
        info: 'Para trocar o subdomínio entre em contato com suporte',
      },

      terms: {
        terms: 'Termos',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          'Aqui estão listados os termos de aceite da plataforma de vendas',
        create_your_term: 'Crie seu termo',
        term_name: 'Nome do termo',
        valid_until: 'Válido até',
        name: 'Nome',
        expirated: 'Expira',
      },

      payment_plans: {
        payment_plans: 'Planos de pagamento',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          'Aqui estão listados os planos de pagamento juntamente com suas respectivas ações',
        create_payment_plans: 'Criar Planos de pagamentos',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
        erp_integration: 'Integração ERP',
        integration_type: 'Tipo de Integração',
        select_an_integration: 'Selecione uma integração',
        card_flag: 'Bandeira do Cartão',
        flag: 'Bandeira',
        type: 'Tipo',
        erp_code: 'Código ERP',
        card_installment: 'Parcelamento',
        payment_plan: 'Plano de pagamento',
        installment: 'Parcela',
        time: 'Prazo',
        credit: 'Crédito',
        debit: 'Débito',
      },

      indicators: {
        indicators: 'Indicadores',
        orders: 'Pedidos',
        filters: 'Filtros',
        first: 'Inicio',
        end: 'Final',
        total_order: 'Total de pedidos',
        revenue: 'Receita',
        orders_by_location: 'Pedidos por modalidade',
        orders_by_month: 'Pedidos por mês',
        orders_by_day: 'Pedidos por dia',
        orders_by_hour: 'Pedidos por hora',
        orders_by_month_sector: 'Pedidos por mês e modalidade',
        orders_by_day_sector: 'Pedidos por dia e modalidade',
        orders_by_hour_sector: 'Pedidos por hora e modalidade',
        product: 'Produtos',
        categories: 'Categorias',
        sales_by_category: 'Vendas por categoria',
        revenue_by_category: 'Receita por categoria',
        average_ticket: 'Ticket médio',
        quantity: 'Quantidade',
        summary: 'Resumo',
        summaryAccess: 'Acessos',
        summaryAccessGroup: 'Áreas acessadas pelo período',
        summaryTimeAccessGroup: 'Total por horário',
        summaryIPAccessGroup: 'Total por usuário',
        summarySellerCart: 'Total de carrinhos criados por vendedor',
        period: 'Escolha um período',
        summaryTypeCust: 'Soma por tipo de custo',
        summaryComposition: 'Composição de custos',
        cost: 'Custos',
        customer: 'Clientes',
        seller_sales_by_category: 'Vendas do vendedor por categoria',
        summary_seller: 'Resumo do Vendedor',
        sellers_invoice: 'Faturamento do vendedor',
        comparative_sales_by_channel: 'Comparativo venda por canal',
        select_view: 'Selecione visão',
        sales: 'Vendas',
        attended_customers: 'Clientes atendidos',
        carts: 'Carrinhos gravados',
        sales_conversion: 'Convesão de vendas',
        mean_ticket: 'Ticket médio',
        sales_client: 'Comparativo/ Ranking de venda por clientes',
        sellers: 'Vendedores',
        summary_store: 'Resumo da Loja',
        accesses: 'Visitas',
        active_sellers: 'Vendedores ativos',
        revenue_store: 'Faturamento da Loja',
        revenue_group: 'Faturamento do Grupo',
        comparative_sales_by_seller: 'Comparativo venda por vendedor',
        comparative_sales_by_store: 'Comparativo de unidade de negócio',
        comparative_by_seller: 'Força comercial - Comparativo de vendedores',
        stores: 'Lojas',
        invoicing: 'Faturamento',
        active_stores: 'Lojas ativas',
        summary_group: 'Resumo do Grupo',
        invoice_by_store: 'Faturamento por loja',
        rank_sellers: 'Ranking de vendedores',
        rank_stores: 'Ranking de lojas',
      },

      customer_list: {
        customer_list: 'Lista de cliente',
        listed_customers: 'Aqui estão listados os clientes juntamente com suas respectivas ações.',
        select_time: 'Período dos pedidos realizados',
        name: 'Nome',
        first: 'Início',
        end: 'Fim',
        phone: 'Telefone',
        date: 'Data',
        detail: 'Detalhes do Cliente',
        total_profit: 'Lucro Total',
        total_itens: 'Total de Itens',
        total_orders: 'Total de Pedidos',
        order_between: 'Pedidos entre',
        order_detail: 'Detalhe do pedido',
        create: 'Criar Cliente',
        go_detail: 'Ver detalhes',
        product: 'Produto',
        value: 'Valor',
        quantity: 'Qtd.',
        total: 'Total',
        edit: 'Editar Cliente',
      },

      smart_order: {
        smart_order: 'Smart Order',
        message_warning_find_variation:
          'Ao realizar a pesquisa por nome se atente ao código de referência e o SKU, além do nome do produto.',
        service_classification: 'Classificação de Serviço',
        product: 'Produtos',
        referenceCode: 'Código de Referência',
        create_product: 'Criar Produto',
        here_are_listed_the_products_along_with_their_respective_actions:
          'Aqui estão listadas os produtos juntamente com suas respectivas ações',
        name: 'Nome',
        code: 'Código',
        color_code: 'Código da cor',
        crop_image: 'Recortar Imagem',
        use_original_image: 'Usar Imagem Original',
        select_image_format: 'Selecionar Formato da Imagem',
        use_selected_size: 'Usar Tamanho Selecionado',
        format_640x640: '640x640 (Quadrado)',
        format_600x900: '600x900 (Retrato)',
        product_data: 'Dados do Produto',
        mark: 'Marca',
        measurement_unit: 'Unidade de Medida',
        description: 'Descrição',
        technical_specification: 'Especificação Técnica',
        from: 'de',
        characters: 'caracteres',
        order: 'Ordem',
        product_image: 'Imagens do Produto',
        additional_images: 'Imagens Adicionais',
        product_groups: 'Grupos dos clientes para o Produto',
        categories: 'Categorias',
        here_are_listed_the_categories_along_with_their_respective_actions:
          'Aqui estão listadas as categorias juntamente com suas respectivas ações',
        image: 'Imagem produto',
        image_variation: 'Imagem variação',
        category: 'Categoria',
        category_parent: 'Categoria Pai',
        category_name: 'Nome da categoria',
        category_code: 'Código da categoria',
        perfil_image: 'Imagem do perfil',
        subcategories: 'Subcategorias',
        subcategory: 'Subcategoria',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          'Aqui estão listadas as subcategorias juntamente com suas respectivas ações',
        select_category: 'Selecione uma categoria',

        marks: 'Marcas',
        listened_marks: 'Aqui estão listadas as marcas juntamente com suas respectivas ações',

        measurements_units: 'Unidades de Medidas',
        listened_measurement:
          'Aqui estão listadas as unidades de medidas juntamente com suas respectivas ações',

        grid_products: 'Grades',
        listened_grid:
          'Aqui estão listadas as grades de produtos juntamente com suas respectivas ações',
        grid_name: 'Nome da grade',
        grid_code: 'Código',
        variation: 'Variação',
        grid: 'Grade',
        grids: 'Grades',

        variations: 'Variações',
        listened_variations:
          'Aqui estão listadas as variações de produtos juntamente com suas respectivas ações',
        modality: 'Modalidade',
        select_modality: 'Selecione uma modalidade',
        prod: 'Produto',
        select_product: 'Selecione um produto',
        no_variation: 'Produto sem variação',
        variation_product: 'Variação do produto',
        cost_price: 'Preço de Custo',
        sell_price: 'Preço de Venda',
        promotional_price: 'Preço Promocional',
        weight: 'Peso',
        height: 'Altura',
        width: 'Largura',
        depth: 'Profundidade',
        availability: 'Qual a disponibilidade do produto?',
        when_product_stock: 'Quando o produto acabar em estoque?',
        stock: 'Quantidade de produtos em estoque',
        min_stock: 'Estoque mínimo',
        price: 'Preço',

        catalogs: 'Catálogos',
        catalog: 'Catálogo',
        create_catalog: 'Criar Catálogo',
        edit_catalog: 'Editar Catálogo',
        catalog_link: 'Copiar Link do Catálogo',
        listened_catalogs:
          'Aqui estão listadas as catálogos de produtos juntamente com suas respectivas ações.',
        validity: 'Vigência',
        first: 'Início',
        end: 'Fim',
        search_products: 'Pesquisa de Produtos',

        product_status: 'Status do produto',
        sku: 'SKU/EAN',
        status_variation: 'Status da variação',
        specification: 'Especificação',
        price_promotional: 'Preço com desconto',
        inventory: 'Estoque',
        preparation_time: 'Tempo de preparo',
        service_title: 'Aqui estão listados os serviços juntamente com suas respectivas ações.',

        initial_hour: 'Horário inicial',
        final_hour: 'Horário final',

        date_start: 'Data Inicial',
        date_end: 'Data Final',

        add_group: 'Lista de Adicionais',
        no_add: 'Este produto ainda não está associado a nenhuma lista de adicionais.',
        already_add: 'Este produto está associado com as seguintes listas de adicionais.',
        associate_add: 'Associar a uma lista de adicionais',
        associate: 'Associar',
        choose_add: 'Escolha as listas de adicionais que serão associados com este produto.',
        no_group_add: 'Não há listas de adicionais disponíveis para associar.',
        remove_add: 'Remover associação',
        remove_add_text: 'Deseja remover a associação deste produto com a lista de adicionais "@"?',
        limit_range: 'Limite máximo de intervalos atingido',

        remove_add_soon:
          'Atenção! Está aba será removida em breve. Você poderá continuar gerenciando seus adicionais normalmente. Acesse a aba "Informações Básicas" e vá até a sessão "Grupo de Adicionais" para ver os adicionais desse produto.',
        create_image_ia: 'Proposta de Imagem IA',
        create_image_ia_text: 'Informe uma descrição do produto para gerar as imagens.',
        generate_images: 'Gerar imagens',
        generate_description: 'Personalizar descrição',
        generate_new_options: 'Gerar novas opções',
        save_image_selected: 'Salvar a foto selecionada',
        reference_image_ia: 'Imagem de referência',
        image_qtd_ia: 'Quantidade de imagens',
        save_img_ia: 'Salvar imagens',
        cancel: 'Cancelar',

        more_category: 'Ver mais configurações desta categoria',
        selectAll: 'Selecionar Todos',
        alterLot: 'Alterar Lote',
        edit_category:
          'Não é permitido trocar o vinculo de categoria, instruímos que crie uma nova categoria',

        catalog_image: 'Imagem do Catálogo',

        created: 'Criado em',
        updated: 'Atualizado em',
      },

      service_grid: {
        service_grid: 'Grades de Serviços',
        service_grid_single: 'Grades de Serviços',
        create_service_grid: 'Criar Grade de Serviços',
        edit_service_grid: 'Editar Grade de Serviços',
        service_grid_name: 'Nome da Grade de Serviços',
        service_grid_name_placeholder: 'Nome da grade de serviços',
        start_hour: 'Hora Inicial',
        start_hour_placeholder: '00:00',
        end_hour: 'Hora Final',
        end_hour_placeholder: '23:59',
        interval: 'Intervalo',
        interval_placeholder: '00:15',
        interval_tooltip: 'Intervalo de tempo entre pedidos',
        service_list: 'Lista de Serviços',
        service_placeholder: 'Serviços',
        missing_fields: 'Campos faltantes',
        missing_fields_message: 'Verifique se preencheu todos os campos!',
        grid_created: 'Grade cadastrada',
        grid_created_message: 'Cadastro realizado com sucesso!',
        grid_updated: 'Grade alterada',
        grid_updated_message: 'Edição realizada com sucesso!',
        error: 'Erro',
        error_create_message: 'Erro ao cadastrar a grade!',
        error_update_message: 'Erro ao alterar a grade!',
        fill_information_create:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
        save_changes_edit:
          'Preencha as informações abaixo e clique no botão salvar para confirmar as alterações',
        dashboard: 'Dashboard',
        title: 'Título',
        listed_grids:
          'Aqui estão listadas as grades de serviços juntamente com suas respectivas ações',
        grid_deleted: 'Grade deletada',
        grid_deleted_message: 'Deleção realizada com sucesso!',
        error_delete_message: 'Erro ao deletar a grade!',
        status: 'Status',
        grid_linked_warning: 'Grade vinculada',
        grid_linked_message:
          'Esta grade está vinculada a {count} formulário(s) de serviço(s) e não pode ser excluída.',
      },

      webapp: {
        webapp: 'Webapp',
        generate_qrcode: 'Gerar QR Code',
        personalize: 'Personalizar',
        settings: 'Configurações',
        link: 'Link para Webapp',

        webapp_data: 'Dados do Webapp',
        name: 'Nome',
        place: 'Local',
        product_pagination: 'Quantidade de produtos na paginação',
        logo_ninegrid: 'Logo do Ninegrid',
        light: 'Clara',
        dark: 'Escura',
        logo_totvs: 'Logo da TOTVS',
        use_icon_menu: 'Usar ícone no menu do Webapp',
        description: 'Descrição',
        icon: 'Ícone',
        color_setting: 'Configuração de cores',
        background_webapp: 'Fundo do Webapp',
        background_default_webapp: 'Cor Padrão do WebApp',
        background_header: 'Fundo do cabeçalho',
        text_header: 'Texto do cabeçalho',
        icon_header: 'Ícones do cabeçalho',
        background_footer: 'Fundo do rodapé',
        icon_footer: 'Ícones do rodapé',
        highlight_footer: 'Realce do rodapé',
        notification_cart: 'Notificação do carrinho',
        notification_text: 'Texto da notificação',
        home_button: 'Botão de início',
        text_home_button: 'Texto do botão de início',
        title_bar: 'Barra de título',
        text_title_bar: 'Texto da barra de título',
        icon_title_bar: 'Ícones da barra de título',
        text_category: 'Texto de categorias',
        webapp_button: 'Tema do Webapp',
        text_button: 'Texto dos botões',
        background_menu: 'Fundo do menu lateral',
        text_menu: 'Texto do menu lateral',
        price_card_background: 'Fundo da etiqueta de preço',
        price_card_font_color: 'Texto da etiqueta de preço',
        order_status: 'Status do pedido',
        order_active_status: 'Status do pedido ativo',
        text_order_active_status: 'Texto do status do pedido',
        info_cart: 'Informativo do carrinho',

        settings_webapp: 'Configurações do Webapp',
        type_delivery: 'Tipo de restrição de entrega',
        integration: 'Integração',
        select_integration: 'Selecione uma integração',
        payment_method_card: 'Meio de pagamento Cartão',
        payment_method_pix: 'Meio de pagamento Pix',
        payment_method_delivery: 'Meio de pagamento na entrega',
        consent_letter: 'Ativar carta de consentimento',
        product_no_stock: 'Venda de produtos sem estoque',
        show_subcategory: 'Exibir subcategoria',
        show_observation: 'Exibir observação',
        use_category_list: 'Exibir subcategorias e produtos em listas',
        use_category_list_v2: 'Exibir categorias e subcategorias em listas',
        use_product_list: 'Exibir produtos em listas',
        remove_shadow: 'Não adicionar sombra em categorias e catálogos',
        remove_show_mode: 'Remover modo de exibição',
        no_shadow: 'Não adicionar sombra em categorias',
        is_order_number: 'Ordenar categoria',
        order_number: 'Por ordem',
        order_category: 'Alfabética',
        show_layout: 'Exibir Layout',
        image_type: 'Estilo da imagem do produto',

        withdraw_fee: 'Taxa de Retirada',
        minimum_value: 'Valor Minimo do Pedido',
        seller_checkout: 'Modalidade do Checkout',

        no_sales: 'Não permitir vendas',
        safe_mode: 'Modo de segurança',
        time_safe_mode: 'Tempo de Sessão do Modo de segurança (em minutos)',
        limit_characteres_explanation:
          'Para lojas com integração Wintor ou Protheus, o recomendado é no máximo  50 caracteres.',
        limit_characteres: 'Limite de caracteres',

        skip_entry: 'Pular tela de entrada',
        payment_table: 'Pagamento na mesa',

        payment_card: 'Pagamento na comanda',

        slides_homePage: 'Imagens de Destaque HomePage',
        slides_initial: 'Imagens de Destaque Inicial',

        slides_not_found: 'Não foi encontrado nenhuma imagem do slider',

        externalLink: 'Link externo',
        buttonType: 'Tipo do Botão',
        ableUserLocation: 'Permitir busca de endereço por localização',
        ableWaiter: 'Desativar opção de chamar garçom',
        closeAccountButton: 'Tirar botão de fechamento de conta',
        emitNfChef: 'Emitir Nota Fiscal após pagamento do pedido ? (Balcão/Mesa/Comanda)',

        seller_cart_limit_time: 'Tempo de expiração do carrinho do vendedor por hora',
        seller_cart_limit_time_explanation:
          'Tempo máximo que o cliente pode usar o carrinho do vendedor',
        settings_webapp_aggregator: 'Personalizar',
        generate_qrcode_webapp_aggregator: 'Gerar QR code',
        qrcode_webapp_aggregator: 'Aplicativo Web',
        security_settings: 'Configurações de segurança',
        biometric_authentication: 'Autenticação Biométrica',
        code_scanner: 'Permitir leitor de código de barras e código QR',
        maximus_radius: 'Localização: Raio de proximidade permitido (em metros)',
        access_maximus: 'Número máximo de acessos por mesa',
        limit_time: 'Tempo de acesso para a comanda expirar (em minutos)',
        password: 'Senha para liberar o acesso',
        flag_discount: 'Formato da flag de desconto',
        color_flag_discount: 'Cor da tag',

        config_tags: 'Configurar Tags',
        promotional_tags: 'Tag promocional',

        pre_created: 'Pré cadastro',

        show_classification_button: 'Mostrar botão de visualizar todas as categorias',
        show_catalog_button: 'Mostrar botão de visualizar todos os catálogos',
        show_catalog_name: 'Mostrar nome dos catálogos',
        show_classification_name: 'Mostrar nome das categorias',
        show_mark_name: 'Mostrar marca dos produtos',
        show_stock_quantity: 'Mostrar estoque dos produtos',
        show_promotional_tags: 'Mostrar Etiqueta Promocional',
        show_product_sku: 'Mostrar sku do produto',
        tag_display_groups: 'Exibir grupos de tags na listagem de produtos',
        text_free_delivery: 'Texto personalizado para entrega ou retirada gratuita',
        tooltip_free_delivery:
          'Se preenchido, este texto será exibido quando a entrega ou retirada for gratuita. Se estiver vazio, será exibido o valor R$ 0,00',
        place_holder_free_delivery: 'Ex: Grátis',
        no_show_grid: 'Omitir grades de variações únicas do produto',
        explain_show_grid:
          'Oculta grades com variações únicas. Grades com múltiplas opções (ex: tamanhos G; GG) permanecerão visíveis na seleção de produto, porém ocultas em outros locais.',

        type_image: 'Tipo de Imagem',
        type_image_square: 'Quadrada',
        type_image_rectangle: 'Retangular',

        directlink: 'Link Direto',
        infoDirectLink:
          'Não obrigatório, apenas quando for necessário enviar diretamente para outra página ou site, maximo de 350 caracteres',

        block_add_in_limit: 'Bloquear adição no limite',

        family_fonte: 'Família da Fonte',
        rounding_images: 'Arredondamento das Imagens',
        rounding_bars: 'Arredondamento das Barras',
        color_icons: 'Cor dos ícones',
        color_icons_header_footer: 'Cor dos ícones no cabeçalho e rodapé',
        background_icon_button: 'Cor de fundo dos ícones',
        background_icon_custom: 'Cor personalizada',
        restaurant_list: 'Exibir restaurantes em listas',
        restaurant_display_mode: 'Alterar modo de exibição de restaurantes',
        icon_button_size: 'Tamanho dos ícones dos botões',
        shadow_image: 'Sombra da Imagem',
        black_logo_nine: 'Logo Ninegrid Escura',
        skip_loud_screen: 'Pular tela de carregamento',
        can_acesse_restaurant: 'Permitir visualização do catálogo (Loja/Restaurante) sem login',
        info_acesse_restaurant:
          'A ativação desta flag permite que o usuário acesse o menu/catálogo do restaurante ou loja sem a necessidade de login. Caso exista integração de pagamento ativa, o login será solicitado diretamente no próprio WebApp da loja ou restaurante, antes da etapa de pagamento, para que o pedido seja corretamente associado ao contexto do usuário (perfil/reserva) no sistema do hotel.',
      },

      integration: {
        integration: 'Integração',
        means_of_payment: 'Meio de Pagamento',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          'Aqui estão listados os meios de pagamentos juntamente com suas respectivas ações',
        PDV: 'Integração PDV',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          'Aqui estão listadas as integrações juntamente com suas respectivas ações',
        integration_name: 'Nome da Integração',
        type_of_integration: 'Tipo de Integração',
        actions: 'Actions',
        search: 'Search',
        example: 'Exemplo de Payload',

        loads: 'Cargas',
        name: 'Nome',
        price: 'Preço',
        stock: 'Estoque',
        measurements_units: 'Unidades de Medidas',
        grid: 'Grades',
        classifications: 'Categorias',
        products: 'Produtos',
        status_sync: 'Sincronismo de Status',
        marks: 'Marcas',
        orders: 'Pedidos',
        trigger_load: 'Acionar Carga',
        first: 'Início',
        end: 'Fim',
        load: 'Carregar',
        messenger: 'Mensageria',
        others: 'Outros',
        test: 'Deseja testar a integração',
        params_test: 'Ver parâmetros dessa integração',
        copy_params: 'Copiar parâmetros',
        result_test: 'Resultados do teste da integração',
        success_1: 'Sucesso! A integração',
        success_2: 'foi bem sucedida.',
        result_log: 'Log de resultado',
        copy_result: 'Copiar resultado',
        search_result: 'Pesquisar nos resultados',
        error_1: 'A integração',
        error_2: 'retornou um erro. Confira o log abaixo para mais informações.',

        success_food_1: 'Sucesso! A integração',
        success_food_2: 'foi bem sucedida.',
        error_food_1: 'A integração',
        error_food_2: 'retornou offline.',

        integrationPrint: 'Testar Conexão',
      },

      reports: {
        orders: 'Pedidos',
        order_report: 'Relatório de Pedidos',
        order_list: 'Lista de Pedidos',
        first: 'Início',
        end: 'Fim',
        firstTime: 'Hora inicial',
        endTime: 'Hora final',
        orders_between: 'Pedidos entre',
        order_number: 'Número do Pedido',
        date: 'Data',
        consumer: 'Consumidor',
        modality: 'Modalidade',
        total_value: 'Valor',
        cancel_order: 'Cancelar pedido',

        products: 'Produtos',
        quantity: 'Quantidade',
        qtt: 'Qtd',
        product: 'Produto',
        value: 'Valor',
        total: 'Total',
        order_status: 'Status do Pedido',
        payment_method: 'Forma de pagamento',
        billing_address: 'Endereço de cobrança',
        product_value: 'Valor dos produtos',
        discount: 'Desconto',
        order: 'Pedido',

        listened_logs: 'Aqui estão listados os logs juntamente com suas respectivas ações.',
        methods: 'Métodos',
        log_details: 'Detalhes do Log',

        withdraw: 'Retirada',
        delivery: 'Entrega',
        table: 'Mesa',
        counter: 'Balcão',
        responsible_withdraw: 'Responsável pela retirada',
        responsible_delivery: 'Responsável pela recepção',
        address_withdraw: 'Endereço de retirada',
        address_delivery: 'Endereço de entrega',
        seller: 'Vendedor',
        seller_link: 'Link do Vendedor',
        external_code: 'Número externo',
        payment: 'Pagamento',
        internal_delivery: 'Entrega Interna',
        origin: 'Origem',
        historial: 'Histórico do pedido',
        approval_moment: 'Data e hora da aprovação',
        id: 'Código da Reserva',
        pluginspace: 'Hotel',
        hotel: 'Pedido associado ao hotel',
        document: 'Documento da Reserva',
        room: 'Código do Quarto',
        status_payment: 'Status do pagamento',
        authorization_code: 'Código de autorização',
        transaction: 'ID da transição',
        made_in: 'Realizado em',
        send_method: 'Método de envio',
        send_date: 'Data de envio',
        estimated_delivery: 'Previsão de entrega',
        freight: 'Frete',
        tracking_code: 'Código de rastreamento',
        website: 'Abrir site de rastreamento',
        label: 'Imprimir etiqueta de envio',
        payment_delivery: 'Pagamento na entrega',
        payment_money: 'Pagamento em dinheiro',
        change_money: 'Troca',
        label_code: 'Etiqueta',
        label_website: 'Abrir site da etiqueta',
        declaration_code: 'Declaração',
        declaration_website: 'Abrir site da declaração',
        height: 'Altura (cm)',
        width: 'Largura (cm)',
        length: 'Comprimento (cm)',
        weight: 'Peso (kg)',
        send_text: 'Forma de envio escolhida pelo cliente: ',
        success_label: 'Sua etiqueta de envio foi gerada com sucesso.',
        continue: 'Continuar',
        confirm: 'Confirmar',
        change_multiple_status: 'Alterar status de múltiplos pedidos',
        change_status_text: 'Deseja alterar o status dos pedidos abaixo?',
        new_status: 'Novo status',
        change_status: 'Alterar status',

        synkar: 'Automação',
        invalid_data: 'Por favor, selecione as datas de início e fim.',

        details: 'Detalhes',
      },

      imports: {
        imports: 'Importações',
        import_image_product: 'Importações de Imagens para Produtos',
        import_image_category: 'Importações de Imagens para Categorias',
        listened_import_product:
          'Aqui estão listadas as importações de imagens para produtos juntamente com suas respectivas ações.',
        no_upload_images: 'Não realizar upload de imagens',
        first: 'Início',
        end: 'Fim',
        total_products: 'Total de Produtos',
        sync_products: 'Produtos Sincronizados',
        import_image_sku: 'Importações de Imagens para Variações',
        listened_import_sku:
          'Aqui estão listadas as importações de imagens para variações juntamente com suas respectivas ações.',
        verify_verification: 'Verificação da variação',
        product_code: 'Código do produto',
        code: 'Código',
        total_variations: 'Total de Variações',
        sync_variations: 'Variações Sincronizadas',
        total_categories: 'Total de Categorias',
        sync_categories: 'Categorias Sincronizadas',
        problem_title: 'Imagens com problema',
        images_success: 'imagens foram enviadas com sucesso.',
        images_error: 'imagens apresentaram problema e não foram enviadas.',
        file: 'Arquivo',
        status: 'Status da importação',
        new_import: 'Realizar nova importação',
        import_xls: 'Importar imagens com arquivo XLS',
        import_repo: 'Importar imagens do Google Drive ou Dropbox',
        steps: 'Passo a passo para importação',
        step_1: '1. Coloque todas as imagens em um servidor web público.',
        step_2: '2. Verifique se o servido é público e acessível via web.',
        step_3: '3. Faça o download do nosso arquivo XLSX em branco.',
        step_4: '4. Preencha com os dados do seu banco de imagens.',
        step_5: '5. Faça o upload do arquivo preenchido.',
        step_1_repo:
          '1. Verifique se a pasta da loja está criada como "fotos_loja_<identificador da loja>".',
        step_2_repo: '2. Crie a pasta "produtos" dentro da pasta da sua loja.',
        step_2_repo_sku: '2. Crie a pasta "variacoes" dentro da pasta da sua loja.',
        step_2_repo_category: '2. Crie a pasta "categorias" dentro da pasta da sua loja.',
        step_3_repo: '3. Confirme se o os arquivos estão como "<codigo do produto>.<extensão>".',
        step_3_repo_sku: '3. Confirme se o os arquivos estão como "<sku>.<extensão>".',
        step_3_repo_category:
          '3. Confirme se o os arquivos estão como "<codigo da categoria>.<extensão>".',
        step_4_repo: '4. Caso seja um produto adicional, verificar se possui "_<numero>".',
        step_4_repo_sku:
          '4. Confirme que a variação é uma imagem e se está na extensão JPG ou PNG.',
        step_4_repo_category:
          '4. Confirme que a categoria é uma imagem e se está na extensão JPG ou PNG.',
        step_5_repo: '5. Confirme que o produto é uma imagem e se está na extensão JPG ou PNG.',
        download: 'Baixar o arquivo XLSX em branco',
        download_problems: 'Exportar relatório',
        upload: 'Enviar arquivo',
        upload_anex: 'Anexar arquivo',
        import_dropbox: 'Importar com Dropbox',
        import_drive: 'Importar com Google Drive',
        spreadsheet: 'Planilha',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: 'Tipo',
        type_resize: 'Tipo de Resize',
        agroup_color: 'Agrupar fotos por cor',
        banner_size: 'Tratar categoria N1 como banner',
        select_dimensions: 'Selecione as dimensões',
        square: 'Tratar com 640x640',
        vertical: 'Tratar com 600x900',
      },

      sms: {
        sms: 'SMS',
        listened_sms:
          'Aqui estão listadas as mensagens (SMS) juntamente com suas respectivas ações.',
        order: 'Ordem',
        name: 'Nome',
        message: 'Mensagem',
        markers: 'Os marcadores [pedido] e [status] devem estar na mensagem',
        waiting: 'Aguardando',
        opened: 'Em aberto',
        ready: 'Pronto',
        refused: 'Recusado',
        message_hotel: 'SMS Hotel',
        listened_sms_hotel:
          'Aqui estão listadas as mensagens do hotel juntamente com suas respectivas ações.',
        status_hotel: 'Status e Notificação',
        listened_status_hotel:
          'Aqui estão listados os status e notificações do hotel juntamente com suas respectivas ações.',
        edit_status: 'Editar status',
        edit_status_hotel: 'Editar status hotel',
        notification: 'Notificação',
        email_group_status: 'Status',
        email_group_service_forms: 'Formulários de Serviço',
        email_group_services: 'Serviços',
        email_group_services_booking: 'Reservas de Serviços',
        send_email_simple: 'Enviar e-mail',
        status_label: 'Status',
        write_message_status: 'Escreva aqui uma mensagem para este status',
        markers_hotel:
          'Os marcadores [pedido], [status], [cliente], [quarto], [hotel] devem estar na mensagem',
        status_updated: 'Status atualizado',
        status_update_success: 'Atualização realizada com sucesso!',
        status_update_error_title: 'Erro',
        status_update_error: 'Erro ao atualizar o status!',
      },

      multichannel: {
        multichannel: 'Multicanal',
        listened_multichannel:
          'Aqui estão listadas as configurações de multicanal juntamente com suas respectivas ações.',
      },

      feed: {
        content: 'Conteúdo',
        title: 'Título',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Preencha as informações abaixo e clique no botão criar para salvar as alterações',
      },
      feedCategory: {
        feedCategory: 'Categoria do Conteúdo',
      },

      structured_content: {},

      queue: {
        index: 'Fila de espera',
        menage: 'Gerenciamento',
        config: 'Configurações da fila de espera',
        able: 'Permitir fila de espera',
        link: 'Link da fila de espera:',
        limit_people: 'Número máximo de pessoas',
        limit_people_text: 'Limite da fila de espera',
        limit_time: 'Limite de tempo para exibir alerta',
        limit_time_text: 'Tempo máximo em minutos para considerar atrasado',
        image_title: 'Definição de imagens',
        image_text:
          'O sistema de fila exibe 2 imagens. Faça upload de fotos do seu restaurante, ou selecione fotos padrão abaixo. As fotos enviadas serão ajustadas para o tamanho de 350x250 pixels.',
        image: 'Imagem',
        position: 'Posição',
        time: 'Tempo de espera',
        people: 'pessoas',
        cancel: 'Cancelamento',
        cancel_text: 'Deseja remover essa pessoa da fila de espera?',
        cancel_button: 'Remover',
        confirm: 'Confirmação',
        confirm_text: 'Deseja confirmar a chegada do reservante?',
        confirm_button: 'Confirmar chegada',
        empty: 'Não há lista de espera no momento',
        confirm_all: 'Confirmar todas',
        cancel_all: 'Cancelar todas',
        observation: 'Observação',
        use_terms: 'Ativar termos de consentimento',
        total_people: 'Total de pessoas por grupo',
        total_people_text: 'Limite da fila de espera por grupo',
        all: 'Todos',
        in_queue: 'Na fila',
        preferential: 'Preferencial',
        confirmed: 'Confirmado',
        removed: 'Recusado',
        show: 'Exibir',
        show_text: 'Últimas @ horas',
        yes: 'Sim',
        no: 'Não',
        add: 'Adicionar Cliente a Fila',
        use_location: 'Permitir localização?',
        use_menu: 'Deseja utilizar cardápio?',
        use_ninegrid_menu: 'Utilizar o cardápio Ninegrid?',
        external_menu_link: 'Informe o link do cardápio',
        edit: 'Editar Cliente na Fila',
      },
      booking: {
        index: 'Reserva',
        config: 'Configurações da reserva',
        able: 'Permitir reserva',
        link: 'Link da reserva:',
        image_title: 'Definição de imagens',
        image_text:
          'O sistema de reservas exibe 2 imagens. Faça upload de fotos do seu restaurante, ou selecione fotos padrão abaixo. As fotos enviadas serão ajustadas para o tamanho de 350x250 pixels.',
        image: 'Imagem',
        days_week: 'Dias da semana',
        booking_day: 'Permitir reservas neste dia?',
        booking_day_text: 'Defina abaixo os horários liberados para reservas.',
        booking_day_subtext:
          'Ao selecionar um horário será definida uma janela de 1 hora. Exemplo: ao selecionar 19:00 as pessoas poderão fazer reservas entre 19:00 e 20:00.',
        max_people: 'Número máximo de pessoas por reserva',
        max_people_text: 'É o tamanho máximo de um grupo de pessoas que pode fazer uma reserva',
        expiry_time: 'Tempo máximo até a reserva expirar',
        expiry_time_text: 'Tempo em minutos para aguardar a chegada do reservante',
        day_confirm: 'Exigir confirmação no dia',
        day_confirm_text: 'Usuário precisa confirmar a reserva na data escolhida',
        payment_confirm: 'Exigir pagamento antecipado na reserva',
        value_payment_confirm: 'Valor do pagamento antecipado',
        week: 'Semana',
        month: 'Mês',
        year: 'Ano',
        use_terms: 'Ativar termos de consentimento',
        empty: 'Não há reservas no momento',
        use_time: 'Permitir reserva por período',
        time: 'Duração da reserva (HH:mm)',
        use_cancel: 'Permitir cancelamento',
        time_cancel: 'Prazo limite para cancelamento da reserva (HH:mm)',
        time_change: 'Prazo limite para alteração da reserva (HH:mm)',
        use_change: 'Permitir alteração de horário da reserva',
      },
      booking_day: {
        booking: 'Reservas do dia',
        date: 'Data',
        people: 'pessoas',
        expiry: 'Expira em',
        cancel_title: 'Cancelamento',
        cancel_subtitle: 'Deseja cancelar essa reserva?',
        cancel_button: 'Cancelar reserva',
        confirm_title: 'Confirmação',
        confirm_subtitle: 'Deseja confirmar a chegada do reservante?',
        confirm_button: 'Confirmar chegada',
        accessibility_needs: 'Necessidade de Acessibilidade',
        accessibility_elderly: 'Apoio ao Idoso',
        accessibility_wheelchair: 'Cadeirante',
        accessibility_physical: 'Deficiente Físico',
        filter_accessibility: 'Filtrar por Acessibilidade',
        all_accessibility: 'Todas as necessidades',
      },
      booking_report: {
        report: 'Relatórios',
        search: 'Busca de reservas',
        time: 'Selecione o período',
        date_start: 'Data início',
        date_end: 'Data fim',
        confirm: 'Confirmação',
        noShow: 'No show',
        confirmed: 'Reservas confirmadas',
        canceled: 'Reservas canceladas',
        open: 'Em aberto',
        map: 'Mapa de reservas',
        booking: 'reservas',
        accessibility_stats: 'Estatísticas de Acessibilidade',
        accessibility_total: 'Total com necessidades',
        accessibility_percentage: 'Percentual',
      },
      booking_report_management: {
        management: 'Gestão de reservas',
        search: 'Busca de reservas',
        phone: 'Telefone',
        date_start: 'Data início',
        date_end: 'Data fim',
        today: 'Hoje',
        tomorrow: 'Amanhã',
        calendar: 'Calendário',
        see_all: 'Ver todas',
        people: 'pessoas',
        noShow: 'No show',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        open: 'Em aberto',
        search_text: 'Resultados pela pesquisa de telefone ou seleção de data',
      },
      environment: {
        map: 'Mapa de ambientes',
        environment: 'Ambiente',
        index: 'Ambientes',
        name: 'Nome do ambiente',
        tables: 'Número de mesas',
        seats_available: 'Total de lugares disponíveis',
        actions: 'Ações',
      },
      week_day: {
        sun: 'Domingo',
        mon: 'Segunda',
        tue: 'Terça',
        wed: 'Quarta',
        thur: 'Quinta',
        fri: 'Sexta',
        sat: 'Sábado',
      },
      week_day_full: {
        sun: 'Domingo',
        mon: 'Segunda-feira',
        tue: 'Terça-feira',
        wed: 'Quarta-feira',
        thur: 'Quinta-feira',
        fri: 'Sexta-feira',
        sat: 'Sábado',
      },
      checkout: {
        title: 'Dados do Cliente',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Aqui estão listados os campos necessários para a criação do cliente.',
        active_mandatory: 'Campo Mandatório',
        active_visibility: 'Campo Visível',
      },

      liveShop: {
        liveShop: 'Live Commerce',
        liveShop_list:
          'Aqui estão listados os eventos de Live Commerce juntamente com suas respectivas ações.',
        create: 'Criar Live Commerce',
        edit: 'Editar Live Commerce',
        dateInit: 'Início',
        hourInit: 'Hora de Início',
        dateEnd: 'Fim',
        hourEnd: 'Hora de Término',
        status: 'Status',
        initDate: 'Data e Hora de Início',
        fimDate: 'Data e Hora de Término',
        name: 'Nome',
        variations: 'Variações do Produto',
        search_products_Attentions:
          'Os Produtos e Variações retornados devem possuir status ativado, possuir preço, estoque e imagem',
        alert_delete: 'Não é possivel remover uma Live quando começou ou foi finalizada!',
        alert_Edit: 'Não é possivel editar uma Live quando começou ou foi finalizada!',
        delete: 'Excluir Live Commerce',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Erro código do telefone Pagseguro',
        pagseguroPaymentErrorCountry: 'Erro do código País Pagseguro',
        pagseguroPaymentErrorEmail: 'Erro do email Pagseguro',
        authenticatePagseguro: 'Autenticação Pagseguro',
        pagseguroPayment: 'Pagamento Pagseguro',
        pagseguroPaymentCatch: 'Pagamento Pagseguro',
        pagseguroPaymentResponse: 'Resposta do pagamento Pagseguro',
        pagseguroPaymentTransactions: 'Transação do pagamento Pagseguro',
        pagseguroReturnPayment: 'Retorno do pagamento Pagseguro',
        paymentPixPagseguro: 'Pagamento Pix Pagseguro',

        pagseguroPaymentGateway: 'Gateway de pagamento Pagseguro',
        getAuthPagseguroEmailSpace: 'Autenticação do Pagseguro por email',
        getOneApplicationClientId: 'Pegar aplicação do cliente Pagseguro',
        createAuthPagseguro: 'Criar autenticação Pagseguro',
        generatePublicKeyPagseguro: 'Gerar chave pública Pagseguro',
        updateCodeRedirectApplication: 'Atualização do Codigo da aplicação Pagseguro',
        deleteAuthPagseguroByEmail: 'Remover autenticação Pagseguro',
        createPluginconfig: 'Configuração do plugin',

        //Totvs pagamento HUB
        refundTotvs: 'Estorno via Totvs',
        refundPayCard: 'Estorno via Totvs por cartão',
        paymentTotvs: 'Pagamento via Totvs',
        paymentPixTotvs: 'Pagamento Pix via Totvs',

        //Card Structure
        sendUnregisteredCardBrands: 'Bandeira não encontrada',
        cardStructure: 'Estrutura do cartão',
        cardStructureInvalidPlugin: 'Plugin inválido para o gateway',
        cardStructureGatewayError: 'Erro do cartão para o gateway',
        cardStructureData: 'Dados do Cartão',
        cardStructureError: 'Erro dos Dados cartão',
        cardStructureDecrypt: 'Descriptografia do cartão',
        cardStructureFields: 'Campos do Cartão',
        refundCard: 'Estorno do Cartão',

        //Status
        analysisSatusOrder: 'Status do pedido para análise',
        statusPayPix: 'Status Pix',

        // Tipos de campos exibidos nas respostas
        types: {
          title: 'Título',
          text: 'Texto',
          textarea: 'Área de Texto',
          stars: 'Avaliação',
          checkbox: 'Caixa de Seleção',
          radio: 'Escolha Única',
          select: 'Seleção',
          number: 'Número',
          date: 'Data',
          time: 'Horário',
          image: 'Imagem',
          link: 'Link',
        },
        //Antifraude
        analyseAntifraud: 'Análise do Antifraude',
        dataClearSale: 'Dados do ClearSale',
        statusAnalysis: 'Status da Análise',

        //estoque
        addSkuInventory: 'Adicionar ao estoque',
        subtractSku: 'Remover do estoque',
        viewCargoHistory: 'Visualizar histórico de carga',
        viewCargoHistoryBySku: 'Visualizar histórico de carga por SKU',

        // Order-Pedido
        sendOrderIn: 'Envio do pedido',
        cancelOrder: 'cancelar Pedido',
        sendOrder: 'Enviar Pedido',
        sendOrderRefund: 'Estorno do Pedido',
        sendOrderError: 'Erro ao enviar pedido',
        sendOrderResultRefund: 'Resultado do estorno do pedido',
        sendOrderResultData: 'Resultado do envio do pedido',
        sendOrderAntifrud: 'Antifraude no envio do pedido',
        sendOrderPaymentStruct: 'Estrutura do pagamento do pedido',

        sendOrderDescryptor: 'Descriptografia do Pedido',
        sendOrderStatus: 'Status do pedido',
        sendOrderConfigNotFound: 'Configuração do envio do pedido',
        sendOrderMandatoryCustomer: 'Cliente do pedido',
        sendOrderMandatory: 'Estruura mandatória do pedido',
        sendOrderResultGateway: 'Resultado do envio ao gateway',
        OrderFashionService: 'Serviço de pedido Fashion',
        OrderFashionServiceError: 'Erro no serviço de pedido Fashion',
        cartOrderLive: 'Carrinho do pedido Live',
        cartOrderLiveError: 'Erro no carrinho do pedido Live',
        sendOrderErrorGeral: 'Erro no pedido',
        sendPushNotification: 'Enviar notificação push',

        //Pre-Order
        preOrderStatusPix: 'Status do Pré pedido via pix',
        processQueuePreOrder: 'Processamento da fila do pré order',
        getAllPreOrderBySpace: 'Pegar todos os pré pedidos por pluginspace',
        sendPreOrder: 'Envio do Pré pedido',
        makeOrderTransparent: 'Verificação pedido',
        statusPreOrder: 'Atualização do Status do Pix do Pré pedido',
        preOrderStatusCanceledPix: 'Cancelar Pré pedido via Pix',

        //Totvs Wintor
        buildOrderTotvsWinthor: 'Criar Pedido',
        sendOrderWinthor: 'Envio do pedido para Totvs',
        sendCustomerOrderWinthor: 'Envio do cliente para Totvs',

        //Totvs Varejo
        buildOrderTotvsVarejo: 'Criar Pedido',
        setConfimTicket: 'Confirmação de Ticket',
        SyncOrderLive: 'Sincronização de Pedidos',
        ObterProdutos: 'Obter Produtos',
        taskPrice: 'Carga de Preço',
        calculationPromotion: 'Cálculo de Promoção',
        PayloadCalcPromotion: 'Payload Cálculo de Promoção',

        //Totvs Moda
        changeStatus: 'Troca de Status',
        sendOrderFashion: 'Envio do pedido para Totvs',
        sendCustomerFashion: 'Envio do cliente para Totvs',
        searchPersonTotvsByCPF: 'Pesquisa de Cliente Totvs',
        sendErrorCustomerFashion: 'Erro no envio do Cliente para o Fashion',
        buildCustomerTotvsFashion: 'Criação de cliente na Totvs',
        ResumeSnyOrderFashion: 'Resumo sincronia com o Fashion',
        changeStatusFashion: 'Trocar Status',
        buildOrderTotvsFashion: 'Criar Pedido Fashion',

        //Totvs Food
        updateStatusOrderFoodIntegration: 'Troca de Status',
        buildOrderTotvsFood: 'Criar Pedido',
        changeStatusOrderFood: 'Troca de Status',
        sendOrderTotvsFood: 'Envio do pedido para a Totvs',
        confirmMenu: 'Menu Confirmado',
        getMenu: 'Pegar Menu Totvs',

        //Totvs Live
        sendCustomerLive: 'Envio do Cliente Live',
        sendOrderLive: 'Envio Pedido Live',

        //Synkar
        updateStatusOrderSynkar: 'Atualização Pedido Synkar',
        sendingOrderMessageSynkar: 'Envio Mensageria Synkar',
        responseOrderMessageSynkar: 'Resposta Mensageria Synkar',
        sendingOrderSynkar: 'Envio Synkar',
        responseOrderSynkar: 'Resposta Synkar',

        //SDS
        sdsGetOrders: 'Pegar os pedidos SDS',
        sdsOrderIn: 'Envio dos pedidos SDS',
        sdsOrderInResult: 'Envio do pedido ao SDS',
        sdsSyncCardapio: 'Sincronia do cardapio com o SDS',
        'sendOrderfood-sdsOrderIn': 'Erro em enviar pedido SDS',

        //S3
        createRoute: 'Criar Rota S3',
        getStatusfiftythree: 'Status Rota 53',
        updateDistribution: 'Atualiza Distribuição',
        deleteRoute: 'Deleta Rota S3',
        deleteDistribution: 'Deleta Distribuição',

        //Erede
        refundErede: 'Estorno Erede',
        paymentErede: 'Pagamento Erede',

        //Cielo
        refundCielo: 'Estorno Cielo',
        paymentCielo: 'Pagamento Cielo',

        //Pagseguro
        refundPagseguro: 'Estorno Pagseguro',
        getApplicationPagseguro: 'Gateway Aplicação Pagseguro',

        //pagamento offline
        paymentOffline: 'Pagamento na entrega',

        //Geral
        chargeSyncOrderErro: 'Erro na Sincronia de Status',
        chargeSyncOrder: 'Sincronia de Status',
        chargeProductLive: 'Sincronia de Produtos do Live',
        chargeBalanceLive: 'Sincronia de Estoque do Live',
        chargePriceLive: 'Sincronia de Preços do Live',
        chargeProductLiveErro: 'Erro na Sincronia de Produtos do Live',
        chargeBalanceLiveErro: 'Erro na Sincronia de Estoque do Live',
        chargePriceLiveErro: 'Erro na Sincronia de Preços do Live',

        chargeProduct: 'Sincronia de Produtos',
        chargeBalance: 'Sincronia de Estoque',
        chargePrice: 'Sincronia de Preços',
        chargeProductErro: 'Erro na Sincronia de Produtos',
        chargeBalanceErro: 'Erro na Sincronia de Estoque',
        chargePriceErro: 'Erro na Sincronia de Preços',

        taskBalanceIntegration: 'Integração da Carga de estoque',
        taskBalanceCharge: 'Carga de estoque iniciada',
        SnyOrder: 'Sincronismo de status de pedido',
        syncronyzePriceInteration: 'Carga de Preço',
        syncronyzePrice: 'Sincronização de Preço',
        chargeClassification: 'Carga de categoria e subcategoria',
        chargeGrid: 'Carga de grade',
        chargeGridItens: 'Itens de Carga de grade',
        chargeMeasure: 'Carga de unidade de medida',
        deleteAllProducts: 'Deletar todos os Produtos',

        chargeGridToken: 'Token para carga de Grade',
        classificationChargeToken: 'Token para carga de Classificação',
        syncronyzeBalanceToken: 'Token para sincronização de Estoque',
        syncronyzePriceToken: 'Token para sincronização de Preço',
        chargeMeasureToken: 'Token para carga de Unidade de Medida',
        taskClassificationBySpace: 'Carga de Classificação',
        syncStatusOrderPayload: 'Payload de Sincronização de Status do Pedido',
        syncStatusOrder: 'Sincronização de Status do Pedido',
        syncStatusOrderToken: 'Token de Sincronização de Status do Pedido',
        syncronyzeBalancePayload: 'Payload de Sincronização de Estoque',
        syncronyzeBalance: 'Sincronização de Estoque',
        taskBalanceChargeBySpace: 'Carga de Estoque',
        syncronyzePricePayload: 'Payload de Sincronização de Preço',
        priceSkuVariationItens: 'Preço dos Itens da Variação',
        configSyncOrderBySpace: 'Configuração de Sincronização de Pedido',
        configSyncOrder: 'Configuração de Sincronização de Pedido',
        taskGridChargeBySpace: 'Carga de Grade',
        productChargeInternal: 'Carga de Produto',
        taskChargeProductBySpace: 'Carga de Produto',
        skuLocationVariation: 'Sincronismos de Variação por Localização',
        stockSkuVariation: 'Sincronismos de Variação',
        taskPriceChargeBySpace: 'Carga de Preço por Pluginspace',

        automaticChargeBalance: 'Sinc Automático de Estoque',
        automaticChargePrice: 'Sinc Automático de Preço',
        automaticChargeClassification: 'Sinc Automático de Classificação',
        automaticTaskGridCharge: 'Sinc Automático de Grid',
        automaticTaskMeassure: 'Sinc Automático de Unid. Medidas',
        automaticSnyOrder: 'Sinc Automático Status de Pedidos',
        chargeMeasureItens: 'Itens de carga de Unid Medida',
        searchMeasurementAll: 'Carga de unidade de medida',
        taskGridCharge: 'Carga de Grade',
        taskMeassure: 'Carga de unidade de medida',

        getCredential: 'Obter Token',
        LoadPricePerList: 'Carga de Preços',
        processPriceList: 'Processamento da Lista de Preços',
        updateProductKit: 'Atualização de Produtos',
        UpdateProductSingle: 'Atualização de Produtos',
        updateProductStatus: 'Atualização de Status de Produto',
        taskBalanceIntegrationLink: 'Link de integração de estoque',
        taskPriceIntegrationLink: 'Link de integração de preço',
        taskProductIntegrationLink: 'Link de integração de produto',
        token: 'Obtenção de Token',
        automaticChargeProduct: 'Carga automática de productos',

        //Desconto Ninegrid
        calculateDiscount: 'Calculo do desconto no ninegrid',
        sendDiscountNinegrid: 'Desconto Ninegrid',

        //Customer Cart
        updateCustomerCartStatus: 'Update do carrinho do Cliente',

        //Cliente
        createCustomer: 'Criação do Cliente',
        validCodeCustomer: 'Código de validação do Cliente',

        //clearSale
        statusAnalisis: 'Analise do Status',
        antifraudValidation: 'Validação da antifraude',
        clearSale: 'ClearSale Garantido',
        searchOrderStatusClearSale: 'Pesquisa Status ClearSale',

        printLabelFrenet: 'Etiqueta Frenet',
        changeStatusFrenet: 'Troca de status Frenet',
        callWaiter: 'Chamar Garçom',
        paymentTable: 'Pagamento na mesa',

        // Geracao de nota Fiscal Do Chef
        generateNfOrderFood: 'Gerar nota fiscal do pedido',
        getNotaFiscalChef: 'Recuperar nota fiscal do Chef',
        finishOrderFood: 'Checagem prévia à nota fiscal',

        // Log de erro do pedido Chef
        buildCardData: 'Erro ao criar dados para Comanda',
        buildTableData: 'Erro ao criar dados para Mesa',
        buildTablePaymentData: 'Erro ao criar dados para Pagamento Mesa',
        buildCounterData: 'Erro ao criar dados para Balcão',
        buildDeliveryData: 'Erro ao criar dados para Entrega/Retirada',

        generateCustomerWholeSalerByCSV: 'Gerar cliente atacadista por CSV',

        validateStockWholeSaleCart: 'Alerta de pedido',
        validateWholeSaleCart: 'Alerta de pedido',

        chargeImageService: 'Serviço de carga de imagens',

        webhookNisRedis: 'Limpeza do Redis da Loja',

        /*Envio de email  */
        sendEmailWelcome: 'Enviar email de boas-vindas',
        sendEmailOrderNotification: 'Enviar notificação via email de pedido',
        sendEmailAccountNotification: 'Enviar notificação via email de conta',
        createCustomerLogin: 'Enviar email de criação de login de cliente',
      },

      copy: {
        definition: 'Definição de Pluginspace',
        origin: 'Selecione a Pluginspace de origem',
        destination: 'Selecione a Pluginspace de destino',
        configurations: 'Configurações da cópia',
        store: 'Configurações da Loja',
        deliveryFee: 'Taxa de entrega',
        shifts: 'Turnos',
        paymentPlans: 'Planos de pagamento',
        clientData: 'Dados do Cliente',
        account: 'Configurações da Conta',
        groups: 'Grupos',
        terms: 'Termos',
        webapp: 'Webapp',
        webappConfig: 'Configurações',
        webappPersonalize: 'Personalização',
        whatsappweb: 'WhatsApp Web',
        whatsappwebConfig: 'Configurações',
        whatsappwebPersonalize: 'Personalização',
        integrations: 'Integrações',
        integrationPayment: 'Meios de pagamento',
        integrationPdv: 'PDV',
        integrationMessaging: 'Mensageria',
        integrationOthers: 'Outros',
        button: 'Copiar Pluginspace',
      },

      payment: {
        methods: 'Meios de pagamento',
        method: 'Forma de pagamento',
        gateway: 'Gateway de pagamento',
        card: 'Cartão de crédito',
        debit: 'Cartão de débito',
        food: 'Vale alimentação',
        pix: 'Pix',
        others: 'Outros',
        pay_money: 'Dinheiro',
        config: 'Configurações',
        add: 'Configurar meio de pagamento',
        back: 'Voltar para os gateways de pagamento',
        basic_settings: 'Configurações básicas',
        modalities: 'Modalidades onde este meio de pagamento será utilizado',
        add_payment: 'Adicionar forma de pagamento',
        code_erp: 'Código ERP',
        installments: 'Número de parcelas',
        edit_payment: 'Editar forma de pagamento',
        delete: 'Excluir forma de pagamento',
        money: 'Pagamento em dinheiro',
        max_installments: 'Qual o número máximo de parcelas?',
        min_value_installments: 'Qual o valor mínimo para as parcelas?',
        confirm: 'Confirmar exclusão',
        delete_payment: 'Deseja excluir a forma de pagamento',
        change: 'Deseja realizar esta troca?',
        inative: 'Deseja inativar esta forma de pagamento?',
        inative_change: 'Deseja ativar esta forma de pagamento e inativar a antiga?',
        motive: 'Por favor informe o motivo',
        /* usado para desconto */
        config_descount_payment: 'Configuração de desconto por meio de pagamento',

        able_discount_pix: 'Habilitar desconto para pagamento Pix',
        able_discount_card: 'Habilitar desconto para pagamento Cartão',
        able_discount: 'Habilitar desconto para pagamento',

        discount_percentage: 'Desconto Percentual',
        discount_monetary: 'Desconto Monetário',
        discount_value: 'Valor do desconto',
      },

      icon: {
        title: 'Ícones',
        subtitle: 'Aqui estão listados todos os icones da biblioteca',
      },
      freight: {
        title: 'Modalidades de envio',
        map: 'Mapa',
        map_text: 'Opção para pagamento na entrega do pedido',
        range: 'Raio',
        range_text: 'Opção para pagamento na entrega do pedido',
        cep: 'Lista de CEP',
        cep_text: 'Opção para pagamento na entrega do pedido',
        config: 'Configurações',
        delivery: 'Entrega própria',
        delivery_text: 'São 3 opções de entrega personalizáveis:',
        frenet: 'Frenet',
        frenet_text: 'Gestão completa de fretes com diversas transportadoras e meios de envio.',
        frenet_text_2: 'Para habilitar essa integração é necessário ter um plano da Frenet.',
        site: 'Ver o site oficial',
        coming_soon: 'Em breve...',
      },
      frenet: {
        title: 'Integração com Frenet',
        back: 'Voltar para os meios de entrega',
        integration: 'Integração',
        config: 'Configurações',
        dimensions: 'Dimensões básicas de entrega em centímetros',
        height: 'Altura',
        width: 'Largura',
        length: 'Comprimento',
        value: 'Valor declarado dos produtos',
        use: 'Utilizar',
        dont_use: 'Não utilizar',
        price: 'Usar cotação simplificada?',
        yes: 'Sim',
        no: 'Não',
        branchCode: 'Ponto de postagem Jadlog',
        no_balance: 'Sem saldo na Frenet',
        value_balance: 'Você tem @ de saldo na Frenet',
        print_balance:
          'Para imprimir a etiqueta de envio deste pedido é necessário carregar saldo na sua conta da Frenet.',
        click_balance: 'Clique no botão abaixo para acessar a Frenet em outra aba.',
        open_balance: 'Abrir conta Frenet',
        valid_token: 'Token inválido',
        declared_value: 'O valor declarado é utilizado em caso de seguro pela transportadora.',
        getToken:
          'Para encontrar o token na Frenet, é necessário acessar a seção de chaves de acesso e copiar o valor do campo "TOKEN".',
        weight_frenet: 'Peso padrão (kg)',
        height_frenet: 'Altura padrão (cm)',
        width_frenet: 'Largura padrão (cm)',
        depth_frenet: 'Profundidade padrão (cm)',
        alert_title: 'Dimensões de referência para cálculo de frete',
        alert_warning: 'Atenção!',
        alert_description:
          'Estas medidas serão usadas para calcular o frete de produtos sem volumetria cadastrada.',
        alert_wrong_values: 'Valores incorretos podem gerar:',
        alert_overpriced: 'Fretes superfaturados (afastando clientes).',
        alert_additional_costs:
          'Custos adicionais (se a transportadora ajustar o valor posteriormente).',
        alert_recommendation: 'Recomendamos cadastrar a volumetria real de cada produto.',
        alert_reference: 'Dimensões de referência:',
        alert_small_products: 'Produtos pequenos',
        alert_small_examples: '(ex: acessórios, bijuterias, cabos)',
        alert_small_weight: 'Peso: 0,1–0,3 kg',
        alert_small_dimensions: 'Dimensões: 10 × 10 × 5 cm',
        alert_medium_products: 'Produtos médios',
        alert_medium_examples: '(ex: roupas, livros, eletrônicos pequenos)',
        alert_medium_weight: 'Peso: 0,5–2 kg',
        alert_medium_dimensions: 'Dimensões: 25 × 20 × 10 cm',
        alert_large_products: 'Produtos grandes',
        alert_large_examples: '(ex: eletrodomésticos, caixas volumosas)',
        alert_large_weight: 'Peso: 5–20 kg ou mais',
        alert_large_dimensions: 'Dimensões: 50 × 40 × 30 cm ou maiores',
      },
      chat: {
        you: 'Você',
        now: 'Enviado agora',
        send: 'Enviar',
        type_message: 'Envie uma mensagem...',
        initial_message: 'Bem-vindo(a) ao chat IA da Ninegrid',
        error_message:
          'Não consegui encontrar uma resposta para sua mensagem, pode ser mais específico ou tentar mais tarde.',
        tip_language: 'Responda em português por favor.',
        title_config: 'Configurações de Inteligência Artificial',
        config: 'Configurar Inteligência Artificial',
        fit: 'Treinamento da Inteligência Artificial',
        fit_header: 'Aqui estão listadas as perguntas com as respectivas respostas criadas',
        add_question: 'Adicionar pergunta',
        edit_question: 'Editar pergunta',
        delete_question: 'Deseja excluir a pergunta abaixo?',
        question: 'Pergunta',
        answer: 'Resposta',
        date: 'Data',
        actions: 'Ações',
        active: 'Ativo',
        delete: 'Excluir',
        sync: 'Sincronizar IA',
        upload: 'Upload do arquivo',
        about: 'Sobre',
        chatia: 'Chat',
        about_title: 'Sobre o Ninegrid IA',
        about_description_title: 'Descrição',
        about_description:
          'O Ninegrid IA é um assistente virtual inteligente projetado para ajudar você com tarefas de suporte.',
        about_support_title: 'Suporte',
        about_support_description:
          'Se você tiver alguma dúvida ou precisar de ajuda, nossa equipe de suporte está pronta para ajudar.',
        about_support_contact_1: 'Para falar com suporte, entre em contato pelo e-mail',
        about_support_contact_2: 'ou abra um chamado em nosso portal:',
        about_features_title: 'Recursos',
        tips: 'Dicas para criar a sua perguntas',
        about_tips_1: 'Use perguntas claras e objetivas para obter melhores respostas.',
        about_tips_2: 'Evite gírias ou termos técnicos complexos.',
        about_tips_3: 'Se a resposta não for satisfatória, tente reformular a pergunta.',
        about_tips_4:
          'O Ninegrid IA aprende com as interações, então quanto mais você usar, melhor ele ficará.',
        feature_1: 'Conversação em linguagem natural',
        feature_2: 'Suporte a comandos de voz',
        feature_3: 'Síntese de voz para respostas',
        feature_4: 'Interface intuitiva e responsiva',
        about_manuals: 'Manuais',
        about_manuals_description:
          'Confira nossos manuais para aprender mais sobre como usar o Ambiente Ninegrid,',
        about_faq: 'Perguntas Frequentes',
        about_faq_description:
          'Veja as perguntas mais frequentes e suas respostas para esclarecer dúvidas comuns,',
        about_version_title: 'Informações do Sistema',
        version: 'Versão',
        last_update: 'Última atualização',
        rights_reserved: 'Todos os direitos reservados',
        access_here: 'acesse aqui',
        our_faq: 'veja as perguntas frequentes',
        or: 'ou',
        and: 'e',
      },
      sumary_access: {
        cart: 'Carrinho',
        seller: 'Login Vendedor',
        category: 'Categorias',
        pdv: 'Detalhes do Produto',
        subcategory: 'Subcategoria',
        product: 'Lista de Produtos',
        home: 'Tela Inicial',
        'search-order': 'Pedidos',
        'store-info': 'Informações da Loja',
        customer: 'Cadastro de cliente',
        receipt: 'Recibo de pagamento',
        order: 'Pagamento',
        card: 'Pagamento Cartão',
        'order-qrcode': 'Pagamento Pix Cliente',
        'success-order': 'Sucesso da Compra',
        'filter/pdv': 'Resultado dos Filtros',
        filter: 'Seleção de Filtros',
        'seller-qrcode': 'Link de Pagamento',
        'vendor-order ': 'Consulta de carrinho Vendedor',
        'finalize-order': 'Resumo da compra',
      },
      optional: {
        optionals: 'Adicionais',
        list: 'Lista de Adicionais',
        name: 'Nome',
        used: 'Utilizado em',
        config: 'Configurar',
        link: 'Associar produtos',
        products_optional: 'Produtos associados à lista',
        edit: 'Editar lista de adicionais',
        type: 'Tipo de seleção',
        max: 'Máximo',
        mandatory: 'Obrigatório',
        order: 'Ordem',
        code: 'Código',
        qtd: 'Qtd máxima',
        price: 'Preço',
        include: 'Incluir um adicional',
        create: 'Criar lista de adicionais',
        description: 'Descrição webapp',
        emptyProduct: 'Nenhum produto está utilizando este adicional',
      },

      coupons: {
        title: 'Cupons',
        report: 'Relatórios de Cupons',
        titleCreate: 'Criar Cupons',
        titleUpdate: 'Editar Cupons',
        subTitle: 'Aqui estão listados os cupons juntamente com suas respectivas ações.',
        create: 'Criar Cupom',
        edit: 'Editar Cupom',
        delete: 'Deletar Cupom',

        //variaveis do input
        name: 'Nome do Cupom',
        name_helper: 'Máximos de 15 caracteres',
        description: 'Descrição',
        description_placeholder: 'deverá aceitar no máximo 200 caracteres',
        seller: 'Vendedor',
        catalog: 'Catálogo',
        discountValue: 'Valor do Desconto',
        discountPercentage: 'Porcentagem do Desconto',
        type: 'Tipo',
        dateInit: 'Data de início',
        dateEnd: 'Data de fim',
        quantitative: 'Quantidade de utilizações',
        typeOptions: {
          all: 'Todos os Tipos',
          classification: 'Classificação',
          product: 'Produto',
          individuality: 'Individual',
          exclusive: 'Exclusivo',
          quantitative: 'Quantitativo',
          periodical: 'Periódico',
          cupomday: 'Dia do Cupom',
        },
        filters: 'Filtros',
        status: 'Status',
        selectStatuses: 'Selecione os status',
        actions: {
          filter: 'Filtrar',
          export: 'Exportar',
        },
        quick: {
          today: 'Hoje',
          week: 'Esta Semana',
          month: 'Este Mês',
          lastMonth: 'Mês Passado',
          year: 'Este Ano',
        },
        stats: {
          title: 'Estatísticas Gerais',
          totalCoupons: 'Total de Cupons',
          activeCoupons: 'Cupons Ativos',
          totalUsages: 'Total de Usos',
          totalDiscount: 'Total Descontado',
        },
        distribution: {
          title: 'Distribuição por Tipo',
        },
        monthlyUsage: {
          title: 'Uso Mensal',
        },
        series: {
          usageCount: 'Quantidade de Usos',
          numberOfUses: 'Número de Usos',
          discountValue: 'Valor Descontado',
        },
        table: {
          details: 'Detalhes dos Cupons',
        },
        statusLabels: {
          true: 'Ativo',
          false: 'Inativo',
        },
        statusOptions: {
          all: 'Todos',
          active: 'Ativo',
          inactive: 'Inativo',
          expired: 'Expirado',
        },
      },

      order_print: {
        title: 'Confira as informações do pedido antes de confirmar a impressão',
        print_text: 'Imprimir',
        information:
          'O QZ Tray solicitará permissão para estabelecer a conexão. Clique em "Allow" para prosseguir com a impressão.',
        order_details: 'Detalhes do Pedido',
        client: 'Cliente',
        payment: 'Pagamento',
        created: 'Criado',
        print: 'Imprimir Pedido',
        print_confirm:
          'Você deseja imprimir este pedido? Certifique-se de que a impressora está conectada e configurada corretamente antes de prosseguir',
      },

      whatsappweb: {
        title: 'WhatsApp Web',
        subtitle:
          'Aqui estão listadas as configurações de WhatsApp juntamente com suas respectivas ações.',
        titleCreate: 'Sincronizar WhatsApp',
        titleDelete: 'Remover Sincronização WhatsApp',
        create: 'Sincronizar WhatsApp',
        delete: 'Deletar Session WhatsApp',
        active: 'Ativo',
        welcome: 'WhatsApp Web da Ninegrid',
        describe_whatsappweb:
          'Aqui é possível realisar o vinculo do WhatsAppWEB como o celular da loja!',
        config: 'Para configurar o WhatsApp',
        step1: 'Abra o WhatsApp no seu celular.',
        step2: 'Toque em Mais opções ⋮ no Android ou em Configurações ⚙️ no iPhone.',
        step3: 'Toque em Dispositivos conectados e, em seguida, em Conectar um dispositivo.',
        step4: 'Aponte seu celular para esta tela para escanear o QR code.',
      },
      fileManagement: {
        title: 'Gerenciamento de Arquivos',
        subtitle: 'Aqui estão listados os arquivos juntamente com suas respectivas ações.',
        create: 'Criar Arquivo',
        edit: 'Editar Arquivo',
        delete: 'Deletar Arquivo',
        download: 'Baixar Arquivo',
        upload: 'Enviar Arquivo',
        file: 'Arquivo',
        file_name: 'Nome do Arquivo',
        file_item: 'Item',
        file_itens: 'Itens',
        file_type: 'Tipo do Arquivo',
        file_size: 'Tamanho do Arquivo',
        file_date: 'Data de Criação',
        file_actions: 'Ações',
        file_folder: 'Pasta',
        file_new_folder: 'Nova Pasta',
        file_folder_name: 'Nome da Pasta',
        file_last_modified: 'Última Modificação',
        file_description: 'Descrição do Arquivo',
        file_description_placeholder: 'Descrição do arquivo',
        file_description_helper: 'Máximo de 200 caracteres',
        file_name_placeholder: 'Nome do arquivo',
        file_name_helper: 'Máximo de 15 caracteres',
        file_page_showing: 'Mostrando',
        file_not_found: 'Nenhum arquivo encontrado',
        file_uploading: 'Carregando arquivo',
        file_upload: 'Carregar Arquivo',
        file_changing: 'Alterando arquivo',
        file_Loading: 'Carregando arquivos',
        file_update: 'Atualizar',
        file_sync_knowledge_base: 'Sincronizar Base de Conhecimento',
        file_history_sync: 'Histórico de Sincronização',
        scanned: 'Escaneado',
        indexed: 'Indexado',
        modified: 'Modificado',
        completed: 'Concluído',
        deleted: 'Deletado',
        failed: 'Falhado',
        available: 'Disponível',
        last_update: 'Última atualização',
        status: 'Status',
        status_job: 'Status da Tarefa',
        data_source: 'Fonte de Dados',
        knowledge_base: 'Base de Conhecimento',
        history_sync: 'Histórico de Sincronização',
        chart_scanned_doc: 'Documentos Escaneados',
        chart_indexed_doc: 'Documentos Indexados',
        chart_modified_doc: 'Documentos Modificados',
        chart_deleted_doc: 'Documentos Deletados',
        chart_failed_doc: 'Documentos com Falha',
        chart_docs_processed: 'Documentos Processados',
        chart_docs_total: 'Total de Documentos',
        total_jobs_processed: 'Total de Tarefas Processadas',
        jobs_info: 'Informações sobre as Tarefas',
        observation_table_jobs_phase:
          'Tabela de Jobs Processados apresenta os últimos 5 jobs de cada fonte de dados.',
      },
      service_requests: {
        title: 'Formulários de Serviço',
        subtitle: 'Gerencie os formulários de solicitação de serviços',
        create: 'Criar Formulário de Serviço',
        edit: 'Editar Formulário de Serviço',
        delete: 'Excluir Formulário de Serviço',
        create_form: 'Criar Formulário',
        edit_form: 'Editar Formulário',
        delete_form: 'Excluir Formulário',
        form_title: 'Título',
        form_icon: 'Ícone',
        form_status: 'Status',
        form_description: 'Descrição',
        form_components: 'Componentes',
        form_grids: 'Grades',
        priority_label: 'Prioridade',
        priority_low: 'Baixa',
        priority_normal: 'Normal',
        priority_high: 'Alta',
        priority_critical: 'Crítica',
        choose_icon: 'Escolher',
        add_component: 'Adicionar',
        sections: 'Seções',
        empty_message: 'Clique em Adicionar para inserir componentes e arraste para reordenar.',
        success_created: 'O formulário de serviço foi criado com sucesso.',
        success_updated: 'O formulário de serviço foi atualizado com sucesso.',
        success_deleted: 'Formulário de serviço excluído com sucesso.',
        error_create: 'Ocorreu um erro ao criar o formulário de serviço.',
        error_update: 'Ocorreu um erro ao atualizar o formulário de serviço.',
        error_delete: 'Erro ao excluir o formulário de serviço.',
        error_load: 'Erro ao carregar!',
        validation_title: 'Por favor, informe um título para a sessão',
        validation_icon: 'Por favor, escolha um ícone para a sessão',
        validation_components: 'Adicione pelo menos um componente antes de salvar',
        placeholder_title: 'Ex.: Limpeza',
        icon_selected: 'Ícone selecionado (SVG)',
        icon_none: 'Nenhum ícone selecionado',
        visual_instructions:
          'Monte visualmente a sessão. Arraste para reordenar. Os campos são apenas visuais (não interativos).',
        component: 'componente',
        components_plural: 'componentes',
        grid: 'grade',
        grids_plural: 'grades',
        grid_services: 'Grades de Serviços',
        grid_services_title: 'Selecionar Grades de Serviços',
        grid_services_search: 'Buscar grades',
        grid_services_label: 'Grades',
        grid_services_selected: 'Grades selecionadas',
        grid_services_error: 'Erro ao buscar grades de hotel',
        add_component_modal: 'Adicionar componente',
        validation_grids_required: 'Grades obrigatórias',
        validation_grids_text:
          'Todos os componentes de seleção devem ter pelo menos uma grade de serviços selecionada.',
        actions: 'Ações',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_essential_services: 'Serviços Programáveis',
        // UI Elements
        drag_title: 'Arrastar',
        drag_action: 'Arraste',
        remove_title: 'Remover',
        remove_aria_label: 'Remover bloco',
        max_quantity_title: 'Quantidade máxima:',
        max_prefix: 'Máx:',
        description_label: 'Descrição',
        sections_label: 'Seções',
        // Modal titles and actions
        select_icon_title: 'Selecionar',
        no_icons_available: 'Não há nenhum ícone disponível…',
        search_placeholder: 'Digite para buscar...',
        grid_services_selected_label: 'Selecionadas:',
        no_grid_found: 'Nenhuma grade encontrada',
        no_grid_available: 'Nenhuma grade disponível',
        grid_status_active: 'Ativo',
        grid_status_inactive: 'Inativo',
        cancel_button: 'Cancelar',
        save_button: 'Salvar',
        confirm_button: 'Confirmar',
        // Quantity modal
        max_quantity_modal_title: 'Definir Quantidade Máxima',
        max_quantity_label: 'Quantidade máxima',
        max_quantity_placeholder: 'Digite a quantidade máxima',
        max_quantity_helper:
          'Define o número máximo de itens que podem ser selecionados neste campo.',
        // Breadcrumbs
        breadcrumb_create: 'Criar',
        breadcrumb_edit: 'Editar',
        // Form components
        title_placeholder: 'Digite um título...',
        sample_title: 'Título de Exemplo',
        sample_text: 'Texto de exemplo',
        sample_service_1: 'Serviço 1',
        sample_service_2: 'Serviço 2',
        sample_hygiene: 'Higiene',
        sample_drinks: 'Bebidas',
        text_label: 'Texto',
        text_placeholder: 'Digite um texto...',
        textarea_label: 'Área de Texto',
        textarea_placeholder: 'Digite uma descrição...',
        checkbox_label: 'Seleção (checkbox)',
        radio_label: 'Seleção (radio)',
        room_number_label: 'Número do quarto',
        select_placeholder: 'Selecione...',
        date_label: 'Data',
        hour_label: 'Hora',
        quantity_label: 'Quantidade',
        between_placeholder: 'Entre',
        and_placeholder: 'e',
        select_list_label: 'Seleção (lista)',
        select_item_placeholder: 'Selecione um item',
        select_checkbox_label: 'Seleção (checkbox)',
        // Visibility
        visible_to_label: 'Visível para',
        visible_to_employees: 'Funcionários',
        visible_to_customers: 'Clientes',
        visible_to_both: 'Ambos',
        select_category_placeholder: 'Selecione uma categoria',
        select_quantity_label: 'Seleção (quantidade)',
        qty_label: 'Qtd.',
        // Catalog titles
        catalog_title: 'Título',
        catalog_text: 'Texto',
        catalog_textarea: 'Área de Texto',
        catalog_checkbox: 'Seleção (checkbox)',
        catalog_radio: 'Seleção (radio)',
        catalog_select: 'Seleção (lista)',
        catalog_stars: 'Avaliação (estrelas)',
        catalog_room_number: 'Número do quarto',
        catalog_date: 'Data',
        catalog_hour: 'Hora',
        catalog_date_hour: 'Data + Hora',
        catalog_select_list: 'Seleção (lista)',
        catalog_select_list_quantity: 'Seleção (Lista) + Quantidade',
        catalog_select_checkbox: 'Seleção (checkbox)',
        catalog_select_count: 'Seleção (quantidade)',
        catalog_quantity: 'Quantidade',
      },
      base_modal: {
        attention_title: 'Atenção!',
        unsaved_changes_text: 'As mudanças feitas serão perdidas, tem certeza que deseja sair?',
        confirm_button: 'Sim',
        cancel_button: 'Não',
      },
      summarize_ia: {
        title: 'Resumo de Utilização da IA',
        subtitle: 'Aqui estão listadas as informações de sumarização da IA.',
        create: 'Criar Sumarização IA',
        edit: 'Editar Sumarização IA',
        delete: 'Deletar Sumarização IA',
        summarize: 'Sumarizar',
      },
      s3Analytics: {
        title: 'Analytics S3',
        startDate: 'Data Inicial',
        endDate: 'Data Final',
        pluginspaceId: 'ID do Pluginspace',
        pluginspaceIdPlaceholder: 'Digite o ID do pluginspace',
        method: 'Método',
        methodPlaceholder: 'Digite o método (GET, POST, etc.)',
        loadData: 'Carregar Dados',
        generateAIAnalysis: 'Gerar Análise IA',
        chatWithAI: 'Conversar com IA',
        showRanking: 'Mostrar Ranking',
        analyzeWithAI: 'Analisar com IA',
        close: 'Fechar',
        totalRequests: 'Total de Requisições',
        totalCost: 'Custo Total',
        averageCostPerRequest: 'Custo Médio por Requisição',
        consumptionByPluginspace: 'Consumo por Pluginspace',
        consumptionByMethod: 'Consumo por Método',
        consumptionByDate: 'Consumo por Data',
        costAnalysis: 'Análise de Custos',
        aiAnalysis: 'Análise da IA',
        chatMessage: 'Digite sua pergunta sobre os dados...',
        speakAnalysis: 'Ouvir Análise',
        filterData: 'Filtrar Dados',
        noDataFound: 'Nenhum dado encontrado para os filtros selecionados',
        errorLoadingData: 'Erro ao carregar dados',
        errorGeneratingAnalysis: 'Erro ao gerar análise da IA',
        analysisGenerated: 'Análise gerada com sucesso!',
        dataLoaded: 'Dados carregados com sucesso!',
        rankingData: 'Dados de Ranking',
        aiChatResponse: 'Resposta da IA',
        s3Analytics: 'Analytics S3',
        filters: 'Filtros',
        totalConsumption: 'Consumo Total',
        totalRecords: 'Total de Registros',
        error: 'Erro',
        fetchError: 'Erro ao buscar dados do S3',
        aiAnalysisError: 'Erro ao gerar análise da IA',
        aiChatError: 'Erro ao conversar com IA',
        askQuestion: 'Digite sua pergunta sobre os dados...',
        ask: 'Perguntar',
        cancel: 'Cancelar',
        ok: 'OK',
        aiResponse: 'Resposta da IA',
        aiAnalysisTitle: 'Análise da IA',
        account: 'Conta',
        pluginspace: 'Loja',
        uniquePluginspaces: 'Lojas Únicas',
        methodDistribution: 'Distribuição por Método',
        timeAnalysis: 'Análise Temporal',
        dataTable: 'Tabela de Dados',
        showingFirst10: 'Mostrando os 10 primeiros',
        of: 'de',
        records: 'registros',
        consumption: 'Consumo',
        cost: 'Custo',
        date: 'Data',
        allMethods: 'Todos os Métodos',
        exportData: 'Exportar Dados',
      },
      hospitality: {
        add_room: 'Adicionar Quarto',
        create_multiples: 'Criar Múltiplos',
        add_activity: 'Adicionar Atividade',
        add_experience: 'Adicionar Experiência',
        experiences: 'Experiências ',
        experience_type: 'Tipo de Experiência',
        experience_duration: 'Duração',
        experience_price: 'Preço',
        experience_rating: 'Avaliação',
        experience_includes: 'Inclui',
        create_experience: 'Criar Experiência',
        edit_experience: 'Editar Experiência',
        experience_created: 'Experiência criada com sucesso!',
        experience_updated: 'Experiência atualizada com sucesso!',
        experience_deleted: 'Experiência deletada com sucesso!',
      },
      hospitality_content: {
        page_title: 'Botões',
        page_subtitle: 'Aqui estão listadas os botões das seções.',
        add_button: 'Adicionar Botão',
        filters: {
          sections: 'Seções',
        },
        table: {
          headers: {
            title: 'Título',
            order: 'Ordem',
            formTitle: 'Referência',
            type: 'Tipo',
            visibility: 'Visibilidade',
            actions: 'Ações',
          },
        },
        tabs: {
          buttons: 'Botões',
          native_buttons: 'Botões Nativos',
        },
        actions: {
          edit: 'Editar botão',
          delete: 'Excluir botão',
          delete_confirm: 'Tem certeza que deseja excluir este botão?',
        },
        type_labels: {
          service_form: 'Formulários de Serviço',
          feedback: 'Sua Opinião',
          service: 'Serviços',
          information: 'Informações',
          activities_leisure: 'Atividades e Lazer',
          bars_restaurants: 'Bares e Restaurantes',
          schedule: 'Programação',
          experience: 'Experiência',
          booking: 'Agendamentos',
          check_in: 'Check-in',
          check_out: 'Check-out',
          tours: 'Passeios',
          page_dynamic: 'Página Dinâmica',
          service_reservation: 'Reserva de Serviço',
        },
        no_category: 'Sem categoria',
        messages: {
          filter_error_title: 'Erro',
          filter_error_text: 'Erro ao filtrar seções',
          load_error_title: 'Erro ao carregar',
          load_error_text: 'Falha ao carregar seções!',
          section_not_found_title: 'Erro',
          section_not_found_text: 'Seção não encontrada!',
          deleted_title: 'Seção excluída',
          deleted_text: 'Exclusão realizada com sucesso!',
          delete_error: 'Erro ao excluir a seção!',
          visibility_updated_title: 'Visibilidade atualizada',
          visibility_updated_text: 'A visibilidade do botão foi atualizada com sucesso!',
          visibility_error_title: 'Erro ao atualizar',
          visibility_error_text: 'Erro ao atualizar a visibilidade do botão!',
          form: 'Formulário',
          page: 'Publicação',
          service_reservation: 'Reserva de Serviço',
        },
        create_modal: {
          modal_title: 'Adicionar Conteúdo',
          alert_title: 'Seleção de Seção e Conteúdo',
          alert_subtitle: 'Selecione a seção e o conteúdo correspondentes.',
          label_section: 'Seção',
          label_content: 'Conteúdo',
          placeholder_select: 'Selecione',
          placeholder_select_section: 'Selecione a seção',
          placeholder_select_content: 'Selecione o conteúdo',
          order_label: 'Ordem',
          selection_summary: 'Resumo da seleção:',
          badge_section: 'Seção',
          badge_content: 'Conteúdo',
          select_form_label: 'Selecione o formulário (roomService)',
          tips_title: 'Dicas',
          tips: {
            item1: 'A seção pode ter múltiplos conteúdos',
            item2: 'O conteúdo pode pertencer a múltiplas seções',
            item3: 'A ordem define a posição na listagem',
          },
          buttons: {
            cancel: 'Cancelar',
            create: 'Criar',
          },
          swal: {
            missing_field_title: 'Campo faltando',
            missing_section: 'Selecione uma seção para continuar',
            missing_content: 'Selecione um conteúdo para continuar',
            invalid_field_title: 'Campo inválido',
            invalid_order: 'A ordem deve ser um número positivo ou zero',
            created_title: 'Conteúdo cadastrado',
            created_text: 'Cadastro realizado com sucesso!',
            create_error: 'Erro ao cadastrar o conteúdo!',
          },
        },
        edit_modal: {
          modal_title: 'Editar Conteúdo',
          alert_title: 'Edição de Conteúdo',
          alert_subtitle:
            'Altere a seção e a ordem conforme necessário. O conteúdo atual não pode ser alterado.',
          label_section: 'Seção',
          label_content: 'Conteúdo',
          placeholder_select: 'Selecione',
          placeholder_select_section: 'Selecione a seção',
          placeholder_select_content: 'Selecione o conteúdo',
          order_label: 'Ordem',
          selection_summary: 'Resumo da seleção:',
          badge_section: 'Seção',
          badge_content: 'Conteúdo',
          tips_title: 'Dicas',
          tips: {
            item1: 'Você pode alterar apenas a seção',
            item2: 'A ordem define a posição na listagem',
          },
          buttons: {
            cancel: 'Cancelar',
            save: 'Salvar',
          },
          swal: {
            missing_field_title: 'Campo faltando',
            missing_section: 'Selecione uma seção para continuar',
            missing_content: 'Selecione um conteúdo para continuar',
            invalid_field_title: 'Campo inválido',
            invalid_order: 'A ordem deve ser um número positivo ou zero',
            updated_title: 'Conteúdo atualizado',
            updated_text: 'Atualização realizada com sucesso!',
            update_error: 'Erro ao atualizar o conteúdo!',
          },
        },
        category: {
          page_title: 'Seções',
          page_subtitle:
            'Aqui estão listadas as seções de conteúdo juntamente com suas respectivas ações.',
          add_button: 'Adicionar',
          breadcrumbs: {
            dashboard: 'Dashboard',
            categories: 'Categorias',
          },
          table: {
            headers: {
              section: 'Seção',
              order: 'Ordem',
              status: 'Status',
              actions: 'Ações',
            },
          },
          options: {
            edit_category: 'Editar Seção',
            delete_section: 'Excluir seção',
            delete_confirm: 'Deletar seção',
          },
          swal: {
            deleted_title: 'Seção deletada',
            deleted_text: 'Deleção realizada com sucesso!',
            delete_error: 'Erro ao deletar a seção!',
          },
          create: {
            missing_fields_title: 'Campos faltantes',
            missing_fields_text: 'Verifique se preencheu todos os campos corretamente!',
            created_title: 'Seção cadastrada',
            created_text: 'Cadastro realizado com sucesso!',
            create_error: 'Erro ao cadastrar a seção!',
            select_banners: 'Selecionar Banners de Destaque',
            select_banners_description:
              'Clique nos cards abaixo para selecionar os banners que serão exibidos nesta seção.',
          },
          update: {
            missing_fields_title: 'Campos faltantes',
            missing_fields_text: 'Verifique se preencheu todos os campos corretamente!',
            updated_title: 'Seção atualizada',
            updated_text: 'Edição realizada com sucesso!',
            update_error: 'Erro ao atualizar a seção!',
          },
          type: {
            default: 'Padrão',
            banner: 'Banner de Destaque',
          },
        },
      },
      clean_safe: {
        title: 'Clean & Safe',
        subtitle: 'Gerencie medidas de segurança, protocolos de limpeza e certificações',
        security_measures: 'Medidas de Segurança',
        cleaning_protocols: 'Protocolos de Limpeza',
        certifications: 'Certificações',
        add_security_measure: 'Adicionar Medida',
        add_cleaning_protocol: 'Adicionar Protocolo',
        add_certification: 'Adicionar Certificação',
        add_new_security_measure: 'Adicionar Nova Medida',
        add_new_cleaning_protocol: 'Adicionar Novo Protocolo',
        add_new_certification: 'Adicionar Nova Certificação',
        security_measure: 'Medida de Segurança',
        cleaning_protocol: 'Protocolo de Limpeza',
        certification: 'Certificação',
        icon: 'Ícone',
        choose_icon: 'Escolher Ícone',
        title_field: 'Título',
        description: 'Descrição',
        status: 'Status',
        active: 'Ativo',
        inactive: 'Inativo',
        remove: 'Remover',
        save: 'Salvar',
        required_title: 'Título é obrigatório',
        required_icon: 'Ícone é obrigatório',
        required_fields: 'Campos obrigatórios',
        required_fields_message: 'Por favor, preencha todos os campos obrigatórios.',
        confirmation: 'Confirmação',
        delete_security_measure_confirm:
          'Você tem certeza que deseja deletar esta medida de segurança?',
        delete_cleaning_protocol_confirm:
          'Você tem certeza que deseja deletar este protocolo de limpeza?',
        delete_certification_confirm: 'Você tem certeza que deseja deletar esta certificação?',
        yes: 'Sim',
        no: 'Não',
        error: 'Erro',
        error_delete: 'Erro ao deletar item.',
        success: 'Sucesso',
        success_save: 'Dados de higiene e segurança salvos com sucesso!',
        error_save: 'Ocorreu um erro ao salvar os dados.',
        empty_security_measures: 'Nenhuma medida de segurança adicionada ainda.',
        empty_cleaning_protocols: 'Nenhum protocolo de limpeza adicionado ainda.',
        empty_certifications: 'Nenhuma certificação adicionada ainda.',
        empty_start_message: 'Clique em "Adicionar" para começar.',
        placeholder_security_title: 'Digite o título da medida de segurança',
        placeholder_protocol_title: 'Digite o título do protocolo',
        placeholder_certification_title: 'Digite o título da certificação',
        placeholder_security_description: 'Digite uma descrição breve (máximo 100 caracteres)',
        placeholder_protocol_description: 'Digite a descrição detalhada do protocolo de limpeza',
      },
      orders_room_service: {
        title: 'Reservas de Serviço',
        subtitle: 'Gerenciamento de pedidos de serviços do hotel',

        // Filtros
        status: 'Status',
        start_date: 'Data Inicial',
        end_date: 'Data Final',
        reservation_id: 'Código da Reserva',
        post_id: 'ID da Postagem',
        service_type: 'Tipo de Serviço',
        search: 'Pesquisar',
        clear_filters: 'Limpar Filtros',

        // Status
        status_pending: 'Pendente',
        status_confirmed: 'Confirmado',
        status_in_progress: 'Em Andamento',
        status_cancelled: 'Cancelado',
        status_concluded: 'Concluído',
        status_completed: 'Concluído',
        status_progress: 'Em Andamento',

        // Opções de filtro
        all_status: 'Todos os status',
        all_types: 'Todos os tipos',
        service_forms: 'Formulários de Serviço',
        services: 'Serviços',

        // Headers da tabela
        service: 'Serviço',
        room: 'Quarto',
        price: 'Preço (Un)',
        people_qty: 'Quantidade de Pessoas',
        descripition: 'Descrição',
        reservation: 'Reserva',
        date: 'Data',
        time: 'Horário',
        priority: 'Prioridade',
        created_at: 'Criado em',
        actions: 'Ações',

        // Tooltip actions
        view_details: 'Ver Detalhes',
        change_status: 'Alterar Status',

        // Modal de detalhes
        order_details: 'Detalhes do Pedido',
        close: 'Fechar',
        loading_details: 'Carregando detalhes do pedido...',
        loading: 'Carregando...',

        // Informações do pedido
        order: 'Pedido',
        room_service: 'Serviço de Quarto',
        location: 'Localização',
        room_number: 'Número do Quarto',
        scheduled_date: 'Data Agendada',
        no_time: 'Sem horário',
        reservation_id_label: 'Código da Reserva',

        // Informações do cliente
        customer_info: 'Informações do Cliente',
        full_name: 'Nome Completo',
        email: 'E-mail',
        phone: 'Telefone',

        // Detalhes da solicitação
        request_summary: 'Resumo da Solicitação',
        service_details: 'Detalhes do Serviço',
        request_details: 'Detalhes da Solicitação',
        no_items_selected: 'Nenhum item selecionado',
        not_informed: 'Não informado',
        units: 'unidades',

        // Informações técnicas
        technical_info: 'Informações Técnicas',
        post: 'Postagem',
        booking_type: 'Tipo de Agendamento',
        hotel_info: 'Informações do Hotel',
        hotel_name: 'Nome do Hotel',
        subdomain: 'Subdomínio',
        type: 'Tipo',
        service_form: 'Formulário de Serviço',
        last_update: 'Última Atualização',
        additional_notes: 'Observações Adicionais',

        // Modal de alteração de status
        change_status_title: 'Alterar Status',
        current_status: 'Status Atual',
        new_status: 'Novo Status',
        select_status: 'Selecione um status',

        // Placeholders
        select_status_placeholder: 'Selecione o status',
        select_service_type_placeholder: 'Selecione o tipo de serviço',
        start_date_placeholder: 'Data inicial',
        end_date_placeholder: 'Data final',
        reservation_id_placeholder: 'Digite o ID da reserva',
        post_id_placeholder: 'Digite o ID da postagem',
        new_status_placeholder: 'Selecione o novo status',

        // Mensagens de erro e sucesso
        error: 'Erro',
        success: 'Sucesso',
        warning: 'Atenção',
        error_loading_orders: 'Erro ao carregar os pedidos!',
        error_loading_details: 'Erro ao carregar detalhes do pedido!',
        error_changing_status: 'Erro ao alterar status do pedido!',
        success_status_changed: 'Status alterado com sucesso!',
        select_status_warning: 'Por favor, selecione um status.',

        // Avaliação do cliente
        customer_review: 'Avaliação do Cliente',
        rating: 'Nota',
        review_comment: 'Comentário',
      },
      hospitality_store: {
        establishment: 'Estabelecimento',
        select_establishment: 'Selecione...',
        link: 'Link',
        status: 'Status',
        payment_integrated: 'Pagamento Integrado',
        order: 'Ordem',
        store_image: 'Imagem da Loja',
        store_image_hint: 'Selecione uma imagem representativa da loja',
        description: 'Descrição',
        cnpj: 'CNPJ',
        code: 'Código',
        store_id_placeholder: 'ID da loja',
        type: 'Tipo',
        store_type_placeholder: 'Tipo do estabelecimento',
        no_store_found: 'Nenhum estabelecimento encontrado.',
        edit_store: 'Editar Estabelecimento',
        edit_store_subtitle: 'Edite os dados do estabelecimento.',
      },
      stores_pages: {
        title: 'Estabelecimentos',
        subtitle:
          'Aqui estão listados os estabelecimentos do hotel juntamente com suas respectivas ações.',
        create: 'Criar Estabelecimento',
        no_results: 'Nenhum estabelecimento encontrado.',
        table: {
          code: 'Código',
          image: 'Imagem',
          name: 'Loja',
          cnpj: 'CNPJ',
          vinculation: 'Vinculação',
          vinculation_default: 'Padrão',
          vinculation_dynamic: 'Dinâmico',
          type: 'Tipo',
          order: 'Ordem',
          status: 'Status',
          status_active: 'Ativo',
          status_inactive: 'Inativo',
          payment_integrated: 'Pagamento Integrado',
          actions: 'Ações',
        },
        actions: {
          edit: 'Editar Estabelecimento',
          delete_confirm: 'Tem certeza que deseja excluir?',
          delete: 'Excluir Estabelecimento',
        },
        delete_success: 'Estabelecimento excluído com sucesso.',
        delete_error: 'Erro ao excluir o estabelecimento. Por favor, tente novamente.',
        success: 'Sucesso!',
        error: 'Erro!',
      },
      stores_pages_create: {
        title: 'Criar Estabelecimento',
        subtitle: 'Crie um novo estabelecimento para o hotel.',
        form: {
          establishment: 'Estabelecimento',
          select_placeholder: 'Selecione...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Status',
          status_options: {active: 'Ativo', inactive: 'Inativo'},
          payment_integrated: 'Pagamento Integrado',
          payment_options: {active: 'Ativo', inactive: 'Inativo'},
          order: 'Ordem',
          image_label: 'Imagem do Estabelecimento',
          image_smalltext: 'Selecione uma imagem representativa do estabelecimento',
          description: 'Descrição',
          info_title: 'Informações do Estabelecimento',
          cnpj: 'CNPJ',
          code: 'Código',
          type: 'Tipo',
          vinculation_label: 'Tipo da Vinculação',
          vinculation_options: {default: 'Padrão', dynamic: 'Dinâmico'},
          empty_message: 'Nenhum estabelecimento encontrado.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'ID da loja',
        },
        console_messages: {
          image_upload_error: 'Erro upload imagem',
        },
        messages: {
          warning_title: 'Atenção',
          select_store_warning: 'Por favor, selecione um estabelecimento válido antes de salvar.',
          error_saving: 'Ocorreu um erro ao salvar o estabelecimento. Por favor, tente novamente.',
          success_saved: 'Estabelecimento salvo com sucesso.',
        },
      },
      satisfaction_feedback: {
        title: 'Formulários',
        subtitle: 'Gerencie os formulários de pesquisa e satisfação',
        create: 'Criar Formulário',
        edit: 'Editar Formulário',
        delete: 'Excluir Formulário',
        create_form: 'Criar Formulário',
        edit_form: 'Editar Formulário',
        delete_form: 'Excluir Formulário',
        form_title: 'Título',
        form_status: 'Status',
        form_description: 'Descrição',
        form_date_init: 'Data de Início',
        form_date_end: 'Data de Término',
        form_components: 'Componentes',
        form_grids: 'Grades',
        placeholder_title: 'Ex.: Feedback do Restaurante',
        placeholder_date_init: 'Selecione a data de início',
        placeholder_date_start: 'Selecione a data de início',
        placeholder_date_end: 'Selecione a data de término',
        sections: 'Seções',
        empty_message: 'Clique em Adicionar para inserir componentes e arraste para reordenar.',
        success_created: 'O formulário foi criado com sucesso.',
        success_updated: 'O formulário foi atualizado com sucesso.',
        success_deleted: 'Formulário excluído com sucesso.',
        error_create: 'Ocorreu um erro ao criar o formulário.',
        error_update: 'Ocorreu um erro ao atualizar o formulário.',
        error_delete: 'Erro ao excluir o formulário.',
        error_load: 'Erro ao carregar!',
        validation_title: 'Por favor, informe um título para o formulário',
        validation_date_init: 'Por favor, informe a data de início da vigência',
        validation_date_end: 'Por favor, informe a data de término da vigência',
        validation_date_range: 'A data de início deve ser anterior à data de término',
        validation_components: 'Adicione pelo menos um componente antes de salvar',
        validation_title_required: 'Títulos obrigatórios',
        validation_title_text:
          'Todos os componentes do tipo "título" devem ter um título personalizado configurado.',
        validation_grids_required: 'Grades obrigatórias',
        validation_grids_text:
          'Todos os componentes de seleção devem ter pelo menos uma grade de serviços selecionada.',
        visual_instructions:
          'Preencha as informações abaixo. As seções exibidas são apenas visuais, servindo apenas para ilustrar.',
        // Campos específicos para componentes
        component: 'componente',
        components_plural: 'componentes',
        grid: 'grade',
        grids_plural: 'grades',
        grid_services: 'Grades de Serviços',
        grid_services_title: 'Selecionar Grades de Serviços',
        grid_services_search: 'Buscar grades',
        grid_services_label: 'Grades',
        grid_services_selected: 'Grades selecionadas',
        grid_services_error: 'Erro ao buscar grades de hotel',
        grid_feedback_error: 'Erro ao buscar grades de feedback',
        add_component: 'Adicionar',
        add_component_modal: 'Adicionar componente',
        actions: 'Ações',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_feedback: 'Feedback de Satisfação',
        // UI Elements
        drag_title: 'Arrastar',
        drag_action: 'Arraste',
        remove_title: 'Remover',
        remove_aria_label: 'Remover bloco',
        // Modal titles and actions
        select_icon_title: 'Selecionar',
        no_icons_available: 'Não há nenhum ícone disponível…',
        search_placeholder: 'Digite para buscar...',
        grid_services_selected_label: 'Selecionadas:',
        no_grid_found: 'Nenhuma grade encontrada',
        no_grid_available: 'Nenhuma grade disponível',
        grid_status_active: 'Ativo',
        grid_status_inactive: 'Inativo',
        cancel_button: 'Cancelar',
        save_button: 'Salvar',
        confirm_button: 'Confirmar',
        breadcrumb_create: 'Criar',
        breadcrumb_edit: 'Editar',
        // Form components - reutilizando algumas traduções do service_requests
        sample_title: 'Título de Exemplo',
        sample_text: 'Texto de exemplo',
        sample_service_1: 'Serviço 1',
        sample_service_2: 'Serviço 2',
        // Catalog titles
        catalog_title: 'Título',
        catalog_text: 'Texto',
        catalog_textarea: 'Área de Texto',
        catalog_checkbox: 'Seleção (checkbox)',
        catalog_radio: 'Seleção (radio)',
        catalog_select: 'Seleção (lista)',
        catalog_stars: 'Avaliação (estrelas)',
        // Configuração customizada de título
        configure_title: 'Configurar Título',
        configure_title_modal: 'Configurar Título',
        custom_title_modal_title: 'Configurar Título',
        custom_title_label: 'Título da pergunta',
        custom_title_placeholder: 'Digite o título desejado',
        custom_title_help: 'Este título será exibido no formulário de feedback.',
        custom_title_helper: 'Este título será exibido no formulário de feedback.',
        // Grades e feedback
        grid_feedback: 'Configurar Grades',
        grids_selected: 'Grades',
        grid_selected: 'Grade',
      },
      feedback_reviews: {
        title: 'Reviews de Pesquisa e Satisfação',
        subtitle:
          'Visualize e gerencie todas as avaliações e respostas dos formulários de feedback',
        breadcrumb_feedback: 'Feedback de Satisfação',
        error: 'Erro',
        success: 'Sucesso',
        loading: 'Carregando...',
        loading_details: 'Carregando detalhes do review...',
        close: 'Fechar',
        error_loading_reviews: 'Erro ao carregar os reviews',
        error_loading_details: 'Erro ao carregar os detalhes do review',
        error_changing_status: 'Erro ao alterar o status do review',
        success_status_changed: 'Status alterado com sucesso',
        confirm_status_change: 'Confirmar alteração de status',
        confirm_status_change_text: 'Tem certeza que deseja alterar o status deste review?',

        // Status
        status_pending: 'Pendente',
        status_approved: 'Aprovado',
        status_rejected: 'Rejeitado',

        // Field types shown in responses
        types: {
          title: 'Título',
          text: 'Texto',
          textarea: 'Área de Texto',
          stars: 'Avaliação',
          checkbox: 'Seleção (checkbox)',
          radio: 'Seleção (radio)',
          select: 'Seleção (lista)',
          number: 'Número',
          date: 'Data',
          time: 'Hora',
          image: 'Imagem',
          link: 'Link',
        },

        anonymous_active: 'Ativo',
        anonymous_inactive: 'Inativo',

        // Filtros
        filters: {
          feedback_form: 'Formulário',
          status: 'Status',
          anonymous: 'Anônimo',
          select_anonymous_placeholder: 'Todos',
          rating: 'Avaliação',
          reservation_id: 'ID da Reserva',
          start_date: 'Data Inicial',
          end_date: 'Data Final',
          date: 'Data',
          all_forms: 'Todos os Formulários',
          all_status: 'Todos os Status',
          all_ratings: 'Todas as Avaliações',
          select_form_placeholder: 'Selecione um formulário',
          select_status_placeholder: 'Selecione um status',
          select_rating_placeholder: 'Selecione uma avaliação',
          reservation_id_placeholder: 'Digite o ID da reserva',
          start_date_placeholder: 'Selecione a data inicial',
          end_date_placeholder: 'Selecione a data final',
          filter_button: 'Filtrar',
          clear_filters: 'Limpar Filtros',
        },

        // Tabela
        table: {
          feedback_form: 'Formulário',
          customer: 'Cliente',
          room: 'Quarto',
          reservation: 'Reserva',
          rating: 'Avaliação',
          status: 'Status',
          date: 'Data',
          time: 'Hora',
          actions: 'Ações',
        },

        // Ações
        actions: {
          view_details: 'Ver Detalhes',
          approve: 'Aprovar',
          reject: 'Rejeitar',
        },

        // Detalhes do Review
        review_details: 'Detalhes do Review',
        room: 'Quarto',
        reservation: 'Reserva',
        feedback_form: 'Formulário',
        responses: 'Respostas',
        technical_info: 'Informações Técnicas',
        created_at: 'Criado em',
        updated_at: 'Atualizado em',
        review_id: 'ID do Review',
        plugin_space_id: 'ID do Plugin Space',
        anonymous_response: 'Resposta Anônima',
        no_reservation_linked: 'Esta resposta não está vinculada a uma reserva específica',
        no_detailed_responses: 'Nenhuma resposta detalhada disponível para este review',
        anonymous_label: 'Anônimo',
        email_anonymous: 'Email não disponível (resposta anônima)',
        email_not_informed: 'Email não informado',
        response_title: 'Título',
        no_rating_provided: 'Nenhuma avaliação fornecida',
        no_items_selected: 'Nenhum item selecionado',
        no_option_selected: 'Nenhuma opção selecionada',
        no_answer_provided: 'Nenhuma resposta fornecida',
        form_label: 'Formulário: ',
        client_not_identified: 'Cliente não identificado',
      },
      stores_pages_edit: {
        title: 'Editar Estabelecimento',
        subtitle: 'Edite os dados do estabelecimento.',
        form: {
          establishment: 'Estabelecimento',
          select_placeholder: 'Selecione...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Status',
          status_options: {active: 'Ativo', inactive: 'Inativo'},
          payment_integrated: 'Pagamento Integrado',
          payment_options: {active: 'Ativo', inactive: 'Inativo'},
          order: 'Ordem',
          image_label: 'Imagem do Estabelecimento',
          image_smalltext: 'Selecione uma imagem representativa do estabelecimento',
          description: 'Descrição',
          info_title: 'Informações do Estabelecimento',
          cnpj: 'CNPJ',
          code: 'Código',
          type: 'Tipo',
          vinculation_label: 'Tipo da Vinculação',
          vinculation_options: {default: 'Padrão', dynamic: 'Dinâmico'},
          empty_message: 'Nenhum estabelecimento encontrado.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'ID da loja',
        },
        console_messages: {
          image_upload_error: 'Erro upload imagem',
          image_remove_error: 'Erro ao remover imagem no save',
        },
        messages: {
          success_updated: 'Estabelecimento atualizado com sucesso.',
          error_updating:
            'Ocorreu um erro ao atualizar o estabelecimento. Por favor, tente novamente.',
          payment_change_warning_title: 'Atenção',
          payment_change_warning_text:
            'Essa alteração pode mudar o valor das reservas em andamento no momento do check-out.',
          payment_confirm: 'Sim, continuar',
          cancel: 'Cancelar',
        },
      },
      hospitality_section: {
        index: {
          page_title: 'Páginas de Publicações',
          page_subtitle:
            'Aqui estão listadas as paginas de publicação de conteúdo juntamente com suas respectivas ações.',
          add_button: 'Adicionar Página de Publicação',
          filters: {
            sections: 'Página de Publicação',
          },
          table: {
            headers: {
              title: 'Título',
              order: 'Ordem',
              formTitle: 'Título do Formulário',
              type: 'Tipo',
              actions: 'Ações',
            },
          },
          actions: {
            edit: 'Editar Páginas de Publicações',
            delete: 'Excluir Páginas de Publicações',
          },
        },
        create: {
          page_title: 'Criar Páginas de Publicações',
          page_subtitle: 'Crie uma nova páginas de publicações de conteúdo para o hotel.',
          add_button: 'Adicionar Páginas de Publicações',
          filters: {
            sections: 'Seções',
          },
        },
        edit: {
          page_title: 'Editar Páginas de Publicações',
          page_subtitle: 'Edite os dados da páginas de publicações de conteúdo.',
        },
        // Traduções dinâmicas para seções
        types: {
          category: 'Categoria',
          content: 'Conteúdo',
          simple: 'Simples',
          form: 'Formulário',
          page: 'Restaurante e loja',
        },
        status: {
          active: 'Ativo',
          inactive: 'Inativo',
        },
        actions: {
          create: 'Criar',
          edit: 'Editar',
          delete: 'Excluir',
          save: 'Salvar',
          cancel: 'Cancelar',
          update: 'Atualizar',
          remove_icon: 'Remover Ícone',
          select_icon: 'Selecionar Ícone',
        },
        fields: {
          title: 'Título do Botão',
          type: 'Tipo de Páginas de Publicações',
          category: 'Categoria',
          order: 'Ordem',
          status: 'Status',
          icon: 'Ícone',
          icon_selected: 'Ícone Selecionado',
          icon_not_selected: 'Nenhum Ícone Selecionado',
          icon_description: 'Selecione um ícone na lista ao lado para a seção',
          icon_change_description:
            'Selecione um ícone diferente na lista ao lado ou remova o atual',
        },
        placeholders: {
          title: 'Digite o título do botão',
          type: 'Selecione o tipo',
          category: 'Selecione uma categoria',
          order: '0',
          search_icon: 'Buscar ícone...',
          all_categories: 'Todas as categorias',
        },
        warnings: {
          stores:
            'Nenhuma loja do tipo Dinâmico foi encontrada.\nPara continuar, acesse Configurações da Loja → Estabelecimentos e configure uma loja com o tipo Dinâmico.',
        },
        messages: {
          validation: {
            title_required: 'O título é obrigatório!',
            category_required: 'Selecione uma categoria!',
            icon_required: 'Selecione um ícone!',
          },
          success: {
            created: 'Páginas de Publicações criada com sucesso!',
            updated: 'Páginas de Publicações atualizada com sucesso!',
            deleted: 'Páginas de Publicações excluída com sucesso!',
          },
          error: {
            create: 'Erro ao criar Páginas de Publicações!',
            update: 'Erro ao atualizar Páginas de Publicações!',
            delete: 'Erro ao excluir Páginas de Publicações!',
            load: 'Erro ao carregar dados da Páginas de Publicações!',
          },
          confirm: {
            delete_title: 'Tem certeza?',
            delete_text: 'Esta ação não pode ser desfeita!',
            delete_confirm: 'Sim, excluir!',
            delete_cancel: 'Cancelar',
          },
          delete: {
            deleted_title: 'Páginas de Publicações excluída',
            deleted_text: 'Exclusão realizada com sucesso!',
            error_title: 'Erro ao excluir a Páginas de Publicações!',
            error_text:
              'Ocorreu um erro ao excluir a Páginas de Publicações. Por favor, tente novamente.',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: 'Categoria de Publicações',
          page_subtitle:
            'Aqui estão listadas as categorias de publicações juntamente com suas respectivas ações.',
          add_button: 'Adicionar Categoria de Publicação',
          table: {
            headers: {
              title: 'Título',
              code: 'codigo',
              actions: 'Ações',
            },
            actions: {
              edit: 'Editar Categoria de Publicação',
              delete: 'Excluir Categoria de Publicação',
            },
          },
        },
        create: {
          page_title: 'Criar Categoria de Publicação',
          page_subtitle: 'Crie uma nova categoria de publicação para o hotel.',
          add_button: 'Adicionar Categoria de Publicação',
          success: {
            created_title: 'Categoria de Publicação criada',
            created_text: 'Cadastro realizado com sucesso!',
          },
          error: {
            created_title: 'Erro ao cadastrar a Categoria de Publicação!',
            created_text: 'Ocorreu um erro ao cadastrar a categoria. Por favor, tente novamente.',
          },
        },
        edit: {
          page_title: 'Editar Categoria de Publicação',
          page_subtitle: 'Edite os dados da categoria de publicação.',
          error: {
            created_title: 'Erro ao editar a Categoria de Publicação!',
            created_text: 'Ocorreu um erro ao editar a categoria. Por favor, tente novamente.',
          },
          success: {
            created_title: 'Categoria de Publicação editada',
            created_text: 'Cadastro atualizado com sucesso!',
          },
        },
        // Traduções dinâmicas para categorias de publicação
        actions: {
          create: 'Criar',
          edit: 'Editar',
          delete: 'Excluir',
          save: 'Salvar',
          cancel: 'Cancelar',
          update: 'Atualizar',
          back: 'Voltar',
        },
        fields: {
          name: 'Nome',
          code: 'Código',
          description: 'Descrição',
          status: 'Status',
        },
        placeholders: {
          name: 'Digite o nome da categoria',
          code: 'Digite o código da categoria',
          description: 'Digite a descrição da categoria',
        },
        messages: {
          validation: {
            name_required: 'O nome é obrigatório!',
            fields_missing: 'Verifique se preencheu todos os campos!',
          },
          success: {
            created: 'Categoria de Publicação criada com sucesso!',
            updated: 'Categoria de Publicação atualizada com sucesso!',
            deleted: 'Categoria de Publicação excluída com sucesso!',
          },
          error: {
            create: 'Erro ao criar Categoria de Publicação!',
            update: 'Erro ao atualizar Categoria de Publicação!',
            delete: 'Erro ao excluir Categoria de Publicação!',
            load: 'Erro ao carregar dados da categoria!',
          },
        },
      },
      hospitality_post: {
        posts: 'Publicações',
        index: {
          page_title: 'Publicações',
          page_subtitle:
            'Aqui estão listadas as publicações do hotel juntamente com suas respectivas ações.',
          add_button: 'Adicionar Publicação',
          filter_all: 'Todos',
          filter: 'Categorias',
          table: {
            headers: {
              title: 'Título',
              image: 'Imagem',
              summary: 'Resumo',
              order: 'Ordem',
              status: 'Status',
              classification: 'Classificação',
              actions: 'Ações',
            },
            actions: {
              edit: 'Editar Publicação',
              delete: 'Excluir Publicação',
            },
          },
        },
        create: {
          page_title: 'Criar Publicação',
          page_subtitle: 'Crie uma nova publicação para o hotel.',
          success: {
            created_title: 'Publicação criada',
            created_text: 'Cadastro realizado com sucesso!',
          },
          error: {
            created_title: 'Erro ao cadastrar a Publicação!',
            created_text: 'Ocorreu um erro ao cadastrar a publicação. Por favor, tente novamente.',
          },
        },
        edit: {
          page_title: 'Editar Publicação',
          page_subtitle: 'Edite os dados da publicação.',
          success: {
            created_title: 'Publicação editada',
            created_text: 'Cadastro realizado com sucesso!',
          },
          error: {
            created_title: 'Erro ao editar a Publicação!',
            created_text: 'Ocorreu um erro ao editar a publicação. Por favor, tente novamente.',
          },
        },
        form_validate: {
          title_required: 'O título é obrigatório!',
          summary_required: 'O resumo é obrigatório!',
          classification_required: 'A classificação é obrigatória!',
          content_required: 'O conteúdo é obrigatório!',
          fields_missing: 'Verifique se preencheu todos os campos!',
        },
      },
      hospitality_post_page: {
        types: {
          simple: 'Simples',
          section: 'Seção',
          form: 'Formulário',
          category: 'Categoria',
        },
        index: {
          page_title: 'Páginas de Publicações',
          page_subtitle:
            'Aqui estão listadas as páginas de publicação de conteúdo juntamente com suas respectivas ações.',
          add_button: 'Adicionar Página de Publicação',
          edit_button: 'Editar Página de Publicação',
          delete_button: 'Excluir Página de Publicação',
        },
        create: {
          page_title: 'Criar Página de Publicação',
          page_subtitle: 'Crie uma nova página de publicação de conteúdo para o hotel.',
          form: {
            title: 'Título da Página de Publicação',
            type: 'Tipo de Página de Publicação',
            status: 'Status',
          },
          icon: {
            icon: 'Ícone SVG',
            lib: 'Biblioteca de Ícones SVG',
            search: 'Buscar ícone...',
            category: 'Categoria do Ícone',
            description: 'Selecione um ícone na lista ao lado para a página de publicação',
            selected: 'Ícone Selecionado',
            no_selected: 'Nenhum Ícone Selecionado',
            selected_description: 'Selecione um ícone na lista ao lado para a página de publicação',
            no_selected_description:
              'Nenhum ícone selecionado. Selecione um ícone na lista ao lado para a página de publicação',
            change_description: 'Selecione um ícone diferente na lista ao lado ou remova o atual',
          },
          success: {
            created_title: 'Página de Publicação criada',
            created_text: 'Cadastro realizado com sucesso!',
          },
          error: {
            created_title: 'Erro ao cadastrar a Página de Publicação!',
            created_text: 'Ocorreu um erro ao cadastrar a página. Por favor, tente novamente.',
          },
        },
        edit: {
          page_title: 'Editar Página de Publicação',
          page_subtitle: 'Edite os dados da página de publicação de conteúdo.',
          form: {
            title: 'Título da Página de Publicação',
            type: 'Tipo de Página de Publicação',
            status: 'Status',
          },
          icon: {
            icon: 'Ícone SVG',
            lib: 'Biblioteca de Ícones SVG',
            search: 'Buscar ícone...',
            category: 'Categoria do Ícone',
            description: 'Selecione um ícone na lista ao lado para a página de publicação',
            selected: 'Ícone Selecionado',
            no_selected: 'Nenhum Ícone Selecionado',
            selected_description: 'Selecione um ícone na lista ao lado para a página de publicação',
            no_selected_description:
              'Nenhum ícone selecionado. Selecione um ícone na lista ao lado para a página de publicação',
            change_description: 'Selecione um ícone diferente na lista ao lado ou remova o atual',
          },
          success: {
            created_title: 'Página de Publicação editada',
            created_text: 'Edição realizada com sucesso!',
          },
          error: {
            created_title: 'Erro ao editar a Página de Publicação!',
            created_text: 'Ocorreu um erro ao editar a página. Por favor, tente novamente.',
          },
        },
      },
      users: {
        houserkeeping: 'Camareira',
        maintenancetechnician: 'Técnico de Manutenção',
        receptionist: 'Recepcionista',
        manager: 'Gerente',
        administrator: 'Administrador',
        waiter: 'Garçom',
        kitchenchief: 'Chefe de Cozinha / Chef',
        warehouse: 'Administrador de Armazém',
        concierge: 'Concierge',
        messenger: 'Mensageiro',
        receptionsupervisor: 'Supervisor de Recepção',
        telephonist: 'Telefonista',
        cook: 'Cozinheiro',
        barman: 'Barman / Bartender',
        roomserviceattendant: 'Atendente de Room Service',
        steward: 'Steward (Limpeza de Cozinha)',
        sommelier: 'Sommelier',
        plumber: 'Encanador',
        airconditiontechnician: 'Técnico de Ar-Condicionado',
        maintenancesupervisor: 'Supervisor de Manutenção',
        reservationagent: 'Agente de Reservas',
        reservationcoordinator: 'Coordenador de Reservas',
        salesexecutive: 'Executivo de Vendas',
        revenuemanager: 'Revenue Manager',
        commercialmanager: 'Gerente Comercial',
        administrativeassistant: 'Auxiliar Administrativo',
        financeaccountspayable: 'Financeiro / Contas a Pagar',
        accountant: 'Contador',
        humanresources: 'Recursos Humanos',
        purchasingwarehouse: 'Compras / Almoxarifado',
        recreator: 'Recreador',
        activityinstructor: 'Instrutor de Atividades',
        experiencecoordinator: 'Coordenador de Experiências',
        tourguide: 'Guia de Passeios',
        childmonitor: 'Monitor Infantil',
        securityguard: 'Vigilante',
        doorman: 'Porteiro',
        accesscontroller: 'Controlador de Acesso',
        securitysupervisor: 'Supervisor de Segurança',
        generalmanager: 'Gerente Geral',
        assistantmanager: 'Subgerente',
        operationalmanager: 'Gerente Operacional',
        departmentsupervisorscoordinators: 'Supervisores e Coordenadores de departamento',
        floormanager: 'Encarregada de Andares',
        governancesupervisor: 'Supervisora de Governança',
        generalservicesassistant: 'Auxiliar de Serviços Gerais',
        laundryattendant: 'Atendente de Lavanderia',
        laundrymanager: 'Encarregada de Enxoval',
        machinist: 'Operador de Máquinas',
        ironer: 'Passador',
        electrician: 'Eletricista',
        carpenter: 'Marceneiro',
      },
      swagger:{
        title: 'Permissões do Swagger',
        subTitle:'Gerencie as permissões do Swagger por usuários das pluginSpaces',
        title_user: 'Permissões do Swagger para os usuários da pluginspace selecionada',
        subTitle_user: 'Aqui abaixo está a lista de usuários da pluginspace selecionada, juntamente com suas respectivas ações. Clique em "Gerenciar Permissões" para configurar as permissões do Swagger para cada usuário.',
      }
    },
  },
}

export {messages}
// hospitality_experiences block moved inside translations below
